import React, { useRef, useState, useEffect } from "react";
import { toast } from "react-toastify";
import Accordion from "react-bootstrap/Accordion";
import jwt_decode from "jwt-decode";
import { DatePicker, Space } from "antd";
import { Modal } from "react-bootstrap";
import Confetti from "react-confetti";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import RadioButton from "../Radio_button";
import Checkbox from "../Checkbox";
import Select from "../Select";
import Input from "../Input";
import Textarea from "../Textarea";
import { validateEmail, checkUrl } from "../../../utils";
import correct from "../../../assets/img/icons/correct.png";
import doneSvg from "../../../assets/img/icons/done02.svg";
import successful from "../../../assets/img/icons/successful.svg";
import circle from "../../../assets/assets_html/images/circle.png";
import roundplus from "../../../assets/assets_html/images/roundplus.png";
import tick from "../../../assets/assets_html/images/tick.png";
import vector from "../../../assets/assets_html/images/Vector.png";
import finger from "../../../assets/assets_html/images/finger.png";
import crossref from "../../../assets/img/icons/crossref.svg";
import launchOfferBand from "../../../assets/img/icons/Launch-Offer-Band.png";

import {
  FetchJournalDetails,
  FetchJournalByKeyWord,
  GetOrcidID,
  FetchSubjectSpecialization,
  FetchOfferById,
} from "../../../containers/autherFlow/submitArticle/queries";
import { editorTitleOptionsNew } from "../../../constants";
import {
  getProfileDetails,
  updateProfileDetails,
  getOtherSpecialization,
  UploadMedia,
  UploadMediaWithName,
} from "../../../store/apiCalls/profileDetails";
import { SAVE_SUBJECT_STATUS } from "../../../store/actions/profileActions";
import { GET_OTHER_SUBJECT } from "../../../store/actions/profileActions";
import alertSvg from "../../../assets/img/icons/alert_info.svg";
import OtherSubject from "../../OtherSubject/OtherSubject";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import {
  extractManuscriptXml,
  generatePdfFromXml,
  parseExtractorError,
} from "../../../services/extractorApi";
import { markDocumentUploadFailed as markDocUploadFailedApi } from "../../../store/apiCalls/articles";

import en from "antd/es/date-picker/locale/en_US";
import dayjs from "dayjs";
const buddhistLocale = {
  ...en,
  lang: {
    ...en.lang,
    fieldDateFormat: "YYYY-MM-DD",
    fieldDateTimeFormat: "YYYY-MM-DD HH:mm:ss",
    yearFormat: "YYYY",
    cellYearFormat: "YYYY",
  },
};

const mySubmission2 = (subjects, saveAndPay) => {
  const dispatch = useDispatch();
  const [isUploadingArticle, setIsUploadingArticle] = useState(false);
  const isSubmissionReadOnly =
    !!subjects?.isSubmissionReadOnly || isUploadingArticle;

  console.log(subjects);

  const [isJournalExist, setisJournalExist] = useState(0);
  const isJournalExistRef = useRef(isJournalExist);
  const reviewProcessScroll = useRef(null);
  const executeScrollds = () => reviewProcessScroll.current.scrollIntoView();
  isJournalExistRef.current = isJournalExist;
  const otherSubject = useSelector(
    (state) => state?.ProfileReducer?.otherSubject,
  );
  const sucessHandler = (journalDetails) => {
    if (journalDetails.status === 200) {
      const journalList = [];
      journalDetails.data.data.forEach((element) => {
        const data = { label: element.journalName, value: element._id };
        journalList.push(data);
      });

      setjournalMaster(journalList);
    }
  };
  const sucessGenralDetailsHandler = (journalDetails) => {
    if (journalDetails.status === 200) {
      const preVal = preValues;
      const details = journalDetails.data.data;
      const storeJournal = [];
      const storeJournalF = [];
      if (
        details.length > 0 &&
        preValues.journalType === journalTypes.society
      ) {
        const subjectDetl = [];
        const specialization = [];

        const choiceOfReview = [];
        const slugMapUpdate = {};
        details.forEach((element, k) => {
          storeJournal.push({ journalName: element.journalName });
          const subjectName =
            element.subjectData?.[0]?.subject?.subjectName || "";
          slugMapUpdate[element.journalName] = {
            slug: element.slug || "",
            subjectName,
          };
          choiceOfReview[element.journalName] = element.choiceOfReview;
          // Fallback: if subjectData is empty or has no valid subjects,
          // still set choiceOfReview for the matching journal.
          if (
            preVal?.journal === element.journalName &&
            !element.subjectData?.some((s) => s.subject)
          ) {
            const val = preValues;
            val.choiceOfReview = element.choiceOfReview;
            setpreValues({ ...val });
          }
          element.subjectData.forEach((subject, p) => {
            if (subject.subject) {
              const val = preValues;
              if (preVal?.journal === element.journalName) {
                val.subject = subject.subject.subjectName;
                val.subjectId = subject.subject._id;
                // Always set choiceOfReview for the matching journal,
                // regardless of whether it has specialization data.
                val.choiceOfReview = element.choiceOfReview;
              }
              const subj = {
                val: subject.subject.subjectName,
                key: subject.subject._id,
              };
              subjectDetl[element.journalName] = subj;
              if (subject.specialization && subject.specialization.length > 0) {
                const specNames = subject.specialization
                  .filter(
                    (s) => s && s.specialization && s.specialization.trim(),
                  )
                  .map((s) => s.specialization)
                  .join(" | ");
                const specIds = subject.specialization
                  .filter((s) => s && s._id)
                  .map((s) => s._id)
                  .join("|");
                const data = { key: specIds, value: specNames };
                specialization[element.journalName] = data;
              }
              if (preVal?.journal === element.journalName) {
                setpreValues({ ...val });
              }
            }
          });
        });
        setsocitySubjectDesp({
          subject: subjectDetl,
          descpline: specialization,
          review: choiceOfReview,
        });
        setjournalOptions(storeJournal);
        setjournalOptionsFirst(storeJournal);
        setJournalSlugMap((prev) => ({ ...prev, ...slugMapUpdate }));
      } else if (
        details.length > 0 &&
        preValues.journalType === journalTypes.mega
      ) {
        const storeJournalS = [];
        const specilizations = [];
        const subjects = [];
        const megaSlugMapUpdate = {};
        details.forEach((element, k) => {
          storeJournal.push({ journalName: element.journalName });
          megaSlugMapUpdate[element.journalName] = {
            slug: element.slug || element._id || "",
            subjectName: element.subjectData?.[0]?.subject?.subjectName || "",
          };
          if (preVal?.secondaryJournalName !== element.journalName)
            storeJournalF.push({ journalName: element.journalName });
          if (preVal?.journal !== element.journalName)
            storeJournalS.push({ journalName: element.journalName });
          const subjct = [];
          element.subjectData.forEach((subject, p) => {
            subjct.push({
              val: subject.subject.subjectName,
              key: subject.subject._id,
            });
            specilizations[subject.subject._id] = subject.specialization;

            if (preVal?.subjectId === subject.subject._id) {
              const subjectSpecialization = [];
              if (subject.specialization && subject.specialization.length > 0) {
                subject.specialization.forEach((element) => {
                  const data = {
                    key: element._id,
                    value: element.specialization,
                  };
                  subjectSpecialization.push(data);
                });
              }
            }
            if (preVal?.secondarySubject?._id === subject?.subject?._id) {
              const subjectSpecializations = [];
              if (subject.specialization && subject.specialization.length > 0) {
                subject.specialization.forEach((element) => {
                  const data = {
                    key: element._id,
                    value: element.specialization,
                  };
                  subjectSpecializations.push(data);
                });
              }
            }
          });
          if (preVal?.journal === element.journalName) {
            //setdescplineSubject(subjct);
          }
          if (preVal?.secondaryJournalName === element.journalName) {
            // setdescplineSubjectSec(subjct);
          }
          subjects[element.journalName] = subjct;
        });
        setjournalOptions(storeJournal);
        setjournalOptionsFirst(storeJournalF);
        setjournalOptionsSecondry(storeJournalS);
        setjournalOptions(storeJournal);
        setJournalSlugMap((prev) => ({ ...prev, ...megaSlugMapUpdate }));
      } else {
        setsocityJournalDetails([{ societyName: "", relatedData: [] }]);
      }
    }
  };
  const sucessSubjectSpecialization = (details) => {
    if (details.status === 200) {
      const data = details.data.data;
      const pr = preValues;
      let selcteSpeId = "";
      let selcteSpe = "";
      if (preValues.journal === data.data[0].journalName) {
        const subject = [];
        data.data.forEach((element) => {
          const SubjectData = {
            key: element._id,
            val: element.subjectName,
          };
          subject.push(SubjectData);
        });

        const subjectSpecialization = [];
        const specializationM = [];
        const singleSub = [];
        data.specilisation.forEach((ele, k) => {
          const spe = [];
          if (ele?.specialization) {
            const sp = { key: ele._id, value: ele.specialization };
            subjectSpecialization.push(sp);
            const subId = data.data[0]?._id;
            singleSub.push(ele);
            if (subId && k === data.specilisation.length - 1)
              specializationM[subId] = singleSub;
          } else {
            ele.forEach((el, p) => {
              if (k === 0 && isJournalExistRef.current !== 2) {
                const sp = { key: el._id, value: el.specialization };
                subjectSpecialization.push(sp);
              } else if (
                isJournalExistRef.current === 2 &&
                preValues.subjectId === el.subjectId
              ) {
                const sp = { key: el._id, value: el.specialization };
                subjectSpecialization.push(sp);
              }
              spe.push(el);
            });
            const subId = data.data[k]?._id;

            specializationM[subId] = spe;
          }
        });

        setspecializationMaster(specializationM);
        setspecialization(subjectSpecialization);
        setdescplineSubject(subject);
        if (isJournalExistRef.current !== 2) {
          pr.subject = data.data[0].subjectName;
          pr.subjectId = data.data[0]._id;
        } else if (isJournalExistRef.current === 2) {
          if (preValues.subjectId === data.data[0]._id)
            pr.subject = data.data[0].subjectName;
          setpreValues({ ...pr });
        }
      } else if (preValues.secondaryJournalName === data.data[0].journalName) {
        const subject = [];
        data.data.forEach((element) => {
          const SubjectData = {
            key: element._id,
            val: element.subjectName,
          };
          subject.push(SubjectData);
        });
        const subjectSpecialization = [];
        const specializationM = [];
        const singleSub = [];
        data.specilisation.forEach((ele, k) => {
          const spe = [];
          if (ele?.specialization) {
            if (k === 0) {
              selcteSpeId = ele._id;
              selcteSpe = ele.specialization;
            }

            const sp = { key: ele._id, value: ele.specialization };
            subjectSpecialization.push(sp);
            const subId = data.data[0]?._id;
            singleSub.push(ele);
            if (subId && k === data.specilisation.length - 1)
              specializationM[subId] = singleSub;
          } else {
            ele.forEach((el, p) => {
              if (k === 0 && p === 0) {
                selcteSpeId = el._id;
                selcteSpe = el.specialization;
              }

              if (k === 0 && isJournalExistRef.current !== 2) {
                const sp = { key: el._id, value: el.specialization };
                subjectSpecialization.push(sp);
              } else if (
                isJournalExistRef.current === 2 &&
                preValues.secondarySubject._id === el.subjectId
              ) {
                const sp = { key: el._id, value: el.specialization };
                subjectSpecialization.push(sp);
              }

              spe.push(el);
            });
            const subId = data.data[k]?._id;
            specializationM[subId] = spe;
          }
        });

        setspecializationSecMaster(specializationM);
        setsecondrySpecialization(subjectSpecialization);
        setdescplineSubjectSec(subject);

        if (isJournalExistRef.current !== 2) {
          pr.secondarySubjectName = data.data[0].subjectName;
          pr.secondarySubject._id = data.data[0]._id;
        } else if (isJournalExistRef.current === 2) {
          if (preValues.secondarySubject?._id === data.data[0]._id)
            pr.secondarySubjectName = data.data[0].subjectName;
          setpreValues({ ...pr });
        }
      }

      if (isJournalExistRef.current !== 2) setpreValues({ ...pr });
    }
  };

  function getSubjectSpecialization(journalName) {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const queryParams = {
      params: { journalName: journalName },
      headers: headers,
    };
    if (journalName) getJournalSubjects(queryParams);
    else dispatch({ type: "SET_LOADER", payload: false });
  }

  const { mutate: getJournalSubjects } = FetchSubjectSpecialization(
    sucessSubjectSpecialization,
  );
  const sucessOrcidID = (orcid) => {
    if (orcid.status === 200) {
      const OrcidId = orcid.data.orcid;
      updateOrcidIdInProfile(OrcidId);
    }
  };

  const { mutate: getJournal } = FetchJournalByKeyWord(sucessHandler);
  const { mutate: getJournalDetails } = FetchJournalDetails(
    sucessGenralDetailsHandler,
  );
  const { mutate: getOrcidID } = GetOrcidID(sucessOrcidID);

  const sucessHandlerCoupon = (details) => {
    if (details.status === 200) {
      const detail = details.data.data;
      if (detail?._id) {
        // Validation: The coupon code should be of society and not mega
        const isMegaJournal =
          preValues.journalType === "6454a6390d88e62fa10503be";
        if (detail?.megaJournalType && !isMegaJournal) {
          setIsCouponApplied(false);
          return toast.error(
            "This coupon is for a Mega Journal and cannot be used here.",
          );
        }
        // Validation: If article is a society journal, coupon's societyJournalType must match
        const societyJournalID = "6454a6390d88e62fa10503bf";
        const isSocietyJournal = preValues.journalType === societyJournalID;
        if (isSocietyJournal) {
          const journalName = preValues.journal;
          if (
            !detail?.societyJournalType ||
            (detail.societyJournalType !== "All" &&
              journalName !== "All" &&
              detail.societyJournalType !== journalName)
          ) {
            setIsCouponApplied(false);
            return toast.error(
              `This coupon is not valid for "${journalName}". Please use a coupon issued for this society journal.`,
            );
          }
        }
        setIsCouponApplied(true);
        setpreValues((prev) => ({
          ...prev,
          validCouponCode: detail,
          paymentBySociety: {
            ...prev.paymentBySociety,
            apcPayBySociety: apcPaymentOption === "society",
          },
        }));
      } else {
        setIsCouponApplied(false);
        toast.error("coupon code is invalid");
      }
    }
  };

  const { mutate: validateCouponCode } = FetchOfferById(sucessHandlerCoupon);

  const handleApplyNow = () => {
    if (isSubmissionReadOnly) return;

    if (
      preValues.journal === "" ||
      preValues.subjectId === "" ||
      (preValues.articleType === "" &&
        subjects.completedTabs.mySubmission === false)
    ) {
      toast.error("Please fill all the mandatory fields first.");
      return;
    }

    if (couponCode.trim() !== "") {
      const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
      const queryParams = {
        params: { offerCode: couponCode.trim() },
        headers: headers,
      };
      validateCouponCode(queryParams);
    } else {
      toast.error("Please enter coupon code");
    }
  };
  const [ProfileDetails, setProfileDetails] = useState({});
  const [journalSlugMap, setJournalSlugMap] = useState({});

  const formatUrl = (inputString) => {
    if (!inputString) return "";
    return inputString.toLowerCase().replace(/\s/g, "-");
  };

  const megaJournalSlugMap = {
    "Samaj Shastra \u2013 The Mega Journal of Social Sciences":
      "social-sciences",
    "Chanakya Shastra \u2013 The Mega Journal of Business and Management":
      "business-management",
    "Charakh Shastra \u2013 The Mega Journal of Medicine": "medicine",
    "Abhiyantran Shastra \u2013 The Mega Journal of Engineering": "engineering",
    "Soochna Shastra \u2013 The Mega Journal of Information Technology":
      "information-technology",
    "Vigyan Shastra \u2013 The Mega Journal of Sciences": "sciences",
    "AyurYoga Shastra \u2013 The Mega Journal of Ayurveda and Yoga":
      "ayurveda-and-yoga",
  };

  const getJournalUrl = () => {
    const journalName = preValues.journal;
    if (!journalName) return "#";
    if (isSocityJournal) {
      const info = journalSlugMap[journalName];
      if (!info) return "#";
      return `/society-journals/${formatUrl(info.subjectName)}/${info.slug}`;
    }
    // Mega journal: use the hardcoded short-slug mapping
    const megaSlug = megaJournalSlugMap[journalName];
    return megaSlug ? `/mega-journals/${megaSlug}` : "#";
  };
  const [specializationMaster, setspecializationMaster] = useState([]);
  const [specializationSecMaster, setspecializationSecMaster] = useState([]);
  const [specialization, setspecialization] = useState([]);
  const [articleTypeListwconf, setarticleTypeListwconf] = useState([]);
  const [articleTypeListwoutconf, setarticleTypeListwoutconf] = useState([]);
  const [articleTypeListf, setarticleTypeListf] = useState([]);
  const [descplineSubject, setdescplineSubject] = useState([]);

  const [descplineSubjectSec, setdescplineSubjectSec] = useState([]);
  const [countrylist, setcountrylist] = useState([
    { name: "Afghanistan", code: "AF" },
    { name: "Åland Islands", code: "AX" },
    { name: "Albania", code: "AL" },
    { name: "Algeria", code: "DZ" },
    { name: "American Samoa", code: "AS" },
    { name: "AndorrA", code: "AD" },
    { name: "Angola", code: "AO" },
    { name: "Anguilla", code: "AI" },
    { name: "Antarctica", code: "AQ" },
    { name: "Antigua and Barbuda", code: "AG" },
    { name: "Argentina", code: "AR" },
    { name: "Armenia", code: "AM" },
    { name: "Aruba", code: "AW" },
    { name: "Australia", code: "AU" },
    { name: "Austria", code: "AT" },
    { name: "Azerbaijan", code: "AZ" },
    { name: "Bahamas", code: "BS" },
    { name: "Bahrain", code: "BH" },
    { name: "Bangladesh", code: "BD" },
    { name: "Barbados", code: "BB" },
    { name: "Belarus", code: "BY" },
    { name: "Belgium", code: "BE" },
    { name: "Belize", code: "BZ" },
    { name: "Benin", code: "BJ" },
    { name: "Bermuda", code: "BM" },
    { name: "Bhutan", code: "BT" },
    { name: "Bolivia", code: "BO" },
    { name: "Bosnia and Herzegovina", code: "BA" },
    { name: "Botswana", code: "BW" },
    { name: "Bouvet Island", code: "BV" },
    { name: "Brazil", code: "BR" },
    { name: "British Indian Ocean Territory", code: "IO" },
    { name: "Brunei Darussalam", code: "BN" },
    { name: "Bulgaria", code: "BG" },
    { name: "Burkina Faso", code: "BF" },
    { name: "Burundi", code: "BI" },
    { name: "Cambodia", code: "KH" },
    { name: "Cameroon", code: "CM" },
    { name: "Canada", code: "CA" },
    { name: "Cape Verde", code: "CV" },
    { name: "Cayman Islands", code: "KY" },
    { name: "Central African Republic", code: "CF" },
    { name: "Chad", code: "TD" },
    { name: "Chile", code: "CL" },
    { name: "China", code: "CN" },
    { name: "Christmas Island", code: "CX" },
    { name: "Cocos (Keeling) Islands", code: "CC" },
    { name: "Colombia", code: "CO" },
    { name: "Comoros", code: "KM" },
    { name: "Congo", code: "CG" },
    { name: "Congo, The Democratic Republic of the", code: "CD" },
    { name: "Cook Islands", code: "CK" },
    { name: "Costa Rica", code: "CR" },
    { name: "Cote D'Ivoire", code: "CI" },
    { name: "Croatia", code: "HR" },
    { name: "Cuba", code: "CU" },
    { name: "Cyprus", code: "CY" },
    { name: "Czech Republic", code: "CZ" },
    { name: "Denmark", code: "DK" },
    { name: "Djibouti", code: "DJ" },
    { name: "Dominica", code: "DM" },
    { name: "Dominican Republic", code: "DO" },
    { name: "Ecuador", code: "EC" },
    { name: "Egypt", code: "EG" },
    { name: "El Salvador", code: "SV" },
    { name: "Equatorial Guinea", code: "GQ" },
    { name: "Eritrea", code: "ER" },
    { name: "Estonia", code: "EE" },
    { name: "Ethiopia", code: "ET" },
    { name: "Falkland Islands (Malvinas)", code: "FK" },
    { name: "Faroe Islands", code: "FO" },
    { name: "Fiji", code: "FJ" },
    { name: "Finland", code: "FI" },
    { name: "France", code: "FR" },
    { name: "French Guiana", code: "GF" },
    { name: "French Polynesia", code: "PF" },
    { name: "French Southern Territories", code: "TF" },
    { name: "Gabon", code: "GA" },
    { name: "Gambia", code: "GM" },
    { name: "Georgia", code: "GE" },
    { name: "Germany", code: "DE" },
    { name: "Ghana", code: "GH" },
    { name: "Gibraltar", code: "GI" },
    { name: "Greece", code: "GR" },
    { name: "Greenland", code: "GL" },
    { name: "Grenada", code: "GD" },
    { name: "Guadeloupe", code: "GP" },
    { name: "Guam", code: "GU" },
    { name: "Guatemala", code: "GT" },
    { name: "Guernsey", code: "GG" },
    { name: "Guinea", code: "GN" },
    { name: "Guinea-Bissau", code: "GW" },
    { name: "Guyana", code: "GY" },
    { name: "Haiti", code: "HT" },
    { name: "Heard Island and Mcdonald Islands", code: "HM" },
    { name: "Holy See (Vatican City State)", code: "VA" },
    { name: "Honduras", code: "HN" },
    { name: "Hong Kong", code: "HK" },
    { name: "Hungary", code: "HU" },
    { name: "Iceland", code: "IS" },
    { name: "India", code: "IN" },
    { name: "Indonesia", code: "ID" },
    { name: "Iran, Islamic Republic Of", code: "IR" },
    { name: "Iraq", code: "IQ" },
    { name: "Ireland", code: "IE" },
    { name: "Isle of Man", code: "IM" },
    { name: "Israel", code: "IL" },
    { name: "Italy", code: "IT" },
    { name: "Jamaica", code: "JM" },
    { name: "Japan", code: "JP" },
    { name: "Jersey", code: "JE" },
    { name: "Jordan", code: "JO" },
    { name: "Kazakhstan", code: "KZ" },
    { name: "Kenya", code: "KE" },
    { name: "Kiribati", code: "KI" },
    { name: "Korea, Democratic People'S Republic of", code: "KP" },
    { name: "Korea, Republic of", code: "KR" },
    { name: "Kuwait", code: "KW" },
    { name: "Kyrgyzstan", code: "KG" },
    { name: "Lao People'S Democratic Republic", code: "LA" },
    { name: "Latvia", code: "LV" },
    { name: "Lebanon", code: "LB" },
    { name: "Lesotho", code: "LS" },
    { name: "Liberia", code: "LR" },
    { name: "Libyan Arab Jamahiriya", code: "LY" },
    { name: "Liechtenstein", code: "LI" },
    { name: "Lithuania", code: "LT" },
    { name: "Luxembourg", code: "LU" },
    { name: "Macao", code: "MO" },
    { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
    { name: "Madagascar", code: "MG" },
    { name: "Malawi", code: "MW" },
    { name: "Malaysia", code: "MY" },
    { name: "Maldives", code: "MV" },
    { name: "Mali", code: "ML" },
    { name: "Malta", code: "MT" },
    { name: "Marshall Islands", code: "MH" },
    { name: "Martinique", code: "MQ" },
    { name: "Mauritania", code: "MR" },
    { name: "Mauritius", code: "MU" },
    { name: "Mayotte", code: "YT" },
    { name: "Mexico", code: "MX" },
    { name: "Micronesia, Federated States of", code: "FM" },
    { name: "Moldova, Republic of", code: "MD" },
    { name: "Monaco", code: "MC" },
    { name: "Mongolia", code: "MN" },
    { name: "Montserrat", code: "MS" },
    { name: "Morocco", code: "MA" },
    { name: "Mozambique", code: "MZ" },
    { name: "Myanmar", code: "MM" },
    { name: "Namibia", code: "NA" },
    { name: "Nauru", code: "NR" },
    { name: "Nepal", code: "NP" },
    { name: "Netherlands", code: "NL" },
    { name: "Netherlands Antilles", code: "AN" },
    { name: "New Caledonia", code: "NC" },
    { name: "New Zealand", code: "NZ" },
    { name: "Nicaragua", code: "NI" },
    { name: "Niger", code: "NE" },
    { name: "Nigeria", code: "NG" },
    { name: "Niue", code: "NU" },
    { name: "Norfolk Island", code: "NF" },
    { name: "Northern Mariana Islands", code: "MP" },
    { name: "Norway", code: "NO" },
    { name: "Oman", code: "OM" },
    { name: "Pakistan", code: "PK" },
    { name: "Palau", code: "PW" },
    { name: "Palestinian Territory, Occupied", code: "PS" },
    { name: "Panama", code: "PA" },
    { name: "Papua New Guinea", code: "PG" },
    { name: "Paraguay", code: "PY" },
    { name: "Peru", code: "PE" },
    { name: "Philippines", code: "PH" },
    { name: "Pitcairn", code: "PN" },
    { name: "Poland", code: "PL" },
    { name: "Portugal", code: "PT" },
    { name: "Puerto Rico", code: "PR" },
    { name: "Qatar", code: "QA" },
    { name: "Reunion", code: "RE" },
    { name: "Romania", code: "RO" },
    { name: "Russian Federation", code: "RU" },
    { name: "RWANDA", code: "RW" },
    { name: "Saint Helena", code: "SH" },
    { name: "Saint Kitts and Nevis", code: "KN" },
    { name: "Saint Lucia", code: "LC" },
    { name: "Saint Pierre and Miquelon", code: "PM" },
    { name: "Saint Vincent and the Grenadines", code: "VC" },
    { name: "Samoa", code: "WS" },
    { name: "San Marino", code: "SM" },
    { name: "Sao Tome and Principe", code: "ST" },
    { name: "Saudi Arabia", code: "SA" },
    { name: "Senegal", code: "SN" },
    { name: "Serbia and Montenegro", code: "CS" },
    { name: "Seychelles", code: "SC" },
    { name: "Sierra Leone", code: "SL" },
    { name: "Singapore", code: "SG" },
    { name: "Slovakia", code: "SK" },
    { name: "Slovenia", code: "SI" },
    { name: "Solomon Islands", code: "SB" },
    { name: "Somalia", code: "SO" },
    { name: "South Africa", code: "ZA" },
    { name: "South Georgia and the South Sandwich Islands", code: "GS" },
    { name: "Spain", code: "ES" },
    { name: "Sri Lanka", code: "LK" },
    { name: "Sudan", code: "SD" },
    { name: "Suriname", code: "SR" },
    { name: "Svalbard and Jan Mayen", code: "SJ" },
    { name: "Swaziland", code: "SZ" },
    { name: "Sweden", code: "SE" },
    { name: "Switzerland", code: "CH" },
    { name: "Syrian Arab Republic", code: "SY" },
    { name: "Taiwan, Province of China", code: "TW" },
    { name: "Tajikistan", code: "TJ" },
    { name: "Tanzania, United Republic of", code: "TZ" },
    { name: "Thailand", code: "TH" },
    { name: "Timor-Leste", code: "TL" },
    { name: "Togo", code: "TG" },
    { name: "Tokelau", code: "TK" },
    { name: "Tonga", code: "TO" },
    { name: "Trinidad and Tobago", code: "TT" },
    { name: "Tunisia", code: "TN" },
    { name: "Turkey", code: "TR" },
    { name: "Turkmenistan", code: "TM" },
    { name: "Turks and Caicos Islands", code: "TC" },
    { name: "Tuvalu", code: "TV" },
    { name: "Uganda", code: "UG" },
    { name: "Ukraine", code: "UA" },
    { name: "United Arab Emirates", code: "AE" },
    { name: "United Kingdom", code: "GB" },
    { name: "United States", code: "US" },
    { name: "United States Minor Outlying Islands", code: "UM" },
    { name: "Uruguay", code: "UY" },
    { name: "Uzbekistan", code: "UZ" },
    { name: "Vanuatu", code: "VU" },
    { name: "Venezuela", code: "VE" },
    { name: "Viet Nam", code: "VN" },
    { name: "Virgin Islands, British", code: "VG" },
    { name: "Virgin Islands, U.S.", code: "VI" },
    { name: "Wallis and Futuna", code: "WF" },
    { name: "Western Sahara", code: "EH" },
    { name: "Yemen", code: "YE" },
    { name: "Zambia", code: "ZM" },
    { name: "Zimbabwe", code: "ZW" },
  ]);
  const otherSubjectTitle =
    "Other Subject (choose this option to register your subject)";
  const [secondrySpecialization, setsecondrySpecialization] = useState([]);
  const journalTypes = {
    society: "6454a6390d88e62fa10503bf",
    mega: "6454a6390d88e62fa10503be",
    yogaJournal: "AyurYoga – The Mega Journal of Ayurveda and Yoga",
  };
  const [showMaterialPolicy, setShowMaterialPolicy] = useState(false);
  const [incompleteInfoPopup, setincompleteInfoPopup] = useState(false);
  const [createcitationPopup, setcreatecitationPopup] = useState(false);
  const [citationGeneratedPopup, setcitationGeneratedPopup] = useState(false);
  const [needHelpPopup, setneedHelpPopup] = useState(false);
  const [isSocityJournal, setisSocityJournal] = useState(false);
  const [apcPaymentOption, setApcPaymentOption] = useState("");
  const [showApcInfo, setShowApcInfo] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [isCouponApplied, setIsCouponApplied] = useState(false);
  const [showSocietyFundedInfo, setShowSocietyFundedInfo] = useState(false);
  const [articleTypeDesc, setarticleTypeDesc] = useState({
    name: "",
    desc: "",
    wordCount: "",
  });
  const [socityJournalDetails, setsocityJournalDetails] = useState([
    { societyName: "", relatedData: [] },
  ]);
  const [socitySubjectDesp, setsocitySubjectDesp] = useState({
    subject: [],
    descpline: [],
    review: [],
  });
  const [authorCount, setauthorCount] = useState([0]);
  const [APCData, setAPCData] = useState([]);
  const [popupError, setpopupError] = useState("");
  const [popupTitle, setpopupTitle] = useState("Author Contribution Statement");
  const [showSaveSuccessModal, setShowSaveSuccessModal] = useState(false);
  const location = useLocation();
  const [showCelebrationModal, setShowCelebrationModal] = useState(false);
  const [showUploadArticleModal, setShowUploadArticleModal] = useState(false);
  const [showPreviouslySubmittedModal, setShowPreviouslySubmittedModal] =
    useState(false);
  const [showMegaGuidelineModal, setShowMegaGuidelineModal] = useState(false);
  const [showNoFiguresModal, setShowNoFiguresModal] = useState(false);


  const isSocietyArticle = () => {
    const editedDetail = subjects?.preStepData;
    const getValId = (val) => {
      if (!val) return "";
      if (typeof val === "string") return val;
      return val._id || val.key || val.id || "";
    };
    return Boolean(
      isSocityJournal ||
      getValId(editedDetail?.submissionDetail?.journalType) === journalTypes.society ||
      editedDetail?.submissionDetail?.journalType?.journalType === "Society Journal" ||
      editedDetail?.journalType === "Society Journal" ||
      editedDetail?.journalType === journalTypes.society ||
      editedDetail?.journaldstype === "societyArticle" ||
      editedDetail?.paymentBySociety?.apcPayBySociety === true
    );
  };

  useEffect(() => {
    if (isSocietyArticle()) {
      sessionStorage.removeItem("reupload_article_triggered");
      setShowUploadArticleModal(false);
      return;
    }
    if (
      location?.state?.openUploadModal ||
      sessionStorage.getItem("reupload_article_triggered") === "true"
    ) {
      setShowUploadArticleModal(true);
      sessionStorage.removeItem("reupload_article_triggered");
    }
  }, [location?.state, subjects?.preStepData, isSocityJournal]);
  const [selectedUploadType, setSelectedUploadType] = useState("");
  const [uploadFile, setUploadFile] = useState(null);
  const [imageList, setImageList] = useState([]);
  const [supplementaryList, setSupplementaryList] = useState([]);
  const [uploadStatusMessage, setUploadStatusMessage] = useState("");
  const [uploadErrorMessage, setUploadErrorMessage] = useState("");
  const imageInputRef = useRef(null);
  const documentInputRef = useRef(null);
  const supplementaryInputRef = useRef(null);

  const ALLOWED_SUPPLEMENTARY_EXTENSIONS = [
    "pdf",
    "doc",
    "docx",
    "xls",
    "xlsx",
    "jpg",
    "jpeg",
    "png",
  ];

  const handleAddSupplementaryFiles = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const selectedFiles = Array.from(e.target.files);
      const invalidFiles = selectedFiles.filter((file) => {
        const ext = file.name.split(".").pop()?.toLowerCase();
        return !ALLOWED_SUPPLEMENTARY_EXTENSIONS.includes(ext);
      });

      if (invalidFiles.length > 0) {
        toast.error(
          "Only PDF, WORD, EXCEL, and JPG/PNG formats are allowed for Supplementary Material.",
        );
        e.target.value = null;
        return;
      }

      const newItems = selectedFiles.map((file, idx) => ({
        id:
          Date.now() +
          "_" +
          idx +
          "_" +
          Math.random().toString(36).substr(2, 4),
        file,
        name: file.name,
        size: file.size,
      }));
      setSupplementaryList((prev) => [...prev, ...newItems]);
      e.target.value = null;
    }
  };

  const handleRemoveSupplementaryFile = (id) => {
    setSupplementaryList((prev) => prev.filter((item) => item.id !== id));
  };

  const handleAddImages = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const newItems = Array.from(e.target.files).map((file, idx) => ({
        id:
          Date.now() +
          "_" +
          idx +
          "_" +
          Math.random().toString(36).substr(2, 4),
        file,
        title: file.name,
      }));
      setImageList((prev) => [...prev, ...newItems]);
      e.target.value = null;
    }
  };

  const handleUpdateImageTitle = (id, newTitle) => {
    setImageList((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, title: newTitle } : item,
      ),
    );
  };

  const handleRemoveImage = (id) => {
    setImageList((prev) => prev.filter((item) => item.id !== id));
  };

  const extractAndUploadPdfImages = async (pdfFile, uploadMediaFn) => {
    try {
      if (typeof window.pdfjsLib === "undefined") {
        await new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src =
            "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
          script.onload = () => resolve();
          script.onerror = () =>
            reject(new Error("Failed to load PDF.js script"));
          document.head.appendChild(script);
        });
      }

      const pdfjsLib = window.pdfjsLib;
      pdfjsLib.GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

      const arrayBuffer = await pdfFile.arrayBuffer();
      const pdfDoc = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

      const extractedImageUrls = [];
      const imageMap = {};
      let imageCounter = 1;

      for (let pageNum = 1; pageNum <= pdfDoc.numPages; pageNum++) {
        const page = await pdfDoc.getPage(pageNum);
        const ops = await page.getOperatorList();

        for (let i = 0; i < ops.fnArray.length; i++) {
          if (
            ops.fnArray[i] === pdfjsLib.OPS.paintImageXObject ||
            ops.fnArray[i] === pdfjsLib.OPS.paintInlineImageXObject
          ) {
            const imgName = ops.argsArray[i][0];
            let imgObj;
            try {
              imgObj = page.objs.get(imgName);
            } catch (e) {
              continue;
            }

            if (
              !imgObj ||
              !imgObj.width ||
              !imgObj.height ||
              imgObj.width < 50 ||
              imgObj.height < 50
            ) {
              continue;
            }

            const canvas = document.createElement("canvas");
            canvas.width = imgObj.width;
            canvas.height = imgObj.height;
            const ctx = canvas.getContext("2d");

            const imgData = ctx.createImageData(imgObj.width, imgObj.height);
            const data = imgObj.data;

            if (data.length === imgObj.width * imgObj.height * 4) {
              imgData.data.set(data);
            } else if (data.length === imgObj.width * imgObj.height * 3) {
              let j = 0;
              for (let k = 0; k < data.length; k += 3) {
                imgData.data[j] = data[k];
                imgData.data[j + 1] = data[k + 1];
                imgData.data[j + 2] = data[k + 2];
                imgData.data[j + 3] = 255;
                j += 4;
              }
            } else {
              continue;
            }

            ctx.putImageData(imgData, 0, 0);

            const blob = await new Promise((res) =>
              canvas.toBlob(res, "image/png"),
            );
            if (!blob) continue;

            const figFilename = `fig${imageCounter}.png`;
            const file = new File([blob], figFilename, { type: "image/png" });

            const formData = new FormData();
            formData.append("file", file);

            const imgResp = await uploadMediaFn(formData);
            if (imgResp && imgResp.data && imgResp.data.url) {
              const cdnUrl = imgResp.data.url;
              extractedImageUrls.push(cdnUrl);
              imageMap[figFilename] = cdnUrl;
              imageMap[`figure${imageCounter}.png`] = cdnUrl;
              imageMap[`fig${imageCounter}`] = cdnUrl;
              imageMap[`figure${imageCounter}`] = cdnUrl;
              imageCounter++;
            }
          }
        }
      }

      return { extractedImageUrls, imageMap };
    } catch (err) {
      console.error("extractAndUploadPdfImages error:", err);
      return { extractedImageUrls: [], imageMap: {} };
    }
  };

  const handleUploadArticleSubmit = async () => {
    if (!uploadFile) {
      toast.error("Please select a manuscript document file to upload.");
      return;
    }
    setIsUploadingArticle(true);
    setUploadErrorMessage("");
    try {
      // Step 1: Upload attached images (if any) and build image_map JSON object
      const imageMap = {};
      const uploadedImageUrls = [];
      if (imageList && imageList.length > 0) {
        for (let i = 0; i < imageList.length; i++) {
          const item = imageList[i];
          const formData = new FormData();
          formData.append("file", item.file);
          const imgResp = await UploadMedia(formData);
          if (imgResp && imgResp.data && imgResp.data.url) {
            const key =
              item.title && item.title.trim()
                ? item.title.trim()
                : item.file.name;
            imageMap[key] = imgResp.data.url;
            uploadedImageUrls.push(imgResp.data.url);
          }
        }
      }

      // Step 1.2: Upload attached supplementary material (if any)
      const uploadedSupplementaryUrls = [];
      if (supplementaryList && supplementaryList.length > 0) {
        for (let i = 0; i < supplementaryList.length; i++) {
          const item = supplementaryList[i];
          const formData = new FormData();
          formData.append("file", item.file);
          const fname = `${Date.now()}_${item.file.name}`;
          const uploadResp = await UploadMediaWithName(
            formData,
            `?fileName=${fname}`,
          );
          if (uploadResp && uploadResp.data && uploadResp.data.url) {
            uploadedSupplementaryUrls.push(uploadResp.data.url);
          } else {
            console.error("Failed to upload supplementary file:", item.file.name);
          }
        }
      }

      // Step 1.5: Automatically extract embedded images from manuscript PDF & upload to DigitalOcean Space via UploadMedia API
      if (
        uploadFile &&
        (uploadFile.type === "application/pdf" ||
          uploadFile.name.endsWith(".pdf"))
      ) {
        try {
          const pdfExtracted = await extractAndUploadPdfImages(
            uploadFile,
            UploadMedia,
          );
          if (
            pdfExtracted &&
            pdfExtracted.extractedImageUrls &&
            pdfExtracted.extractedImageUrls.length > 0
          ) {
            Object.assign(imageMap, pdfExtracted.imageMap || {});
            pdfExtracted.extractedImageUrls.forEach((url) => {
              if (!uploadedImageUrls.includes(url)) {
                uploadedImageUrls.push(url);
              }
            });
          }
        } catch (pdfErr) {
          console.error("PDF image extraction and upload error:", pdfErr);
        }
      }

      // Step 2: Extract JATS XML from uploaded document
      const xmlData = await extractManuscriptXml(uploadFile);

      // Save XML string to session storage
      try {
        sessionStorage.setItem(
          "articleXmlFormat",
          typeof xmlData === "string" ? xmlData : String(xmlData),
        );
      } catch (e) { }

      // Save extracted XML format into database as 'articleXmlFormat' key and validate mandatory UGC sections BEFORE calling generate_pdf API
      if (subjects && typeof subjects.onPdfGenerated === "function") {
        const valResult = await subjects.onPdfGenerated(
          "",
          null,
          xmlData,
          uploadedImageUrls,
          uploadedSupplementaryUrls,
        );
        if (valResult === false) {
          setIsUploadingArticle(false);
          // Keep Upload Article modal open so user stays on the article upload page
          return;
        }
      }

      // Step 3: Generate PDF using XML and imageMap
      const pdfBlob = await generatePdfFromXml(xmlData, imageMap);

      // Step 4: Create PDF URL and save to session
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const articleId =
        subjects?.preStepData?._id || subjects?.preStepData?.id || "current";

      try {
        sessionStorage.setItem(`generated_pdf_url_${articleId}`, pdfUrl);
        const reader = new FileReader();
        reader.readAsDataURL(pdfBlob);
        reader.onloadend = () => {
          try {
            sessionStorage.setItem(
              `generated_pdf_data_${articleId}`,
              reader.result,
            );
          } catch (e) {
            console.error("sessionStorage setItem error:", e);
          }
        };
      } catch (e) {
        console.error("Error storing PDF in session storage:", e);
      }

      let genResult = null;
      if (subjects && typeof subjects.onPdfGenerated === "function") {
        genResult = await subjects.onPdfGenerated(
          pdfUrl,
          pdfBlob,
          xmlData,
          uploadedImageUrls,
          uploadedSupplementaryUrls,
        );
        if (genResult === false) {
          setIsUploadingArticle(false);
          return;
        }
      }

      toast.success("Article Review successful!");
      setUploadErrorMessage("");
      setShowUploadArticleModal(false);
      setSelectedUploadType("");
      setUploadFile(null);
      setImageList([]);
      setSupplementaryList([]);

      if (subjects && typeof subjects.onContinueToEditor === "function") {
        const targetId =
          genResult && typeof genResult === "string"
            ? genResult
            : genResult?.articleId || "";
        subjects.onContinueToEditor(targetId);
      } else {
        setdefaultActiveKey("6");
      }
    } catch (error) {
      console.error("Upload/Extraction error:", error);
      const friendlyMessage = parseExtractorError(error);
      setUploadErrorMessage(friendlyMessage);
      toast.error(friendlyMessage);

      try {
        const articleId =
          subjects?.preStepData?._id ||
          subjects?.preStepData?.id ||
          subjects?.articleContent?.id;
        let currentUserId = "";
        try {
          if (localStorage?.usertoken) {
            const decoded = jwt_decode(localStorage.usertoken);
            currentUserId = decoded?.id || decoded?._id || "";
          }
        } catch (err) { }
        if (!currentUserId) {
          currentUserId = localStorage?.userId || localStorage?.userid || "";
        }

        const headersData = {
          Authorization: `Bearer ${localStorage?.usertoken}`,
        };
        const payloadData = {
          articleId,
          userId: currentUserId,
          title:
            "Please upload the article manuscript here to complete the submission process",
          submissionDetail:
            subjects?.preStepData?.submissionDetail ||
            subjects?.articleContent?.submissionDetail ||
            {},
        };
        const res = await markDocUploadFailedApi({
          payload: payloadData,
          headers: headersData,
        });
        console.log(
          "Article marked/created as documentUploadFailed (extraction):",
          res?.data,
        );
      } catch (e) {
        console.error("Error marking document upload failed (extraction):", e);
      }
    } finally {
      setIsUploadingArticle(false);
      setUploadStatusMessage("");
    }
  };
  const [defaultActiveKey, setdefaultActiveKey] = useState("0");
  const [other, setOther] = useState({
    show: false,
    specialization: "",
    disabled: true,
  });
  const [subjectApproval, setsubjectApproval] = useState(false);
  const [showSubject, setShowSubject] = useState(false);
  const [authorContent, setauthorContent] = useState({
    authorTitle: [{ val: "" }],
    authorname: [{ val: "" }],
    authorEmail: [{ val: "" }],
    authorUniversity: [{ val: "" }],
    authorDepartment: [{ val: "" }],
    authorOrcidID: [{ val: "" }],
    contributionStatement: "",
    isMePrimaryAuthor: true,
  });
  const [authorError, setauthorError] = useState({
    authorTitleError: [],
    authornameError: [],
    authorEmailError: [],
    authorUniversityError: [],
    authorDepartmentError: [],
    contributionStatementError: "",
  });
  const [fundingCount, setfundingCount] = useState([0]);
  const [fundingDetails, setfundingDetails] = useState({
    name: [{ val: "" }],
    email: [{ val: "" }],
    phone: [{ val: "" }],
    fundingAgency: [{ val: "" }],
    fundingAgencyUrl: [{ val: "" }],
    grantAmount: [{ val: "" }],
    fundingInformation: "",
    noFundingRecevied: false,
  });
  const [fundingDetailsError, setfundingDetailsError] = useState({
    nameError: [],
    emailError: [],
    phoneError: [],
    fundingAgencyError: [],
    fundingAgencyUrlError: [],
    grantAmountError: [],
    fundingInformationError: "",
  });
  const [reviewerCount, setreviewerCount] = useState([0, 1, 2, 3, 4]);
  const [reviewerDetails, setreviewerDetails] = useState({
    title: [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }],
    email: [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }],
    name: [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }],
    university: [
      { val: "" },
      { val: "" },
      { val: "" },
      { val: "" },
      { val: "" },
    ],
    orcidId: [{ val: "" }, { val: "" }, { val: "" }, { val: "" }, { val: "" }],
    department: [
      { val: "" },
      { val: "" },
      { val: "" },
      { val: "" },
      { val: "" },
    ],
    specialization: [
      { val: "" },
      { val: "" },
      { val: "" },
      { val: "" },
      { val: "" },
    ],
    additionalComment: [
      { val: "" },
      { val: "" },
      { val: "" },
      { val: "" },
      { val: "" },
    ],
    recommendReviwer: true,
  });
  const [reviewerDetailsError, setreviewerDetailsError] = useState({
    nameError: [],
    emailError: [],
    titleError: [],
    universityError: [],
    specializationError: [],
  });

  const [journalOptions, setjournalOptions] = useState([]);
  const [journalOptionsFirst, setjournalOptionsFirst] = useState([]);
  const [journalOptionsSecondry, setjournalOptionsSecondry] = useState([]);
  const [preValues, setpreValues] = useState({
    id: "",
    journalType: "",
    societyName: "",
    disciplineType: "",
    disciplineTypeError: "",
    journal: "",
    subject: "",
    subjectId: "",
    specialization: "",
    specializationId: "",
    articleType: "",
    // reviewType: ""
    reviewType: "pre-publication peer review only",
    secondaryJournalName: "",
    secondarySubjectName: "",
    secondarySubject: { _id: "" },
    secondarySpecialization: "",
    secondaryJournalNameError: "",
    secondarySubjectError: "",
    secondarySpecializationError: "",
    choiceOfReview: null,
    validCouponCode: {},
    paymentBySociety: { apcPayBySociety: false },
  });
  const [statements, setstatements] = useState({
    commercialFinanceConflict: "",
    conflictDetail: "",
    manuscriptVersion: "",
    manuscriptVersionDetail: "",
    checkedCondition: false,
    conflictError: "",
    versionError: "",
    acceptAllError: "",
  });
  const [conference, setconference] = useState({
    conferenceName: "",
    city: "",
    country: "",
    url: "",
    date: "",
    conferenceChairName: "",
    conferenceChairiEmail: "",
    trackChairName: "",
    trackChairEmail: "",
    checkedCondition: false,
  });
  const [conferenceError, setconferenceError] = useState({
    conferenceName: "",
    city: "",
    country: "",
    url: "",
    date: "",
    conferenceChairName: "",
    conferenceChairiEmail: "",
    trackChairName: "",
    trackChairEmail: "",
  });
  const SOCIETY_SPECIAL_JOURNAL =
    "Applied and Basic Obesity, Diabetes and Endocrinology";

  const isSocietyAPCDefaultAndDisabledJournal = (journalName) => {
    if (!journalName) return false;
    const j = journalName.trim().toLowerCase();
    return (
      j === "applied and basic obesity, diabetes and endocrinology" ||
      j === "community learning and social transformation"
    );
  };

  // Society journals that use the 9999 pricing tier (case-insensitive comparison)
  const SOCIETY_JOURNALS_WITH_9999_PRICE = [
    "applied and basic obesity, diabetes and endocrinology",
    "minorities in world politics",
    "community learning and social transformation",
  ];

  const applyApcPriceOverride = (
    baseAPCData,
    journalName,
    isSocietyJournal,
  ) => {
    if (!Array.isArray(baseAPCData)) return [];

    const clonedAPCData = baseAPCData.map((item) =>
      item && typeof item === "object" ? { ...item } : item,
    );

    const shouldOverridePrice =
      isSocietyJournal &&
      SOCIETY_JOURNALS_WITH_9999_PRICE.includes(
        (journalName || "").trim().toLowerCase(),
      );

    if (shouldOverridePrice && clonedAPCData[0]) {
      clonedAPCData[0].lastPrice = 12999;
      clonedAPCData[0].saving = 3000;
      clonedAPCData[0].introductoryPrice = 9999;
    }

    return clonedAPCData;
  };

  const defaultValuedate = dayjs(
    conference.date != "" ? conference.date : "01-01-2024",
  );
  // console.log("conferenceconference",conference);

  useEffect(() => {
    console.log(
      "[Diagnostic] MySubmission mounted. Initial subjects.preStepData:",
      subjects.preStepData,
    );
    handleGetSpecialization();

    const editedDetail = subjects.preStepData;
    const getValId = (val) => {
      if (!val) return "";
      if (typeof val === "string") return val;
      return val._id || val.key || val.id || "";
    };

    const isSocietyEditedArticle =
      getValId(editedDetail?.submissionDetail?.journalType) === journalTypes.society;
    const editedJournalName = editedDetail?.submissionDetail?.journalName || "";
    setAPCData(
      applyApcPriceOverride(
        subjects.APCData,
        editedJournalName,
        isSocietyEditedArticle,
      ),
    );
    let manageTab = "0";
    let isAuthorExist = false;
    let society = false;
    if (editedDetail.submissionDetail.articleType) {
      const data = preValues;
      data.id = editedDetail._id;
      manageTab = "1";
      const journalTypeId = getValId(editedDetail.submissionDetail?.journalType);
      fetchJernalDetails(journalTypeId);
      if (
        journalTypeId === journalTypes.society
      ) {
        setisSocityJournal(true);
        society = true;
        data.reviewType = "pre-publication peer review only";
        const savedApcPayBySociety =
          editedDetail.paymentBySociety?.hasOwnProperty("apcPayBySociety")
            ? editedDetail.paymentBySociety.apcPayBySociety
            : true;

        if (savedApcPayBySociety || isSocietyAPCDefaultAndDisabledJournal(editedJournalName)) {
          setApcPaymentOption("society");
          data.paymentBySociety = {
            ...data.paymentBySociety,
            apcPayBySociety: true,
          };
          setShowApcInfo(false);
          setShowSocietyFundedInfo(false);
        } else {
          setApcPaymentOption("self");
          data.paymentBySociety = {
            ...data.paymentBySociety,
            apcPayBySociety: false,
          };
          setShowApcInfo(true);
          setShowSocietyFundedInfo(false);
        }

        const editorialBoard = {
          key: "Editorial",
          value: "Editorial",
          description: "",
          wordCount: "",
        };
        if (
          editedDetail.submissionDetail?.journalName ===
          "Applied and Basic Obesity, Diabetes and Endocrinology"
        ) {
          setarticleTypeListf([...subjects.articleTypeList, editorialBoard]);
        } else {
          let updatedData = subjects.articleTypeList.filter(
            (item) => item.key !== "664aed76ada7b4f743b760a9",
          );
          setarticleTypeListf([...updatedData, editorialBoard]);
        }
      }
      setisJournalExist(2); // 2 journal value exist
      data.societyName = editedDetail.submissionDetail?.societyName;
      if (data.societyName !== "") {
        data.subject = editedDetail.submissionDetail?.subject?.subjectName;
        let savedSpec = "";
        if (Array.isArray(editedDetail.submissionDetail?.specialization)) {
          // If it's an array, it likely contains the IDs we want to restore.
          // We'll join them to check if they are IDs, and also set data.specializationId.
          savedSpec = editedDetail.submissionDetail.specialization
            .map((s) => (typeof s === "object" ? s.specialization || s._id : s))
            .filter(Boolean)
            .join(" | ");
          data.specializationId = editedDetail.submissionDetail.specialization
            .map((s) => (typeof s === "object" ? s._id : s))
            .filter(Boolean);
        } else {
          savedSpec =
            editedDetail.submissionDetail?.specialization?.specialization || "";
        }

        // Only restore if it looks like human-readable subject names (not old MongoDB ObjectId strings).
        // A MongoDB ObjectId is exactly 24 hex characters. If every segment matches that pattern, it's IDs.
        const isOldIdFormat = savedSpec
          .split(/[|,]/)
          .map((s) => s.trim())
          .filter(Boolean)
          .every((s) => /^[a-f0-9]{24}$/i.test(s));
        data.specialization = isOldIdFormat ? "" : savedSpec;
        if (isOldIdFormat && !data.specializationId) {
          data.specializationId = savedSpec
            .split(/[|,]/)
            .map((s) => s.trim())
            .filter(Boolean);
        }
      }
      data.journalType = getValId(editedDetail.submissionDetail?.journalType);
      const rawDiscipline = editedDetail.submissionDetail?.disciplineType;
      let discId = getValId(rawDiscipline);
      if (discId && subjects.desciplineMaster?.length > 0) {
        const found = subjects.desciplineMaster.find(
          (d) => d._id === discId || d.disciplineType === discId,
        );
        discId = found ? found._id : "";
      }
      data.disciplineType = discId;
      data.disciplineTypeError = "";
      data.journal = editedDetail.submissionDetail?.journalName;
      if (society === false && data.journal !== "") {
        getSubjectSpecialization(data.journal);
      }
      data.subjectId = getValId(editedDetail.submissionDetail?.subject) || getValId(editedDetail.submissionDetail?.subjectId);
      data.specializationId = getValId(editedDetail.submissionDetail?.specialization) || getValId(editedDetail.submissionDetail?.specializationId) || data.specializationId;

      const rawArtType = editedDetail.submissionDetail?.articleType;
      data.articleType = getValId(rawArtType);
      if (data.articleType) {
        getArticleTypeDesc(data.articleType);
      }
      data.secondarySubject = editedDetail.submissionDetail?.secondarySubject;
      data.secondaryJournalName =
        editedDetail.submissionDetail?.secondaryJournalName;
      if (society === false && data.secondaryJournalName !== "") {
        setTimeout(function () {
          getSubjectSpecialization(data.secondaryJournalName);
        }, 1000);
      }
      data.secondarySpecialization =
        editedDetail.submissionDetail?.secondarySpecialization;
      if (editedDetail.reviewType?.typeOfReview) {
        if (
          getValId(editedDetail.submissionDetail?.journalType) ===
          journalTypes.society
        ) {
          data.reviewType = editedDetail.reviewType?.typeOfReview;
        } else {
          data.reviewType = "pre-publication peer review only";
        }
      }

      if (editedDetail.validCouponCode && editedDetail.validCouponCode._id) {
        data.validCouponCode = editedDetail.validCouponCode;
        setIsCouponApplied(true);
        setCouponCode(editedDetail.validCouponCode.offerCode);
      }
      if (editedDetail.paymentBySociety) {
        data.paymentBySociety = editedDetail.paymentBySociety;
        if (editedDetail.paymentBySociety.apcPayBySociety || isSocietyAPCDefaultAndDisabledJournal(editedJournalName)) {
          setApcPaymentOption("society");
          setShowApcInfo(false);
        } else {
          setApcPaymentOption("self");
          setShowApcInfo(true);
        }
      }

      console.log("[Diagnostic] MySubmission preValues initialized to:", data);
      setpreValues({ ...data });

      const specialization =
        subjects.subjectSpecializationList[
        editedDetail.submissionDetail?.subject?._id
        ];
      const subjectSpecialization = [];
      if (specialization && specialization.length > 0) {
        specialization.forEach((element) => {
          const data = { key: element._id, value: element.specialization };
          subjectSpecialization.push(data);
        });
      }

      setspecialization(subjectSpecialization);
    }

    if (editedDetail.conference?._id && editedDetail.conference?._id !== "") {
      manageTab = "2";
      const conferenc = conference;

      conferenc.conferenceName = editedDetail?.conference?.conferenceName;
      conferenc.city = editedDetail?.conference?.city;
      conferenc.country = editedDetail?.conference?.country;
      conferenc.url = editedDetail?.conference?.url;
      conferenc.date = editedDetail?.conference?.date;
      conferenc.conferenceChairName =
        editedDetail?.conference?.conferenceChairName;
      conferenc.conferenceChairiEmail =
        editedDetail?.conference?.conferenceChairiEmail;
      conferenc.trackChairName = editedDetail?.conference?.trackChairName;
      conferenc.trackChairEmail = editedDetail?.conference?.trackChairEmail;
      // console.log("ddd", editedDetail?.conference?.conferenceName);
      setconference({ ...conferenc });
    }

    if (
      editedDetail.reviewType?.typeOfReview &&
      editedDetail.reviewType?.typeOfReview !== ""
    ) {
      if (editedDetail.reviewType.paymentDone === true) manageTab = "3";
      const totalreviewer = [];
      const revwrs = reviewerDetails;
      editedDetail.reviewType.suggestedReviewers.forEach((reviewr, k) => {
        totalreviewer.push(k);
        if (revwrs.title[k]) {
          revwrs.title[k].val = reviewr.title;
          revwrs.name[k].val = reviewr.fullName;
          revwrs.email[k].val = reviewr?.email;
          revwrs.university[k].val = reviewr.affiliatedInstitude;
          revwrs.orcidId[k].val = reviewr.orcidId;
          revwrs.department[k].val = reviewr.affiliatedDepartment;
          revwrs.specialization[k].val = reviewr.specialization._id;
          revwrs.additionalComment[k].val = reviewr.additionalComment;
        } else {
          revwrs.title.push({ val: reviewr.title });
          revwrs.name.push({ val: reviewr.fullName });
          revwrs.email.push({ val: reviewr?.email });
          revwrs.university.push({ val: reviewr.affiliatedInstitude });
          revwrs.orcidId.push({ val: reviewr.orcidId });
          revwrs.department.push({ val: reviewr.affiliatedDepartment });
          revwrs.specialization.push({ val: reviewr.specialization._id });
          revwrs.additionalComment.push({ val: reviewr.additionalComment });
        }
      });

      if (editedDetail.reviewType.suggestedReviewers.length === 0) {
        totalreviewer.push(0);
        revwrs.title.push({ val: "" });
        revwrs.name.push({ val: "" });
        revwrs.email.push({ val: "" });
        revwrs.university.push({ val: "" });
        revwrs.orcidId.push({ val: "" });
        revwrs.department.push({ val: "" });
        revwrs.specialization.push({ val: "" });
        revwrs.additionalComment.push({ val: "" });
      }
      revwrs.recommendReviwer = !editedDetail.reviewType.isRecommendReviewers;
      setreviewerDetails({ ...revwrs });
      setreviewerCount([...totalreviewer]);
    }

    if (editedDetail.authorDtl?._id && editedDetail.authorDtl?._id !== "") {
      const author = authorContent;
      const totalAuthor = [];
      editedDetail.authorDtl.author.forEach((authr, k) => {
        totalAuthor.push(k);
        if (author.authorTitle[k]) {
          author.authorTitle[k].val = authr.title;
          author.authorname[k].val = authr?.fullName;
          author.authorEmail[k].val = authr?.email;
          author.authorUniversity[k].val = authr?.affiliatedInstitude;
          author.authorDepartment[k].val = authr?.affiliatedDepartment;
          author.authorOrcidID[k].val = authr?.orcidId;
        } else {
          author.authorTitle.push({ val: authr.title });
          author.authorname.push({ val: authr?.fullName });
          author.authorEmail.push({ val: authr?.email });
          author.authorUniversity.push({ val: authr?.affiliatedInstitude });
          author.authorDepartment.push({ val: authr?.affiliatedDepartment });
          author.authorOrcidID.push({ val: authr?.orcidId });
        }
      });

      if (totalAuthor.length > 0) setauthorCount([...totalAuthor]);
      author.isMePrimaryAuthor = editedDetail.authorDtl?.notThePrimaryAuthor;
      author.contributionStatement =
        editedDetail.authorDtl?.contributionStatement;
      setauthorContent({ ...author });
      isAuthorExist = true;
      manageTab = "4";
    }

    if (
      editedDetail.fundingDetails?._id &&
      editedDetail.fundingDetails?._id !== ""
    ) {
      manageTab = "5";
      const fund = fundingDetails;
      const totalFund = [];
      editedDetail.fundingDetails.funder.forEach((funds, k) => {
        totalFund.push(k);
        if (fund.name[k]) {
          fund.name[k].val = funds.nameOfContactPerson;
          fund.email[k].val = funds?.emailId;
          fund.phone[k].val = funds?.mobileNumber;
          fund.fundingAgency[k].val = funds?.NameOfFundingAgency;
          fund.fundingAgencyUrl[k].val = funds?.urlOfFundingAgency;
          fund.grantAmount[k].val = funds?.grantAmount;
        }
      });

      if (editedDetail.fundingDetails.funder.length === 0) {
        totalFund.push(0);
        fund.name.push({ val: "" });
        fund.email.push({ val: "" });
        fund.phone.push({ val: "" });
        fund.fundingAgency.push({ val: "" });
        fund.fundingAgencyUrl.push({ val: "" });
        fund.grantAmount.push({ val: "" });
      }
      fund.fundingInformation = editedDetail.fundingDetails.fundingInformation;

      fund.noFundingRecevied = editedDetail.fundingDetails.noFundingRecevied;
      setfundingDetails({ ...fund });
      if (totalFund.length > 0) setfundingCount([...totalFund]);
    }

    if (editedDetail.statements?.AakashGangaJournal?.versionOfManuscript) {
      const statement = statements;

      statement.commercialFinanceConflict =
        editedDetail.statements.commercial.commercialOrfinancialConflictOfInterest;
      statement.conflictDetail = editedDetail.statements.commercial.text;
      statement.manuscriptVersion =
        editedDetail.statements.AakashGangaJournal.versionOfManuscript;
      statement.manuscriptVersionDetail =
        editedDetail.statements.AakashGangaJournal.text;
      statement.checkedCondition = true;
      setstatements({ ...statement });
    }

    manageTabs(manageTab);
    fetchProfileData(isAuthorExist);
    const refObj = (activeKey) => manageTabs(activeKey);
    refObj.openUploadModal = () => {
      if (!isSocietyArticle()) {
        setShowUploadArticleModal(true);
      }
    };
    subjects.submissionRef.current = refObj;
  }, []);
  function manageTabs(activeKey) {
    setdefaultActiveKey(activeKey);
  }

  useEffect(() => {
    // remove Conference Paper
    let updatedData = subjects.articleTypeList.filter(
      (item) => item.key !== "664aed76ada7b4f743b760a9",
    );
    setarticleTypeListwoutconf(updatedData);
    setarticleTypeListwconf(subjects.articleTypeList);

    const editedDetail = subjects.preStepData;
    const journalType =
      typeof editedDetail.submissionDetail?.journalType === "string"
        ? editedDetail.submissionDetail?.journalType
        : editedDetail.submissionDetail?.journalType?._id;
    const journalName = editedDetail.submissionDetail?.journalName;

    const currentJournalType = preValues?.journalType || journalType;
    const currentJournalName = preValues?.journal || journalName;

    const editorialBoard = {
      key: "Editorial",
      value: "Editorial",
      description: "",
      wordCount: "",
    };
    
    if (currentJournalType === journalTypes.mega) {
      setarticleTypeListf(subjects.articleTypeList);
    } else if (currentJournalType === journalTypes.society) {
      if (
        currentJournalName === "Applied and Basic Obesity, Diabetes and Endocrinology"
      ) {
        setarticleTypeListf([...subjects.articleTypeList, editorialBoard]);
      } else {
        setarticleTypeListf([...updatedData, editorialBoard]);
      }
    } else {
      setarticleTypeListf(updatedData);
    }
  }, [subjects.articleTypeList, preValues.journalType, preValues.journal]);

  useEffect(() => {
    console.log(
      "[Diagnostic] MySubmission prop subjects.preStepData changed:",
      subjects.preStepData,
    );
  }, [subjects.preStepData]);

  function saveOrcidId(code) {
    const data = {
      client_id: "APP-RAKRR9CDZ5FK8R7Z",
      client_secret: "159fe597-d2e0-4ac9-8dd4-ad07aaed037a",
      grant_type: "authorization_code",
      code: code,
      redirect_uri: "https://unikove.com/projects/orcid/orcid.php",
    };
    const headers = {
      Accept: `application/json`,
      "Content-Type": "application/x-www-form-urlencoded",
    };
    const queryParams = {
      payload: data,
      headers,
    };
    getOrcidID(queryParams);
  }

  const updateOrcidIdInProfile = async (orcidId) => {
    const { id } = jwt_decode(localStorage.usertoken);
    const headers = { Authorization: `Bearer ${userLoginDetails?.token}` };
    const queryParams = {
      params: { id },
      data: { orcidId: orcidId },
      headers,
    };
    const updateResp = await updateProfileDetails(queryParams);
    if (updateResp?.status === 200) {
    }
    setEditDetails(updateResp);
    fetchProfileData();
  };
  const fetchProfileData = (isAuthorExist) => {
    const fetchdata = async () => {
      const { id } = jwt_decode(localStorage.usertoken);
      const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
      const params = { id: id };
      return getProfileDetails(headers, params);
    };

    fetchdata()
      .then((userData) => {
        if (userData.status === 200 && userData?.data?.data) {
          setProfileDetails(userData.data.data);
          if (isAuthorExist === false) {
            const authr = authorContent;
            authr.authorTitle[0].val = userData.data.data.title;
            authr.authorname[0].val = userData.data.data.fullName;
            authr.authorEmail[0].val = userData.data.data.email;
            authr.authorUniversity[0].val =
              userData.data.data.affiliation?.affiliations[0]?.name;
            authr.authorDepartment[0].val =
              userData.data.data.affiliation?.affiliations[0]?.department;
            setauthorContent({ ...authr });
          }
        }
      })
      .catch((err) => console.log(err));
  };
  console.log("profiledetails", ProfileDetails);
  function fetchJernalDetails(Jid) {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const queryParams = {
      params: { journalType: Jid },
      headers: headers,
    };
    getJournalDetails(queryParams);
  }
  function handlejournalOPtions(selectedId, type, data) {
    let journal = journalOptions;
    if (data !== "") journal = data;
    const sJournal = [];
    journal.forEach((element) => {
      if (element.journalName !== selectedId) {
        sJournal.push(element);
      }
    });
    if (type === "second") setjournalOptionsFirst(sJournal);
    else if (type === "first") setjournalOptionsSecondry(sJournal);
  }
  function handleSelectChanges(e, type) {
    if (isSubmissionReadOnly) return;

    const val = preValues;
    if (type === "subject") {
      val.subjectId = e;
      const specialization = specializationMaster[e];
      const subjectSpecialization = [];
      specialization.forEach((element) => {
        const data = { key: element._id, value: element.specialization };
        subjectSpecialization.push(data);
      });

      setspecialization(subjectSpecialization);
    } else if (type === "journalType") {
      val.journalType = e;
      setAPCData(applyApcPriceOverride(subjects.APCData, "", false));

      const editorialBoard = {
        key: "Editorial",
        value: "Editorial",
        description: "",
        wordCount: "",
      };
      if (e === journalTypes.mega) {
        setarticleTypeListf(articleTypeListwconf);
      } else if (
        e === journalTypes.society &&
        val.journal === "Applied and Basic Obesity, Diabetes and Endocrinology"
      ) {
        setarticleTypeListf([...articleTypeListwconf, editorialBoard]);
      } else if (e === journalTypes.society) {
        setarticleTypeListf([...articleTypeListwoutconf, editorialBoard]);
      } else {
        setarticleTypeListf(articleTypeListwoutconf);
      }

      val.journal = "";
      val.disciplineType = "";
      val.disciplineTypeError = "";
      if (e === journalTypes.society) {
        fetchJernalDetails(e);
        val.societyName = "";
        val.reviewType = "";
        val.subject = "";
        val.subjectId = "";
        val.articleType = "";
        val.specialization = "";
        val.specializationId = "";
        val.specializationId = "";
        val.secondarySubject = { _id: "" };
        val.secondarySubjectName = "";
        val.reviewType = "pre-publication peer review only";
        setisSocityJournal(true);
        setApcPaymentOption("");
        setShowApcInfo(false);
        setCouponCode("");
        setIsCouponApplied(false);
        setShowSocietyFundedInfo(false);
      } else {
        fetchJernalDetails(e);
        // val.reviewType = ""
        val.reviewType = "pre-publication peer review only";
        val.subject = "";
        val.subjectId = "";
        val.articleType = "";
        val.specialization = "";
        val.specializationId = "";
        val.specializationId = "";
        val.secondaryJournalName = "";
        val.secondarySpecialization = "";
        val.secondarySubject = { _id: "" };
        val.secondarySubjectName = "";
        setdescplineSubject([]);
        setdescplineSubjectSec([]);
        setsecondrySpecialization([]);
        setspecialization([]);
        setisSocityJournal(false);
        setApcPaymentOption("");
        setShowApcInfo(false);
        setCouponCode("");
        setIsCouponApplied(false);
        setShowSocietyFundedInfo(false);
      }
    } else if (type === "socityType") {
      socityJournalDetails.forEach((element) => {
        if (element.relatedData[e]) {
          handleSocietChange(element.relatedData[e]);
        }
      });
      val.societyName = e;
    } else if (type === "specializationSociety") {
      val.specializationId = e; // Array of IDs from the dropdown
      // Also update val.specialization if needed for display, but main fix is specializationId
      val.specialization = e;
    } else if (type === "specialization") {
      val.specializationId = e;
      const subjectName = filterSubjectName(specialization, e);
      if (subjectName === otherSubjectTitle) {
        setOther({ ...other, show: true, disabled: false });
        setShowSubject(true);
      }
    } else if (type === "secondaryJournalName") {
      val.secondaryJournalName = e;
      val.secondarySpecialization = "";
      val.secondarySubjectName = "";
      val.secondarySubject = { _id: "" };
      val.secondaryJournalNameError = "";
      setsecondrySpecialization([]);
      setisJournalExist(1); // 1 old data not exist
      getSubjectSpecialization(e);

      handlejournalOPtions(e, "second", "");
    } else if (type === "secondarySubject") {
      val.secondarySubject._id = e;
      const specialization = specializationSecMaster[e];
      const subjectSpecialization = [];
      specialization.forEach((element) => {
        const data = { key: element._id, value: element.specialization };
        subjectSpecialization.push(data);
      });
      setsecondrySpecialization(subjectSpecialization);
      val.secondarySubjectError = "";
    } else if (type === "secondarySpecialization") {
      val.secondarySpecialization = e;
      val.secondarySpecializationError = "";
    } else if (type === "articleTypeList") {
      val.articleType = e;
      getArticleTypeDesc(e);
    } else if (type === "journal") {
      val.journal = e;
      val.subject = "";
      val.subjectId = "";

      setspecialization([]);
      const isSocietySelection = val.journalType === journalTypes.society;
      setAPCData(
        applyApcPriceOverride(subjects.APCData, e, isSocietySelection),
      );

      if (isSocityJournal === false) {
        setisJournalExist(1); // 1 old data not exist
        getSubjectSpecialization(e);
      }

      handlejournalOPtions(e, "first", "");
      if (isSocityJournal === true) {
        const editorialBoard = {
          key: "Editorial",
          value: "Editorial",
          description: "",
          wordCount: "",
        };
        if (e === "Applied and Basic Obesity, Diabetes and Endocrinology") {
          setarticleTypeListf([...articleTypeListwconf, editorialBoard]);
          setApcPaymentOption("society");
          setShowApcInfo(false);
          setShowSocietyFundedInfo(false); // Hide info as per request
          val.paymentBySociety = {
            ...val.paymentBySociety,
            apcPayBySociety: true,
          };
        } else {
          setarticleTypeListf([...articleTypeListwoutconf, editorialBoard]);
          setApcPaymentOption("society");
          setShowApcInfo(false);
          setShowSocietyFundedInfo(false);
          val.paymentBySociety = {
            ...val.paymentBySociety,
            apcPayBySociety: true,
          };
        }
        const getSub = socitySubjectDesp.subject[e];
        const getDes = socitySubjectDesp.descpline[e];
        const getReview = socitySubjectDesp.review[e];
        val.subject = getSub.val;
        val.subjectId = getSub.key;
        val.specialization = ""; // Initialize empty so user can select
        val.specializationId = ""; // DO NOT set to all IDs (getDes.key) anymore
        val.choiceOfReview = getReview;
      }
    } else if (type === "disciplineType") {
      val.disciplineType = e;
      val.disciplineTypeError = "";
      if (e === "646b3a74636258312d34abcf") {
        val.secondaryJournalNameError = "";
        val.secondarySubjectError = "";
        val.secondarySpecializationError = "";
      }
    } else if (type === "countrylist") {
      const conferenc = conference;
      conferenc.country = e;
      setconference({ ...conferenc });
    }

    setpreValues({ ...val });
  }

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "megaGuidelineAgreed_trigger") {
        if (preValues.journalType !== journalTypes.mega) {
          handleSelectChanges(journalTypes.mega, "journalType");
        }
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [preValues.journalType]);

  function getArticleTypeDesc(articleTypeId) {
    const details = subjects.articleTypeList.filter(
      (detl) => detl.key === articleTypeId,
    );
    setarticleTypeDesc({
      isShow: true,
      name: details[0].value,
      desc: details[0].description,
      wordCount: details[0].wordCount,
    });
  }
  function closegetArticleTypeDesc() {
    setarticleTypeDesc({ isShow: false, name: "", desc: "", wordCount: "" });
  }

  function filterSubjectName(subjects, id) {
    if (subjects.length === 0 || isSocityJournal === true || id === "" || !id)
      return "NoOther";
    return subjects.find(function (o) {
      return o.key === id;
    }).value;
  }
  const handleGetSpecialization = async () => {
    const headers = { Authorization: `Bearer ${localStorage.usertoken || ""}` };
    const { id } = jwt_decode(localStorage.usertoken);
    const params = {
      userId: id,
    };
    dispatch({ type: "SET_LOADER", payload: true });
    const addResp = await getOtherSpecialization(headers, params);
    dispatch({ type: "SET_LOADER", payload: false });
    if (addResp.data?.success) {
      dispatch({
        type: GET_OTHER_SUBJECT,
        payload: addResp?.data?.data,
      });
      getSubjectStatus(addResp?.data?.data);
    } else return;
  };

  const getSubjectStatus = (anotherSubject) => {
    anotherSubject &&
      anotherSubject?.filter((sub) => {
        if (sub?.status === "Pending") {
          dispatch({
            type: SAVE_SUBJECT_STATUS,
            payload: true,
          });
        }
        return;
      });
  };

  function handleSocietChange(details) {
    const pre = preValues;
    pre.societyName = details.societyName;
    pre.journal = details.journalName;
    pre.subject = details[0].subject.subjectName;
    pre.subjectId = details[0].subject._id;
    // Do NOT auto-populate specialization with all subjects from the journal.
    // The user must select subjects explicitly from the multi-select dropdown.
    pre.specialization = "";
    pre.specializationId = "";
    setpreValues({ ...pre });
  }
  function removeReviewers(key) {
    const data = reviewerCount;
    const details = reviewerDetails;
    const dataError = reviewerDetailsError;
    dataError.nameError[key] = "";
    dataError.emailError[key] = "";
    dataError.titleError[key] = "";
    dataError.universityError[key] = "";
    dataError.specializationError[key] = "";
    setreviewerDetailsError({ ...dataError });
    if (details.title[key]) {
      details.title.splice(key, 1);
    }
    if (details.email[key]) {
      details.email.splice(key, 1);
    }
    if (details.name[key]) {
      details.name.splice(key, 1);
    }
    if (details.university[key]) {
      details.university.splice(key, 1);
    }
    if (details.orcidId[key]) {
      details.orcidId.splice(key, 1);
    }
    if (details.department[key]) {
      details.department.splice(key, 1);
    }
    if (details.specialization[key]) {
      details.specialization.splice(key, 1);
    }
    if (details.additionalComment[key]) {
      details.additionalComment.splice(key, 1);
    }

    setreviewerDetails({ ...details });
    data.splice(key, 1);
    setreviewerCount([...data]);
  }
  function handleReviewTypeChange(e) {
    if (isSubmissionReadOnly) return;

    if (subjects.completedTabs.review === false || isSocityJournal === false) {
      const { name, id } = e.target;
      const val = preValues;
      val.reviewType = id;
      setpreValues({ ...val });
    }
  }
  function handleReviewerCheckbox(e) {
    if (isSubmissionReadOnly) return;

    const data = reviewerDetails;
    let val = false;
    if (e.target.checked) val = true;
    data.recommendReviwer = val;
    if (val === false) {
      setreviewerCount([0]);
      data.title = [{ val: "" }];
      data.email = [{ val: "" }];
      data.name = [{ val: "" }];
      data.university = [{ val: "" }];
      data.orcidId = [{ val: "" }];
      data.department = [{ val: "" }];
      data.specialization = [{ val: "" }];
      data.additionalComment = [{ val: "" }];
      const dataError = reviewerDetailsError;
      dataError.nameError = [];
      dataError.emailError = [];
      dataError.titleError = [];
      dataError.universityError = [];
      dataError.specializationError = [];
      setreviewerDetailsError({ ...dataError });
    }
    setreviewerDetails({ ...data });
  }
  function handlePrimaryAuthorCheckbox(e) {
    if (isSubmissionReadOnly) return;

    const author = authorContent;
    const authrEror = authorError;
    let val = true;
    if (e.target.checked) val = false;

    author.isMePrimaryAuthor = val;
    setauthorContent({ ...author });
    if (val === false) {
      if (authorCount.length === 1) {
        addMoreAuthor();
      }

      const authr = authorContent;

      authr.authorTitle[0].val = "";
      authr.authorname[0].val = "";
      authr.authorEmail[0].val = "";
      authr.authorUniversity[0].val = "";
      authr.authorDepartment[0].val = "";
      authr.authorOrcidID[0].val = "";
      authr.authorTitle[1].val = ProfileDetails.title;
      authr.authorname[1].val = ProfileDetails.fullName;
      authr.authorEmail[1].val = ProfileDetails.email;
      authr.authorUniversity[1].val =
        ProfileDetails.affiliation?.affiliations[0]?.name;
      authr.authorDepartment[1].val =
        ProfileDetails.affiliation?.affiliations[0]?.department;
      authr.authorDepartment[1].val =
        ProfileDetails.affiliation?.affiliations[0]?.department;
      setauthorContent({ ...authr });
      if (authrEror.authorTitleError[1]) {
        authrEror.authorTitleError[1] = "";
        authrEror.authornameError[1] = "";
        authrEror.authorEmailError[1] = "";
        authrEror.authorUniversityError[1] = "";
        authrEror.authorDepartmentError[1] = "";
        setauthorError({ ...authrEror });
      }
    } else {
      const authr = authorContent;
      authr.authorTitle[0].val = ProfileDetails.title;
      authr.authorname[0].val = ProfileDetails.fullName;
      authr.authorEmail[0].val = ProfileDetails.email;
      authr.authorUniversity[0].val =
        ProfileDetails.affiliation?.affiliations[0]?.name;
      authr.authorDepartment[0].val =
        ProfileDetails.affiliation?.affiliations[0]?.department;
      authr.authorOrcidID[0].val = "";
      if (authorCount.length > 1) {
        authr.authorTitle[1].val = "";
        authr.authorname[1].val = "";
        authr.authorEmail[1].val = "";
        authr.authorUniversity[1].val = "";
        authr.authorDepartment[1].val = "";
        authr.authorOrcidID[1].val = "";
        removeAuthorInputs(1);
      }
      setauthorContent({ ...authr });

      authrEror.authorTitleError[0] = "";
      authrEror.authornameError[0] = "";
      authrEror.authorEmailError[0] = "";
      authrEror.authorUniversityError[0] = "";
      authrEror.authorDepartmentError[0] = "";
      setauthorError({ ...authrEror });
    }
  }
  function handleStatementInput(e, type) {
    if (isSubmissionReadOnly) return;

    const data = statements;
    if (type === "conflictDetail") {
      data.conflictDetail = e;
    } else if (type === "manuscriptVersionDetail") {
      data.manuscriptVersionDetail = e;
    }
    setstatements({ ...data });
  }
  function handleStatementScriptChange(e) {
    if (isSubmissionReadOnly) return;

    const data = { ...statements };
    if (e.target.id === "scriptversionyes") {
      data.manuscriptVersion = "yes";
      const isMega =
        preValues.journalType === journalTypes.mega ||
        (!isSocityJournal && preValues.journalType !== journalTypes.society);
      if (isMega) {
        setShowPreviouslySubmittedModal(true);
      }
    } else {
      data.manuscriptVersion = "no";
    }
    setstatements(data);
  }
  function handleStatementConflictChange(e) {
    if (isSubmissionReadOnly) return;

    const data = statements;
    if (e.target.id === "conflictyes") data.commercialFinanceConflict = "2";
    else data.commercialFinanceConflict = "1";
    setstatements({ ...data });
  }
  function handleAcceptStatementCheckbox(e) {
    if (isSubmissionReadOnly) return;

    const data = statements;
    let val = false;
    if (e.target.checked) {
      val = true;
      data.acceptAllError = "";
    }

    data.checkedCondition = val;
    setstatements({ ...data });
  }
  function handleFundingCheckbox(e) {
    if (isSubmissionReadOnly) return;

    const data = fundingDetails;
    let val = false;
    if (e.target.checked) val = true;
    data.noFundingRecevied = val;

    if (val === true) {
      data.name[0].val = "";
      data.email[0].val = "";
      data.phone[0].val = "";
      data.fundingAgency[0].val = "";
      data.fundingAgencyUrl[0].val = "";
      data.grantAmount[0].val = "";
      data.fundingInformation = "";
      const error = fundingDetailsError;
      error.nameError = [];
      error.emailError = [];
      error.phoneError = [];
      error.fundingAgencyError = [];
      error.fundingAgencyUrlError = [];
      error.grantAmountError = [];
      error.fundingInformationError = "";
      setfundingDetailsError({ ...error });
    }
    setfundingDetails({ ...data });
  }
  function handleReviewerInput(e, index, type) {
    if (isSubmissionReadOnly) return;

    const data = reviewerDetails;

    const dataError = reviewerDetailsError;
    if (type === "reviewername") {
      data.name[index].val = e.target.value;
      dataError.nameError[index] = "";
    } else if (type === "email") {
      data.email[index].val = e.target.value;
      dataError.emailError[index] = "";
    } else if (type === "university") {
      data.university[index].val = e.target.value;
      dataError.universityError[index] = "";
    } else if (type === "department") {
      data.department[index].val = e.target.value;
    } else if (type === "orcidId") {
      data.orcidId[index].val = e.target.value;
    } else if (type === "additionalComment") {
      data.additionalComment[index].val = e;
    }
    setreviewerDetailsError({ ...dataError });
    setreviewerDetails({ ...data });
  }
  function handleSelectChangesReviewer(e, index, type) {
    if (isSubmissionReadOnly) return;

    const data = reviewerDetails;
    const dataError = reviewerDetailsError;
    if (type === "title") {
      data.title[index].val = e;
      dataError.titleError[index] = "";
    } else if (type === "specialization") {
      data.specialization[index].val = e;
      dataError.specializationError[index] = "";
    }
    setreviewerDetailsError({ ...dataError });
    setreviewerDetails({ ...data });
  }
  function handleConference(e, type) {
    if (isSubmissionReadOnly) return;

    const data = conference;
    if (type === "nameConference") {
      data.conferenceName = e.target.value;
      setconferenceError((errors) => ({ ...errors, conferenceName: "" }));
    } else if (type === "city") {
      data.city = e.target.value;
      setconferenceError((errors) => ({ ...errors, city: "" }));
    } else if (type === "urlConference") {
      data.url = e.target.value;
      setconferenceError((errors) => ({ ...errors, url: "" }));
    } else if (type === "dateConferencePresentation") {
      data.date = e.target.value;
      setconferenceError((errors) => ({ ...errors, date: "" }));
    } else if (type === "nameConferenceChair") {
      data.conferenceChairName = e.target.value;
      setconferenceError((errors) => ({ ...errors, conferenceChairName: "" }));
    } else if (type === "emailConferenceChair") {
      data.conferenceChairiEmail = e.target.value;
      setconferenceError((errors) => ({
        ...errors,
        conferenceChairiEmail: "",
      }));
    } else if (type === "nameTrackChair") {
      data.trackChairName = e.target.value;
      setconferenceError((errors) => ({ ...errors, trackChairName: "" }));
    } else if (type === "emailTrackChair") {
      data.trackChairEmail = e.target.value;
      setconferenceError((errors) => ({ ...errors, trackChairEmail: "" }));
    }

    // console.log(type);
    // console.log(e.target.value);
    setconference({ ...data });
    // console.log("conference",conference);
  }
  const handledatepicker = (date, dateString) => {
    if (isSubmissionReadOnly) return;

    const data = conference;
    data.date = dateString;
    setconferenceError((errors) => ({ ...errors, date: "" }));
    // console.log(date, dateString);
    setconference({ ...data });
  };
  function handleFundingInput(e, index, type) {
    if (isSubmissionReadOnly) return;

    const data = fundingDetails;
    const dataError = fundingDetailsError;
    if (type === "fundingInformation") {
      data.fundingInformation = e;
      dataError.fundingInformationError = "";
    } else if (type === "fundingAgency") {
      data.fundingAgency[index].val = e.target.value;
      dataError.fundingAgencyError[index] = "";
    } else if (type === "fundingAgencyUrl") {
      data.fundingAgencyUrl[index].val = e.target.value;
      dataError.fundingAgencyUrlError[index] = "";
    } else if (type === "grantAmount") {
      data.grantAmount[index].val = e.target.value;
      dataError.grantAmountError[index] = "";
    } else if (type === "name") {
      data.name[index].val = e.target.value;
      dataError.nameError[index] = "";
    } else if (type === "email") {
      data.email[index].val = e.target.value;
      dataError.emailError[index] = "";
    } else if (type === "phone") {
      data.phone[index].val = e.target.value;
      dataError.phoneError[index] = "";
    }
    setfundingDetailsError({ ...dataError });
    setfundingDetails({ ...data });
  }

  function addMoreAuthor() {
    if (isSubmissionReadOnly) return;

    const data = authorCount;
    const author = authorContent;
    author.authorTitle.push({ val: "" });
    author.authorname.push({ val: "" });
    author.authorEmail.push({ val: "" });
    author.authorUniversity.push({ val: "" });
    author.authorDepartment.push({ val: "" });
    author.authorOrcidID.push({ val: "" });
    setauthorContent({ ...author });
    data.push(authorCount.length);
    setauthorCount([...data]);
  }

  function addReviwer() {
    if (isSubmissionReadOnly) return;

    const data = reviewerCount;
    const details = reviewerDetails;
    data.push(reviewerCount.length);
    setreviewerCount([...data]);
    details.title.push({ val: "" });
    details.email.push({ val: "" });
    details.name.push({ val: "" });
    details.university.push({ val: "" });
    details.orcidId.push({ val: "" });
    details.department.push({ val: "" });
    details.specialization.push({ val: "" });
    details.additionalComment.push({ val: "" });
    setreviewerDetails({ ...details });
  }
  function addMoreFunder() {
    if (isSubmissionReadOnly) return;

    const data = fundingCount;
    const fnd = fundingDetails;
    fnd.name.push({ val: "" });
    fnd.email.push({ val: "" });
    fnd.phone.push({ val: "" });
    fnd.fundingAgency.push({ val: "" });
    fnd.grantAmount.push({ val: "" });
    fnd.fundingAgencyUrl.push({ val: "" });

    setfundingDetails({ ...fnd });
    data.push(fundingCount.length);
    setfundingCount([...data]);
  }
  function removeFundingInputs(key) {
    if (isSubmissionReadOnly) return;

    const data = fundingCount;
    const details = fundingDetails;
    const dataError = fundingDetailsError;
    data.splice(key, 1);
    setfundingCount([...data]);
    if (dataError.nameError[key]) {
      dataError.nameError[key] = "";
      dataError.emailError[key] = "";
      dataError.phoneError[key] = "";
      dataError.fundingAgencyError[key] = "";
      dataError.fundingAgencyUrlError[key] = "";
      dataError.grantAmountError[key] = "";
    }

    setfundingDetailsError({ ...dataError });
    if (details.name[key]) {
      details.name.splice(key, 1);
    }
    if (details.email[key]) {
      details.email.splice(key, 1);
    }
    if (details.phone[key]) {
      details.phone.splice(key, 1);
    }
    if (details.fundingAgency[key]) {
      details.fundingAgency.splice(key, 1);
    }
    if (details.fundingAgencyUrl[key]) {
      details.fundingAgencyUrl.splice(key, 1);
    }
    if (details.grantAmount[key]) {
      details.grantAmount.splice(key, 1);
    }
    setfundingDetails({ ...details });
  }
  function removeAuthorInputs(key) {
    if (isSubmissionReadOnly) return;

    const data = authorCount;
    const details = authorContent;
    const dataError = authorError;
    data.splice(key, 1);
    setauthorCount([...data]);
    if (dataError.authorTitleError[key]) {
      dataError.authorTitleError[key] = "";
      dataError.authornameError[key] = "";
      dataError.authorEmailError[key] = "";
      dataError.authorUniversityError[key] = "";
      dataError.authorDepartmentError[key] = "";
    }

    setauthorError({ ...dataError });
    if (details.authorTitle[key]) {
      details.authorTitle.splice(key, 1);
    }
    if (details.authorname[key]) {
      details.authorname.splice(key, 1);
    }

    if (details.authorEmail[key]) {
      details.authorEmail.splice(key, 1);
    }
    if (details.authorUniversity[key]) {
      details.authorUniversity.splice(key, 1);
    }
    if (details.authorDepartment[key]) {
      details.authorDepartment.splice(key, 1);
    }
    if (details.authorOrcidID && details.authorOrcidID[key]) {
      details.authorOrcidID.splice(key, 1);
    }
    setauthorContent({ ...details });
  }

  function clearAuthorInputs(key) {
    if (isSubmissionReadOnly) return;

    const details = { ...authorContent };
    const dataError = { ...authorError };

    // Clear errors for this key
    dataError.authorTitleError[key] = "";
    dataError.authornameError[key] = "";
    dataError.authorEmailError[key] = "";
    dataError.authorUniversityError[key] = "";
    dataError.authorDepartmentError[key] = "";

    setauthorError(dataError);

    // Clear content values for this key
    if (details.authorTitle[key]) details.authorTitle[key].val = "";
    if (details.authorname[key]) details.authorname[key].val = "";
    if (details.authorEmail[key]) details.authorEmail[key].val = "";
    if (details.authorUniversity[key]) details.authorUniversity[key].val = "";
    if (details.authorDepartment[key]) details.authorDepartment[key].val = "";
    if (details.authorOrcidID && details.authorOrcidID[key])
      details.authorOrcidID[key].val = "";

    setauthorContent(details);
  }

  function handleauthorInput(e, key, type) {
    if (isSubmissionReadOnly) return;

    const details = authorContent;
    const dataError = authorError;

    if (type === "title") {
      details.authorTitle[key].val = e;
      if (e !== "") dataError.authorTitleError[key] = "";
    } else if (type === "name") {
      details.authorname[key].val = e.target.value;
      if (e.target.value !== "") dataError.authornameError[key] = "";
    } else if (type === "email") {
      details.authorEmail[key].val = e.target.value;
      if (e.target.value !== "") dataError.authorEmailError[key] = "";
    } else if (type === "university") {
      details.authorUniversity[key].val = e.target.value;
      if (e.target.value !== "") dataError.authorUniversityError[key] = "";
    } else if (type === "department") {
      details.authorDepartment[key].val = e.target.value;
      if (e.target.value !== "") dataError.authorDepartmentError[key] = "";
    } else if (type === "orcid") {
      details.authorOrcidID[key].val = e.target.value;
    } else if (type === "contribution") {
      details.contributionStatement = e;
      if (e !== "") dataError.contributionStatementError = "";
    }
    setauthorContent({ ...details });
    setauthorError({ ...dataError });
  }
  function canOpenTab(key) {
    if (key === "0") return true;
    if (key === "1") {
      return (
        subjects.completedTabs.mySubmission === true ||
        subjects.completedTabs.conference === true ||
        subjects.completedTabs.review === true ||
        subjects.completedTabs.author === true ||
        subjects.completedTabs.funding === true ||
        subjects.completedTabs.statement === true
      );
    }
    if (key === "2") {
      if (preValues.articleType === "664aed76ada7b4f743b760a9") {
        return (
          subjects.completedTabs.conference === true ||
          subjects.completedTabs.review === true ||
          subjects.completedTabs.author === true ||
          subjects.completedTabs.funding === true ||
          subjects.completedTabs.statement === true
        );
      }
      return (
        subjects.completedTabs.mySubmission === true ||
        subjects.completedTabs.review === true ||
        subjects.completedTabs.author === true ||
        subjects.completedTabs.funding === true ||
        subjects.completedTabs.statement === true
      );
    }
    if (key === "3") {
      if (isSocityJournal && apcPaymentOption === "society") {
        if (preValues.articleType === "664aed76ada7b4f743b760a9") {
          return (
            subjects.completedTabs.conference === true ||
            subjects.completedTabs.review === true ||
            subjects.completedTabs.author === true ||
            subjects.completedTabs.funding === true ||
            subjects.completedTabs.statement === true
          );
        }
        return (
          subjects.completedTabs.mySubmission === true ||
          subjects.completedTabs.author === true ||
          subjects.completedTabs.funding === true ||
          subjects.completedTabs.statement === true
        );
      }
      return (
        subjects.completedTabs.review === true ||
        subjects.completedTabs.author === true ||
        subjects.completedTabs.funding === true ||
        subjects.completedTabs.statement === true
      );
    }
    if (key === "4")
      return (
        subjects.completedTabs.author === true ||
        subjects.completedTabs.funding === true ||
        subjects.completedTabs.statement === true
      );
    if (key === "5")
      return (
        subjects.completedTabs.funding === true ||
        subjects.completedTabs.statement === true
      );
    return true;
  }

  function handleAccordian(key) {
    if (isSubmissionReadOnly) return;
    if (!canOpenTab(key)) {
      return;
    }
    if (defaultActiveKey === key) setdefaultActiveKey("");
    else setdefaultActiveKey(key);
  }
  function saveAndPay(type, targetTabKey) {
    if (isSubmissionReadOnly) return;
    const currentTab =
      targetTabKey !== undefined ? String(targetTabKey) : defaultActiveKey;

    if (currentTab === "0") {
      let IsError = false;
      const isMegaOrNonSociety =
        isSocityJournal === false ||
        preValues.journalType === journalTypes.mega ||
        (!isSocityJournal && preValues.journalType !== journalTypes.society);

      const hasValidDiscipline =
        Boolean(preValues.disciplineType) &&
        preValues.disciplineType !== "" &&
        (subjects.desciplineMaster && subjects.desciplineMaster.length > 0
          ? subjects.desciplineMaster.some(
              (d) =>
                d._id === preValues.disciplineType ||
                d.disciplineType === preValues.disciplineType,
            )
          : true);

      const isDisciplineEmpty = isMegaOrNonSociety && !hasValidDiscipline;

      const otherMandatoryMissing =
        preValues.journal === "" ||
        preValues.subjectId === "" ||
        (preValues.articleType === "" &&
          subjects.completedTabs.mySubmission === false);

      if (otherMandatoryMissing) {
        IsError = true;
        toast.error("Please fill all the mandatory fields.");
      } else if (isDisciplineEmpty) {
        IsError = true;
        toast.error("Please select Type of Discipline.");
      }

      const isNotApplicable =
        preValues.disciplineType === "646b3a74636258312d34abcf" ||
        (subjects.desciplineMaster &&
          subjects.desciplineMaster.find(
            (d) =>
              d._id === preValues.disciplineType ||
              d.disciplineType === preValues.disciplineType,
          )?.disciplineType === "Not Applicable");

      if (isDisciplineEmpty) {
        IsError = true;
        const pre = preValues;
        pre.disciplineTypeError = "Please select Type of Discipline";
        setpreValues({ ...pre });
      } else if (isMegaOrNonSociety && !isNotApplicable) {
        const pre = preValues;
        pre.disciplineTypeError = "";
        if (preValues.secondaryJournalName === "") {
          pre.secondaryJournalNameError = "Please select secondary journal";
          IsError = true;
        }

        if (preValues.secondarySubject._id === "") {
          IsError = true;
          pre.secondarySubjectError = "Please select secondary subject";
        }
        if (preValues.secondarySpecialization === "") {
          IsError = true;
          pre.secondarySpecializationError =
            "Please select secondary specialization";
        }
        setpreValues({ ...pre });
      } else {
        preValues.secondarySubject = "";
        preValues.disciplineTypeError = "";
      }
      if (
        filterSubjectName(specialization, preValues.specializationId) ===
        otherSubjectTitle
      ) {
        IsError = true;
        setsubjectApproval(true);
      }

      if (isSocityJournal && apcPaymentOption === "") {
        IsError = true;
        toast.error("Please select an APC payment option.");
      }

      const selJName = (preValues.journal || "").trim().toLowerCase();
      if (
        isSocityJournal &&
        apcPaymentOption === "society" &&
        !isCouponApplied &&
        !isSocietyAPCDefaultAndDisabledJournal(preValues.journal) &&
        selJName !== "minorities in world politics"
      ) {
        IsError = true;
        toast.error("Coupon code is required for this option.");
      }

      if (IsError === false) {
        subjects.saveAndPay(preValues, type, currentTab);
        if (preValues.articleType != "664aed76ada7b4f743b760a9") {
          setdefaultActiveKey("2");
        } else {
          setdefaultActiveKey("1");
        }
      }
    } else if (currentTab === "2") {
      if (reviewerDetails.recommendReviwer === false) {
        const data = reviewerDetails;
        data.reviewType = preValues.reviewType;
        data.paymentBySociety = preValues.paymentBySociety;

        data.additionalComment = [{ val: "" }];
        data.department = [{ val: "" }];
        data.email = [{ val: "" }];
        data.name = [{ val: "" }];
        data.specialization = [{ val: "" }];
        data.title = [{ val: "" }];
        data.university = [{ val: "" }];
        subjects.saveAndPay(data, type, defaultActiveKey);
        setdefaultActiveKey("3");
      } else {
        // The Reviewer form was removed from this component, bypass validation
        const isReviewerValid = false;
        if (isReviewerValid === false) {
          const data = reviewerDetails;
          data.reviewType = preValues.reviewType;
          data.paymentBySociety = preValues.paymentBySociety;
          subjects.saveAndPay(data, type, defaultActiveKey);
          setdefaultActiveKey("3");
        } else {
          setpopupError(
            "Please provide complete information about the suggested reviewers.",
          );
          setincompleteInfoPopup(true);
        }
      }
    } else if (currentTab === "3") {
      const isValidAuthor = validateAuthor();
      if (isValidAuthor === false) {
        const data = authorContent;
        subjects.saveAndPay(data, type, defaultActiveKey);
        setdefaultActiveKey("4");
      } else {
        setpopupError(
          "Please briefly describe each author’s contribution to this work (e.g., conceptualization, writing, data analysis). This ensures transparency and proper credit for all contributors.",
        );
        setincompleteInfoPopup(true);
      }
    } else if (currentTab === "4") {
      if (type === 3) {
        const data = fundingDetails;
        data.noFundingRecevied = false;

        subjects.saveAndPay(data, type, defaultActiveKey);
        setdefaultActiveKey("4");
      } else {
        const isValidAuthor = validateFunding();
        if (isValidAuthor === false) {
          const data = fundingDetails;

          subjects.saveAndPay(data, type, defaultActiveKey);
          setdefaultActiveKey("5");
        } else {
          setpopupError(
            "Please provide complete information about funding details.",
          );
          setincompleteInfoPopup(true);
        }
      }
    } else if (currentTab === "5") {
      let isError = false;
      const error = statements;

      // Reset previous errors
      error.acceptAllError = "";
      error.conflictError = "";
      error.versionError = "";

      if (statements.commercialFinanceConflict === "") {
        error.conflictError = "Please select an option";
        isError = true;
      } else if (
        statements.commercialFinanceConflict === "2" &&
        statements.conflictDetail.trim() === ""
      ) {
        error.conflictError = "Please provide more details";
        isError = true;
      }

      if (statements.manuscriptVersion === "") {
        error.versionError = "Please select an option";
        isError = true;
      } else if (
        statements.manuscriptVersion === "yes" &&
        statements.manuscriptVersionDetail.trim() === ""
      ) {
        error.versionError = "Please provide more details";
        isError = true;
      }

      if (statements.checkedCondition === false) {
        error.acceptAllError = "Please accept term and conditions";
        isError = true;
      }

      if (isError) {
        setstatements({ ...error });
        const onlyCheckboxError =
          error.conflictError === "" &&
          error.versionError === "" &&
          statements.checkedCondition === false;

        if (onlyCheckboxError) {
          setpopupError(
            "Please sign the final box of Author Declaration to move forward.",
          );
          setpopupTitle("Author Declaration");
          setTimeout(() => {
            const el = document.querySelector(".author-declaration-section");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
          }, 100);
        } else {
          setpopupError(
            "Please complete all mandatory fields in the Statements section.",
          );
          setpopupTitle("Details Incomplete");
          setTimeout(() => {
            const el = document.querySelector(".new-statements-layout");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 100);
        }
        setincompleteInfoPopup(true);
      } else {
        const isMega =
          preValues.journalType === journalTypes.mega ||
          (!isSocityJournal && preValues.journalType !== journalTypes.society);
        if (isMega && statements.manuscriptVersion === "yes") {
          setShowPreviouslySubmittedModal(true);
          return;
        }
        subjects.saveAndPay(statements, 0, currentTab);
        setShowCelebrationModal(true);
      }
    } else if (currentTab === "1") {
      let IsError = false;

      if (conference.conferenceName === "") {
        setconferenceError((errors) => ({
          ...errors,
          conferenceName: "Conference Name is required",
        }));
        IsError = true;
      } else if (conference.city === "") {
        setconferenceError((errors) => ({
          ...errors,
          city: "City is required",
        }));
        IsError = true;
      } else if (conference.country === "") {
        setconferenceError((errors) => ({
          ...errors,
          country: "Country is required",
        }));
        IsError = true;
      } else if (conference.url === "") {
        setconferenceError((errors) => ({ ...errors, url: "Url is required" }));
        IsError = true;
      } else if (conference.date === "") {
        setconferenceError((errors) => ({
          ...errors,
          date: "Date is required",
        }));
        IsError = true;
      } else if (conference.conferenceChairName === "") {
        setconferenceError((errors) => ({
          ...errors,
          conferenceChairName: "Name is required",
        }));
        IsError = true;
      } else if (conference.conferenceChairiEmail === "") {
        setconferenceError((errors) => ({
          ...errors,
          conferenceChairiEmail: "Email is required",
        }));
        IsError = true;
      } else if (conference.trackChairName === "") {
        setconferenceError((errors) => ({
          ...errors,
          trackChairName: "Name is required",
        }));
        IsError = true;
      } else if (conference.trackChairEmail === "") {
        setconferenceError((errors) => ({
          ...errors,
          trackChairEmail: "Email is required",
        }));
        IsError = true;
      }

      if (preValues.articleType != "664aed76ada7b4f743b760a9") {
        setdefaultActiveKey(
          isSocityJournal && apcPaymentOption === "society" ? "3" : "2",
        );
      } else {
        if (type === 3) {
          const data = conference;

          if (IsError === false) {
            subjects.saveAndPay(data, type, defaultActiveKey);
            setdefaultActiveKey(
              isSocityJournal && apcPaymentOption === "society" ? "3" : "2",
            );
          }
        } else {
          // const isValidAuthor = validateFunding();
          // if (isValidAuthor === false) {
          const data = conference;
          if (IsError === false) {
            subjects.saveAndPay(data, type, defaultActiveKey);
            setdefaultActiveKey(
              isSocityJournal && apcPaymentOption === "society" ? "3" : "2",
            );
          } else {
            setpopupError(
              "Please provide complete information about Conference Paper",
            );
            setincompleteInfoPopup(true);
          }
        }
      }
    }
  }
  function validateFunding() {
    const dataError = fundingDetailsError;

    let isError = false;
    if (fundingDetails.noFundingRecevied === false) {
      for (let i = 0; i < fundingCount.length; i++) {
        if (!fundingDetails.name[i] || fundingDetails.name[i].val === "") {
          isError = true;
          dataError.nameError[i] = `Please enter name`;
        } else {
          dataError.nameError[i] = "";
        }
        if (!fundingDetails.email[i] || fundingDetails.email[i].val === "") {
          isError = true;
          dataError.emailError[i] = `Please enter email`;
        } else if (!validateEmail(fundingDetails.email[i].val)) {
          isError = true;
          dataError.emailError[i] = `Please enter valid email`;
        } else {
          dataError.emailError[i] = "";
        }
        if (!fundingDetails.phone[i] || fundingDetails.phone[i].val === "") {
          isError = true;
          dataError.phoneError[i] = `Please enter phone number`;
        } else {
          dataError.phoneError[i] = "";
        }
        if (
          !fundingDetails.fundingAgency[i] ||
          fundingDetails.fundingAgency[i].val === ""
        ) {
          isError = true;
          dataError.fundingAgencyError[i] = `Please enter agency name`;
        } else {
          dataError.fundingAgencyError[i] = "";
        }
        if (
          !fundingDetails.fundingAgencyUrl[i] ||
          fundingDetails.fundingAgencyUrl[i].val === ""
        ) {
          isError = true;
          dataError.fundingAgencyUrlError[i] = `Please enter agency url`;
        } else if (!checkUrl(fundingDetails.fundingAgencyUrl[i].val)) {
          isError = true;
          dataError.fundingAgencyUrlError[i] = `Please enter valid url`;
        } else {
          dataError.fundingAgencyUrlError[i] = "";
        }
        if (
          !fundingDetails.grantAmount[i] ||
          fundingDetails.grantAmount[i].val === ""
        ) {
          isError = true;
          dataError.grantAmountError[i] = `Please enter amount`;
        }
        if (fundingDetails.fundingInformation === "") {
          isError = true;
          dataError.fundingInformationError = `Please enter funding information`;
        }
        setfundingDetailsError({ ...dataError });
      }
    }
    return isError;
  }
  function validateReview() {
    let isError = false;
    const data = reviewerDetailsError;
    for (var i = 0; i < reviewerCount.length; i++) {
      if (!reviewerDetails.title[i] || reviewerDetails.title[i].val === "") {
        isError = true;
        data.titleError[i] = `Please enter title`;
      } else {
        data.titleError[i] = "";
      }
      if (!reviewerDetails.name[i] || reviewerDetails.name[i].val === "") {
        isError = true;
        data.nameError[i] = "Please enter name";
      } else {
        data.nameError[i] = "";
      }
      if (!reviewerDetails.email[i] || reviewerDetails.email[i].val === "") {
        isError = true;
        data.emailError[i] = "Please enter email";
      } else if (!validateEmail(reviewerDetails.email[i].val)) {
        isError = true;
        data.emailError[i] = `Please enter valid email`;
      } else {
        data.emailError[i] = "";
      }
      if (
        !reviewerDetails.university[i] ||
        reviewerDetails.university[i].val === ""
      ) {
        isError = true;
        data.universityError[i] =
          "Please enter affiliated institution/university";
      } else {
        data.universityError[i] = "";
      }
      if (
        !reviewerDetails.specialization[i] ||
        reviewerDetails.specialization[i].val === ""
      ) {
        isError = true;
        data.specializationError[i] = "Please select specialization";
      } else {
        data.specializationError[i] = "";
      }
      setreviewerDetailsError({ ...data });
    }
    return isError;
  }
  function validateAuthor() {
    const dataError = authorError;

    let isError = false;
    for (let i = 0; i < authorCount.length; i++) {
      if (
        !authorContent.authorTitle[i] ||
        authorContent.authorTitle[i].val === ""
      ) {
        isError = true;
        dataError.authorTitleError[i] = `Please enter title`;
      } else {
        dataError.authorTitleError[i] = "";
      }
      if (
        !authorContent.authorname[i] ||
        authorContent.authorname[i].val === ""
      ) {
        isError = true;
        dataError.authornameError[i] = `Please enter first name`;
      } else {
        dataError.authornameError[i] = "";
      }

      if (
        !authorContent.authorEmail[i] ||
        authorContent.authorEmail[i].val === ""
      ) {
        isError = true;
        dataError.authorEmailError[i] = `Please enter email`;
      } else if (!validateEmail(authorContent.authorEmail[i].val)) {
        isError = true;
        dataError.authorEmailError[i] = `Please enter valid email`;
      } else {
        dataError.authorEmailError[i] = "";
      }
      if (
        !authorContent.authorUniversity[i] ||
        authorContent.authorUniversity[i].val === ""
      ) {
        isError = true;
        dataError.authorUniversityError[i] = `Please enter university name`;
      } else {
        dataError.authorUniversityError[i] = "";
      }
      if (
        !authorContent.contributionStatement ||
        authorContent.contributionStatement === ""
      ) {
        isError = true;
        dataError.contributionStatementError = `Please enter contribution statement`;
      } else if (authorContent.contributionStatement.split(" ").length > 300) {
        isError = true;
        data.abstractError = "300 words are allowed";
      } else {
        dataError.contributionStatementError = "";
      }
      setauthorError({ ...dataError });
    }
    return isError;
  }

  const successfullyContact = () => {
    setneedHelpPopup(false);
  };
  function handleOtherSubject() {
    handleGetSpecialization();
  }
  console.log("isCOuponApplied :", isCouponApplied);

  const currentJournalName = (preValues.journal || "").trim().toLowerCase();
  const isMWPOnly =
    currentJournalName === "minorities in world politics" ||
    currentJournalName === "mwp";

  // console.log("defaultActiveKey",subjects.completedTabs);
  return (
    <div
      className={
        subjects.isUpdateNewVersion === true && subjects.isForRevision === false
          ? "peerArticlePage readonlyDetailPage"
          : "peerArticlePage"
      }
    >
      {isUploadingArticle && !showUploadArticleModal && (
        <div
          className="alert alert-info d-flex align-items-center justify-content-between mb-3 shadow-sm p-3 rounded"
          style={{
            backgroundColor: "#e3f2fd",
            borderColor: "#90caf9",
            color: "#0d47a1",
            borderRadius: "8px",
            flexWrap: "nowrap",
            gap: "15px",
          }}
        >
          <div
            className="d-flex align-items-center gap-2"
            style={{ flex: "1 1 auto", minWidth: 0 }}
          >
            <span
              className="spinner-border spinner-border-sm text-primary me-2 flex-shrink-0"
              role="status"
              aria-hidden="true"
            ></span>
            <div style={{ minWidth: 0 }}>
              <strong>Evaluating uploaded document</strong>
              <div style={{ fontSize: "13px" }}>
                Please wait while we determine if the article submitted meets
                the Article Submission Guidelines. You will receive an email
                post this evaluation.
              </div>
            </div>
          </div>
          <button
            type="button"
            className="button button-primary ms-3"
            style={{
              whiteSpace: "nowrap",
              flexShrink: 0,
              padding: "8px 18px",
              fontSize: "13px",
              height: "auto",
              lineHeight: "1.2",
              textTransform: "none",
              borderRadius: "6px",
            }}
            onClick={() => setShowUploadArticleModal(true)}
          >
            View Progress
          </button>
        </div>
      )}
      <div
        className="customAccordion"
        style={
          isUploadingArticle
            ? { pointerEvents: "none", opacity: 0.6, userSelect: "none" }
            : {}
        }
      >
        <Accordion activeKey={defaultActiveKey} flush>
          <Accordion.Item eventKey="0">
            <Accordion.Header onClick={() => handleAccordian("0")}>
              <p>CHOOSE TYPE OF JOURNAL</p>
              {subjects.completedTabs.mySubmission === false && (
                <b className="toBeCompleted">
                  {subjects.isSocietyEditor ? "Completed" : "To be completed"}
                </b>
              )}
              {subjects.completedTabs.mySubmission === true && (
                <b className="">Completed</b>
              )}
            </Accordion.Header>
            <Accordion.Body>
              <div className="submission-main-card">
                <div className="section-header">CHOOSE TYPE OF JOURNAL</div>

                <div className="journal-pills-row">
                  {subjects.journalType
                    ?.slice()
                    .sort((a, b) => {
                      if (a.value === "Mega Journal") return -1;
                      if (b.value === "Mega Journal") return 1;
                      return 0;
                    })
                    .map((val, idx, array) => (
                      <React.Fragment key={val.key}>
                        <div
                          className={`journal-pill ${preValues.journalType === val.key ? "active" : ""}`}
                          style={{ userSelect: "none" }}
                          onClick={(e) => {
                            if (subjects?.completedTabs?.review) return;
                            if (val.value === "Mega Journal") {
                              e.preventDefault();
                              setShowMegaGuidelineModal(true);
                            } else {
                              handleSelectChanges(val.key, "journalType");
                            }
                          }}
                        >
                          <span></span>
                          <span>
                            {val.value === "Mega Journal"
                              ? "MEGA"
                              : val.value === "Society Journal"
                                ? "SOCIETY"
                                : val.value.toUpperCase()}
                          </span>
                          <div className="journal-status-circle"></div>
                        </div>
                        {idx < array.length - 1 && (
                          <div className="pill-connector"></div>
                        )}
                      </React.Fragment>
                    ))}
                </div>

                {preValues.journalType !== "" && (
                  <>
                    {isSocityJournal === false && (
                      <div className="discipline-section-wrapper">
                        <div
                          className="discipline-section"
                          style={{
                            marginBottom: preValues.disciplineTypeError
                              ? "8px"
                              : "30px",
                          }}
                        >
                          <div className="label-text">
                            TYPE OF DISCIPLINE
                            <sup
                              className="supStar"
                              style={{
                                color: "#BF1E2E",
                                fontSize: "18px",
                                fontWeight: "bold",
                                marginLeft: "4px",
                              }}
                            >
                              *
                            </sup>
                          </div>
                          {subjects.desciplineMaster
                            ?.slice()
                            .sort((a, b) => {
                              if (a.disciplineType === "Not Applicable") return 1;
                              if (b.disciplineType === "Not Applicable")
                                return -1;
                              return 0;
                            })
                            .map((val) => (
                              <div
                                key={val._id}
                                className={`discipline-option ${
                                  preValues.disciplineType === val._id ||
                                  preValues.disciplineType === val.disciplineType
                                    ? "active"
                                    : ""
                                }`}
                                onClick={() =>
                                  !isSubmissionReadOnly &&
                                  handleSelectChanges(val._id, "disciplineType")
                                }
                              >
                                <div className="radio-outer"></div>
                                <span>{val.disciplineType}</span>
                              </div>
                            ))}
                        </div>
                        {preValues.disciplineTypeError !== "" && (
                          <div
                            className="label-error text-center mb-3"
                            style={{
                              color: "#BF1E2E",
                              fontSize: "14px",
                              fontWeight: "600",
                              display: "block",
                            }}
                          >
                            {preValues.disciplineTypeError}
                          </div>
                        )}
                      </div>
                    )}

                    <div className="primary-journal-divider">
                      <span>PRIMARY JOURNAL</span>
                    </div>

                    <div className="form-grid mt-4">
                      <div className="form-field">
                        <label>Journal</label>
                        <div className="selectBox">
                          <Select
                            disabled={isSubmissionReadOnly}
                            selectedValue={preValues.journal}
                            options={journalOptionsFirst?.map(
                              (val) => val.journalName,
                            )}
                            optionValues={journalOptionsFirst?.map(
                              (val) => val.journalName,
                            )}
                            name="journalName"
                            placeholder=""
                            handleChange={(e) =>
                              handleSelectChanges(e, "journal")
                            }
                            required={true}
                            mandatory={false}
                          />
                        </div>
                      </div>

                      <div className="form-field">
                        <label>Discipline</label>
                        {isSocityJournal === false &&
                          preValues.journal == journalTypes.yogaJournal ? (
                          <div className="selectBox">
                            <Select
                              disabled={isSubmissionReadOnly}
                              selectedValue={preValues.subjectId}
                              options={descplineSubject?.map((val) => val?.val)}
                              optionValues={descplineSubject?.map(
                                (val) => val?.key,
                              )}
                              name="subject"
                              placeholder=""
                              handleChange={(e) =>
                                handleSelectChanges(e, "subject")
                              }
                              required={true}
                              mandatory={false}
                            />
                          </div>
                        ) : (
                          <div className="inputTextBox">
                            <Input
                              errors=""
                              name="subject"
                              className="form-control grey-input"
                              type="text"
                              required={"required"}
                              value={preValues.subject}
                              placeholder="Discipline"
                              handleChange={(e) =>
                                handleSelectChanges(e, "subject")
                              }
                            />
                          </div>
                        )}
                      </div>

                      <div className="form-field">
                        <label>Subject</label>
                        {isSocityJournal === false ? (
                          <>
                            <div className="selectBox subjectDropDown">
                              <Select
                                disabled={isSubmissionReadOnly}
                                selectedValue={preValues.specializationId}
                                options={specialization?.map(
                                  (val) => val?.value,
                                )}
                                optionValues={specialization?.map(
                                  (val) => val?.key,
                                )}
                                name="specialization"
                                placeholder="Search and select"
                                handleChange={(e) =>
                                  handleSelectChanges(e, "specialization")
                                }
                                required={true}
                                mandatory={false}
                                isSearchable={true}
                              />
                            </div>

                            {otherSubject?.map((sub) => {
                              if (sub?.status === "Pending") {
                                return (
                                  <div className="custom_input approvalInput">
                                    <Input
                                      readOnly
                                      className={
                                        "form-control active-input specialization-input"
                                      }
                                      label={""}
                                      value={sub?.specialization}
                                      postTextClass={"Pending approval"}
                                      disabled
                                    />
                                  </div>
                                );
                              } else return null;
                            })}
                          </>
                        ) : (
                          <>
                            <div className="selectBox subjectDropDown">
                              <Select
                                disabled={isSubmissionReadOnly}
                                isMulti={true}
                                selectedValue={
                                  Array.isArray(preValues.specializationId)
                                    ? preValues.specializationId
                                    : preValues.specializationId
                                      ? preValues.specializationId
                                        .split("|")
                                        .map((s) => s.trim())
                                        .filter(Boolean)
                                      : []
                                }
                                options={
                                  socitySubjectDesp?.descpline?.[
                                    preValues.journal
                                  ]?.value
                                    ? socitySubjectDesp.descpline[
                                      preValues.journal
                                    ].value
                                      .split(/[,|]/)
                                      .map((s) => s.trim())
                                      .filter(Boolean)
                                    : []
                                }
                                optionValues={
                                  socitySubjectDesp?.descpline?.[
                                    preValues.journal
                                  ]?.key
                                    ? socitySubjectDesp.descpline[
                                      preValues.journal
                                    ].key
                                      .split("|")
                                      .map((s) => s.trim())
                                      .filter(Boolean)
                                    : []
                                }
                                name="specializationSociety"
                                placeholder="Search and select"
                                handleChange={(e) =>
                                  handleSelectChanges(
                                    e,
                                    "specializationSociety",
                                  )
                                }
                                required={true}
                                mandatory={false}
                                isSearchable={true}
                                joinMultiValues={true}
                              />
                            </div>
                          </>
                        )}
                        {isSocityJournal === false && (
                          <div className="somethingMind">
                            Your subject is not showing?{" "}
                            <Link
                              to="#"
                              onClick={(e) => {
                                e.preventDefault();
                                setOther({
                                  show: true,
                                  specialization: "",
                                  disabled: true,
                                });
                                setShowSubject(true);
                              }}
                            >
                              Add Subject
                            </Link>
                          </div>
                        )}
                      </div>

                      {isSocityJournal ? (
                        <>
                          <div className="form-field">
                            <label>Article Type</label>
                            <div className="selectBox">
                              <Select
                                disabled={isSubmissionReadOnly}
                                selectedValue={preValues.articleType}
                                options={articleTypeListf?.map(
                                  (val) => val?.value,
                                )}
                                optionValues={articleTypeListf?.map(
                                  (val) => val?.key,
                                )}
                                name="articleTypeList"
                                placeholder=""
                                handleChange={(e) =>
                                  handleSelectChanges(e, "articleTypeList")
                                }
                                required={true}
                                mandatory={false}
                              />
                            </div>
                          </div>
                          <div className="article-apc-row">
                            <div className="form-field apc-field">
                              <div className="apc-proceed-section">
                                <span className="apc-label">
                                  How would you like to proceed with the Article
                                  Processing Charge (APC)?
                                </span>
                                <div className="apc-options-row">
                                  <div
                                    className={`apc-radio-option ${apcPaymentOption === "self" ? "active" : ""} ${isSocietyAPCDefaultAndDisabledJournal(preValues.journal) ? "disabled-apc-option" : ""}`}
                                    onClick={() => {
                                      if (
                                        isSocietyAPCDefaultAndDisabledJournal(
                                          preValues.journal,
                                        )
                                      )
                                        return;
                                      setApcPaymentOption("self");
                                      setShowApcInfo(true);
                                      setpreValues((prev) => ({
                                        ...prev,
                                        paymentBySociety: {
                                          ...prev.paymentBySociety,
                                          apcPayBySociety: false,
                                        },
                                      }));
                                    }}
                                  >
                                    <div className="journal-status-circle"></div>
                                    <span>I will pay the APC myself</span>
                                  </div>
                                  <div
                                    className={`apc-radio-option ${apcPaymentOption === "society" ? "active" : ""}`}
                                    onClick={() => {
                                      setApcPaymentOption("society");
                                      setShowApcInfo(false);
                                      setShowSocietyFundedInfo(true);
                                      setpreValues((prev) => ({
                                        ...prev,
                                        paymentBySociety: {
                                          ...prev.paymentBySociety,
                                          apcPayBySociety: true,
                                        },
                                      }));
                                    }}
                                  >
                                    <div className="journal-status-circle"></div>
                                    <span>
                                      The society will pay the APC on my behalf
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="form-field">
                          <label>Article Type</label>
                          <div className="selectBox">
                            <Select
                              disabled={isSubmissionReadOnly}
                              selectedValue={preValues.articleType}
                              options={articleTypeListf?.map(
                                (val) => val?.value,
                              )}
                              optionValues={articleTypeListf?.map(
                                (val) => val?.key,
                              )}
                              name="articleTypeList"
                              placeholder=""
                              handleChange={(e) =>
                                handleSelectChanges(e, "articleTypeList")
                              }
                              required={true}
                              mandatory={false}
                            />
                          </div>
                          <div className="somethingMind">
                            Need some other article type?{" "}
                            <a href="mailto:contactus@vikramshilaedu.in">
                              contactus@vikramshilaedu.in
                            </a>
                          </div>
                        </div>
                      )}
                    </div>

                    {isSocityJournal &&
                      apcPaymentOption === "self" &&
                      showApcInfo && (
                        <div className="apc-payment-required-box">
                          <span
                            className="close-btn"
                            onClick={() => setShowApcInfo(false)}
                          >
                            ×
                          </span>
                          <div className="header">
                            {isCouponApplied
                              ? "SOCIETY-FUNDED SUBMISSION"
                              : "APC PAYMENT REQUIRED"}
                          </div>
                          <hr />
                          <div className="content">
                            <p>
                              Your submission will follow the standard payment
                              process for this journal.
                            </p>
                            {preValues.journal?.trim()?.toLowerCase() !==
                              "minorities in world politics" && (
                                <p>
                                  You’ll be asked to pay a ₹1,000 registration{" "}
                                  <br />
                                  fee at the time of submission.
                                </p>
                              )}
                            <p>
                              If your manuscript is accepted after editorial
                              screening, the{" "}
                              {preValues.journal?.trim()?.toLowerCase() ===
                                "minorities in world politics"
                                ? "full"
                                : "remaining"}{" "}
                              APC will be payable before publication.
                            </p>
                            <p>
                              <b>
                                If the society has issued a coupon code, please
                                click the section "The society will pay the APC
                                on my behalf" and enter the coupon code there.
                              </b>
                            </p>
                            <p>You can continue with your submission.</p>

                            <div className="more-questions">
                              <span>More Questions?</span>
                              <a href="mailto:contactus@vikramshilaedu.in">
                                contactus@vikramshilaedu.in
                              </a>
                            </div>
                          </div>
                        </div>
                      )}
                    {isSocityJournal &&
                      apcPaymentOption === "society" &&
                      !isSocietyAPCDefaultAndDisabledJournal(preValues.journal) && (
                        <div className="society-funded-container">
                          <div className="society-funded-row">
                            {showSocietyFundedInfo && (
                              <div className="apc-payment-required-box society-funded-box">
                                <span
                                  className="close-btn"
                                  onClick={() =>
                                    setShowSocietyFundedInfo(false)
                                  }
                                >
                                  ×
                                </span>
                                <div className="header">
                                  SOCIETY-FUNDED SUBMISSION
                                </div>
                                <hr />
                                <div className="content">
                                  {isCouponApplied ? (
                                    <>
                                      <p>
                                        This journal allows society-funded
                                        submissions.
                                      </p>
                                      <p>
                                        Please enter your society-issued code to
                                        complete your submission without any APC
                                        payment.
                                      </p>
                                      <p>
                                        Once the code is validated, you can
                                        continue directly to manuscript
                                        submission.
                                      </p>
                                    </>
                                  ) : (
                                    <>
                                      <p>
                                        This journal allows society-funded
                                        submissions.
                                      </p>
                                      <p>
                                        Please enter your society-issued code{" "}
                                        <br />
                                        to complete your submission without{" "}
                                        <br />
                                        any APC payment.
                                      </p>
                                      <p>
                                        Once the code is validated, you can
                                        continue directly to manuscript
                                        submission.
                                      </p>
                                    </>
                                  )}

                                  <div className="more-questions">
                                    <span>More Questions?</span>
                                    <a href="mailto:contactus@vikramshilaedu.in">
                                      contactus@vikramshilaedu.in
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}

                            <div className="coupon-section">
                              <label>Enter society-issued coupon code</label>
                              <div className="coupon-input-group">
                                <input
                                  type="text"
                                  placeholder="Enter code"
                                  value={couponCode}
                                  disabled={isSubmissionReadOnly}
                                  readOnly={isSubmissionReadOnly}
                                  onChange={(e) => {
                                    if (isSubmissionReadOnly) return;
                                    setCouponCode(e.target.value);
                                    setIsCouponApplied(false);
                                  }}
                                  className="form-control"
                                />
                                <button
                                  type="button"
                                  className="btn-apply"
                                  disabled={isSubmissionReadOnly}
                                  onClick={handleApplyNow}
                                >
                                  Apply Now
                                </button>
                              </div>
                              {isCouponApplied && (
                                <div className="coupon-success-message">
                                  Coupon applied successfully
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                    {preValues.articleType !== "" &&
                      articleTypeDesc.isShow === true && (
                        <div className="perspectiveToolWrap">
                          {/* <h2>{articleTypeDesc.name}</h2> */}
                          <div className="perspectiveTool">
                            <b
                              className="cross-icon"
                              onClick={closegetArticleTypeDesc}
                            ></b>
                            <b className="article-type">
                              {articleTypeDesc.name}
                            </b>
                            <p>{articleTypeDesc.desc} </p>
                          </div>
                        </div>
                      )}

                    {isSocityJournal === false &&
                      (preValues.disciplineType ===
                        "6454a75cab3a64f719e681c1" ||
                        preValues.disciplineType ===
                        "6454a75cab3a64f719e681c2") && (
                        <div className="otherSubjectBorder">
                          <div className="questionBox">
                            <span>
                              “Other” subject option can only be selected as a
                              part of primary journal.
                            </span>
                          </div>
                        </div>
                      )}

                    {isSocityJournal === false &&
                      preValues.disciplineType !== "" &&
                      preValues.disciplineType !==
                      "646b3a74636258312d34abcf" && (
                        <div className="mt-4">
                          <div className="primary-journal-divider">
                            <span>SECONDARY JOURNAL</span>
                          </div>
                          <div className="form-grid apc-grid">
                            <div className="form-field">
                              <label>
                                Journal Name<sup className="supStar">*</sup>
                              </label>
                              <div className="selectBox">
                                <Select
                                  disabled={isSubmissionReadOnly}
                                  selectedValue={preValues.secondaryJournalName}
                                  options={journalOptionsSecondry.map(
                                    (val) => val.journalName,
                                  )}
                                  optionValues={journalOptionsSecondry?.map(
                                    (val) => val.journalName,
                                  )}
                                  name="journalName"
                                  placeholder=""
                                  handleChange={(e) =>
                                    handleSelectChanges(
                                      e,
                                      "secondaryJournalName",
                                    )
                                  }
                                  required={true}
                                  mandatory={false}
                                />
                                {preValues.secondaryJournalNameError !== "" && (
                                  <div className="label-error">
                                    {preValues.secondaryJournalNameError}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="form-field">
                              <label>
                                Discipline<sup className="supStar">*</sup>
                              </label>
                              {preValues.secondaryJournalName ===
                                journalTypes.yogaJournal ? (
                                <div className="selectBox">
                                  <Select
                                    disabled={isSubmissionReadOnly}
                                    selectedValue={
                                      preValues.secondarySubject?._id
                                    }
                                    options={descplineSubjectSec?.map(
                                      (val) => val?.val,
                                    )}
                                    optionValues={descplineSubjectSec?.map(
                                      (val) => val?.key,
                                    )}
                                    name="subject"
                                    placeholder=""
                                    handleChange={(e) =>
                                      handleSelectChanges(e, "secondarySubject")
                                    }
                                    required={true}
                                    mandatory={false}
                                  />
                                  {preValues.secondarySubjectError !== "" && (
                                    <div className="label-error">
                                      {preValues.secondarySubjectError}
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <div className="inputTextBox">
                                  <Input
                                    errors=""
                                    name="specialization"
                                    readOnly={true}
                                    className="form-control grey-input"
                                    type="text"
                                    required={"required"}
                                    value={preValues.secondarySubjectName}
                                    placeholder="Discipline"
                                  />
                                </div>
                              )}
                            </div>

                            <div className="form-field">
                              <label>Subject</label>
                              <div className="selectBox">
                                <Select
                                  disabled={isSubmissionReadOnly}
                                  selectedValue={
                                    preValues.secondarySpecialization?._id ??
                                    preValues.secondarySpecialization
                                  }
                                  options={secondrySpecialization
                                    ?.filter(
                                      (element) =>
                                        element?.value !== otherSubjectTitle,
                                    )
                                    ?.map((val) => val?.value)}
                                  optionValues={secondrySpecialization?.map(
                                    (val) => val?.key,
                                  )}
                                  name="specialization"
                                  placeholder="Search and select"
                                  handleChange={(e) =>
                                    handleSelectChanges(
                                      e,
                                      "secondarySpecialization",
                                    )
                                  }
                                  required={true}
                                  mandatory={false}
                                  isSearchable={true}
                                />
                                {preValues.secondarySpecializationError !==
                                  "" && (
                                    <div className="label-error">
                                      {preValues.secondarySpecializationError}
                                    </div>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                  </>
                )}
                <div className="footer-inner-card mt-5">
                  <div className="brand-section">
                    <img src={crossref} alt="Crossref" />
                    <div className="divider"></div>
                    <div className="footer-links">
                      <Link
                        to="/author-submission-guidelines"
                        target="_blank"
                        style={{ color: "#ef5c23", textDecoration: "underline", textDecorationColor: "#ef5c23" }}
                      >
                        Author Guidelines
                      </Link>
                      <div className="divider"></div>
                      <Link
                        to={getJournalUrl()}
                        target="_blank"
                        style={{ color: "#ef5c23", textDecoration: "underline", textDecorationColor: "#ef5c23" }}
                      >
                        About the Journal
                      </Link>
                      <div className="divider"></div>
                      <Link
                        onClick={() => setShowMegaGuidelineModal(true)}
                        style={{ cursor: "pointer", color: "#ef5c23", textDecoration: "underline", textDecorationColor: "#ef5c23" }}
                      >
                        Mega Journal Formatting Guideline
                      </Link>
                    </div>
                  </div>
                  <div className="action-buttons">
                    <button
                      className="btn-save-outline"
                      type="button"
                      disabled={isSubmissionReadOnly}
                      onClick={() => {
                        if (preValues?.journalType === journalTypes.mega && localStorage.getItem("megaGuidelineAgreed") !== "true") {
                          toast.error("Please read and accept the Mega Journal Formatting Guidelines.");
                          return;
                        }
                        saveAndPay(1, "0");
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>
                <div className="text-end mt-3">
                  <span style={{ fontSize: "16px" }}>
                    <span
                      className="mandatory-star"
                      style={{ color: "#BF1E2E" }}
                    >
                      *
                    </span>{" "}
                    All fields are mandatory
                  </span>
                </div>
              </div>
              {/* <div className="footer-actions-container mt-5">
                <div className="action-buttons text-end">
                  <button
                    className="btn-save-outline me-3"
                    type="button"
                    onClick={() => saveAndPay(1)}
                  >
                    SAVE
                  </button>
                  <button
                    className="button button-primary"
                    type="button"
                    onClick={() => saveAndPay(2)}
                  >
                    SAVE AND CONTINUE
                  </button>
                </div>
              </div> */}
            </Accordion.Body>
          </Accordion.Item>
          {preValues.articleType === "664aed76ada7b4f743b760a9" ? (
            <Accordion.Item
              eventKey="1"
              className={!canOpenTab("1") ? "disabled" : ""}
            >
              <Accordion.Header onClick={() => handleAccordian("1")}>
                <p>
                  Conference Details
                  <sup className="supStar">*</sup>
                </p>
                <b className="">
                  {subjects.completedTabs.conference === false
                    ? subjects.isSocietyEditor
                      ? "Completed"
                      : "To be completed"
                    : "Completed"}0
                </b>
              </Accordion.Header>
              <Accordion.Body className="pt-0 pb-0">
                <div className="tabCenter">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="fieldWrap">
                        <label className="labelForm mt-2">
                          Name of Conference <sup className="supStar">*</sup>
                        </label>
                        <Input
                          errors={conferenceError?.conferenceName}
                          name={`fname`}
                          handleChange={(e) =>
                            handleConference(e, "nameConference")
                          }
                          className="fieldForm"
                          type="text"
                          required={"required"}
                          value={conference.conferenceName}
                          placeholder="Enter"
                        // readOnly={
                        //   (authorContent?.isMePrimaryAuthor === true &&
                        //     index === 0) ||
                        //   (authorContent?.isMePrimaryAuthor === false &&
                        //     index === 1)
                        // }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="fieldWrap">
                        <label className="labelForm mt-2">
                          City <sup className="supStar">*</sup>
                        </label>
                        <Input
                          errors={conferenceError?.city}
                          name={`fname`}
                          handleChange={(e) => handleConference(e, "city")}
                          className="fieldForm"
                          type="text"
                          required={"required"}
                          value={conference.city}
                          placeholder="Enter"
                        // readOnly={
                        //   (authorContent?.isMePrimaryAuthor === true &&
                        //     index === 0) ||
                        //   (authorContent?.isMePrimaryAuthor === false &&
                        //     index === 1)
                        // }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="fieldWrap">
                        <label className="labelForm mt-2">
                          Country <sup className="supStar">*</sup>
                        </label>
                        <div className="selectBox py-2 w-100">
                          <Select
                            disabled={isSubmissionReadOnly}
                            selectedValue={conference.country}
                            options={countrylist?.map((val) => val?.name)}
                            optionValues={countrylist?.map((val) => val?.name)}
                            name="country"
                            placeholder="Select or search country..."
                            isSearchable={true}
                            handleChange={(e) =>
                              handleSelectChanges(e, "countrylist")
                            }
                            required={true}
                            mandatory={false}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="fieldWrap">
                        <label className="labelForm mt-2">
                          URL of Conference Page{" "}
                          <sup className="supStar">*</sup>
                        </label>
                        <Input
                          errors={conferenceError?.url}
                          name={`fname`}
                          handleChange={(e) =>
                            handleConference(e, "urlConference")
                          }
                          className="fieldForm"
                          type="text"
                          required={"required"}
                          value={conference.url}
                          placeholder="Enter"
                        // readOnly={
                        //   (authorContent?.isMePrimaryAuthor === true &&
                        //     index === 0) ||
                        //   (authorContent?.isMePrimaryAuthor === false &&
                        //     index === 1)
                        // }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="fieldWrap">
                        <label className="labelForm mt-2">
                          Date of Conference Paper Presentation{" "}
                          <sup className="supStar">*</sup>
                        </label>
                        <div className="customdatepick py-2 w-100">
                          <DatePicker
                            onChange={handledatepicker}
                            getPopupContainer={(triggerNode) => {
                              return triggerNode.parentNode;
                            }}
                            defaultValue={defaultValuedate}
                            locale={buddhistLocale}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <span className="commanTitle02 d-block pt-5 pb-2">
                    Conference Chair<sup className="supStar">*</sup>
                  </span>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="fieldWrap">
                        <label className="labelForm">
                          Name of Conference Chair{" "}
                          <sup className="supStar">*</sup>
                        </label>
                        <Input
                          errors={conferenceError?.conferenceChairName}
                          name={`fname`}
                          handleChange={(e) =>
                            handleConference(e, "nameConferenceChair")
                          }
                          className="fieldForm"
                          type="text"
                          required={"required"}
                          value={conference.conferenceChairName}
                          placeholder="Enter"
                        // readOnly={
                        //   (authorContent?.isMePrimaryAuthor === true &&
                        //     index === 0) ||
                        //   (authorContent?.isMePrimaryAuthor === false &&
                        //     index === 1)
                        // }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="fieldWrap">
                        <label className="labelForm">
                          Email address of Conference Chair{" "}
                          <sup className="supStar">*</sup>
                        </label>
                        <Input
                          errors={conferenceError?.conferenceChairiEmail}
                          name={`fname`}
                          handleChange={(e) =>
                            handleConference(e, "emailConferenceChair")
                          }
                          className="fieldForm"
                          type="text"
                          required={"required"}
                          value={conference.conferenceChairiEmail}
                          placeholder="Enter"
                        // readOnly={
                        //   (authorContent?.isMePrimaryAuthor === true &&
                        //     index === 0) ||
                        //   (authorContent?.isMePrimaryAuthor === false &&
                        //     index === 1)
                        // }
                        />
                      </div>
                    </div>
                  </div>
                  <span className="commanTitle02 d-block pt-5 pb-2">
                    Track Chair<sup className="supStar">*</sup>
                  </span>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="fieldWrap">
                        <label className="labelForm">
                          Name of Track Chair <sup className="supStar">*</sup>
                        </label>
                        <Input
                          errors={conferenceError?.trackChairName}
                          name={`fname`}
                          handleChange={(e) =>
                            handleConference(e, "nameTrackChair")
                          }
                          className="fieldForm"
                          type="text"
                          required={"required"}
                          value={conference.trackChairName}
                          placeholder="Enter"
                        // readOnly={
                        //   (authorContent?.isMePrimaryAuthor === true &&
                        //     index === 0) ||
                        //   (authorContent?.isMePrimaryAuthor === false &&
                        //     index === 1)
                        // }
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="fieldWrap">
                        <label className="labelForm">
                          Email address of Track Chair{" "}
                          <sup className="supStar">*</sup>
                        </label>
                        <Input
                          errors={conferenceError?.trackChairEmail}
                          name={`fname`}
                          handleChange={(e) =>
                            handleConference(e, "emailTrackChair")
                          }
                          className="fieldForm"
                          type="text"
                          required={"required"}
                          value={conference.trackChairEmail}
                          placeholder="Enter"
                        // readOnly={
                        //   (authorContent?.isMePrimaryAuthor === true &&
                        //     index === 0) ||
                        //   (authorContent?.isMePrimaryAuthor === false &&
                        //     index === 1)
                        // }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          ) : null}
          {defaultActiveKey === "1" && (
            <div className="confirmFooter blueFooter">
              <div className="confirmContent">
                <h3>
                  CONFERENCE DETAILS: <b>TO BE SAVED</b>
                </h3>
              </div>
              <div className="confirmBtn">
                <button
                  className="button button-primary"
                  type="button"
                  disabled={isSubmissionReadOnly}
                  onClick={() => saveAndPay(1)}
                >
                  SAVE AND CONTINUE
                </button>
              </div>
            </div>
          )}
          <Accordion.Item
            eventKey="2"
            className={!canOpenTab("2") ? "disabled" : ""}
          >
            <Accordion.Header onClick={() => handleAccordian("2")}>
              <p>
                {preValues.articleType != "664aed76ada7b4f743b760a9"
                  ? "Article Processing Charge and Peer Review"
                  : "Conference Paper Submission"}
              </p>
              {subjects.completedTabs.review === true ||
                (subjects.preStepData?.reviewType?.typeOfReview &&
                  subjects.preStepData?.reviewType?.typeOfReview !== "") ? (
                <b className="">Completed</b>
              ) : (
                <b>
                  {subjects.isSocietyEditor ? "Completed" : "To be completed"}
                </b>
              )}
            </Accordion.Header>
            <Accordion.Body>
              <div className="mb-[14px]" style={{ marginBottom: "14px" }}>
                {isSocityJournal === true && (
                  <div className="contentReview">
                    {preValues.choiceOfReview?.prePublicationPeerReviewOnly &&
                      preValues.choiceOfReview?.onlyPostPublicationOpenReview ? (
                      <>
                        <p>
                          This society journal follows a{" "}
                          <b>pre-publication, double-anonymous peer review</b>{" "}
                          system. Every manuscript is evaluated independently by
                          qualified reviewers to ensure fairness, research
                          integrity, and editorial objectivity.
                        </p>
                        <br />
                        <p>
                          In addition to this mandatory review model, the
                          society also opens up the articles for{" "}
                          <b>post-publication peer review</b> for additional
                          expert evaluations after the article goes live.
                        </p>
                        <br />
                        <p>
                          Both review pathways follow the society’s quality
                          standards and are validated through the Aakashganga
                          Open platform.
                        </p>
                      </>
                    ) : preValues.choiceOfReview
                      ?.prePublicationPeerReviewOnly ? (
                      <>
                        <p>
                          This society journal follows a{" "}
                          <b>pre-publication, double-anonymous peer review</b>{" "}
                          system. Every manuscript is evaluated independently by
                          qualified reviewers to ensure fairness, research
                          integrity, and editorial objectivity.
                        </p>
                        <br />
                        <p>
                          This review pathway follows the society’s quality
                          standards and are validated through the Aakashganga
                          Open platform.
                        </p>
                      </>
                    ) : (
                      <>
                        <p>
                          This society journal follows a{" "}
                          <b>post-publication, double-anonymous peer review</b>{" "}
                          system. Every manuscript is evaluated independently by
                          qualified reviewers to ensure fairness, research
                          integrity, and editorial objectivity.
                        </p>
                        <br />
                        <p>
                          This review pathway follows the society’s quality
                          standards and are validated through the Aakashganga
                          Open platform.
                        </p>
                      </>
                    )}
                  </div>
                )}
                {isSocityJournal !== true &&
                  preValues.articleType != "664aed76ada7b4f743b760a9" && (
                    <div className="contentReview">
                      <p>
                        This Mega Journal follows a{" "}
                        <b>pre-publication, double-anonymous peer review </b>
                        system overseen by its Editorial Board and
                        Editor-in-Chief.
                      </p>
                      <br />
                      <p>
                        We use proprietary software to run evaluations and
                        screening for original content. All digital output is
                        confirmed by specialists. In addition to the primary
                        review, the article is also open for{" "}
                        <b>Post-Publication Review</b>. This feature becomes
                        available only if the article is published.
                      </p>
                      <br />
                      <p>
                        All reviews, editorial policies are designed, validated
                        and overseen by Aakashganga Open and the respective
                        Editorial Board.
                      </p>
                    </div>
                  )}
                {preValues.articleType != "664aed76ada7b4f743b760a9" ? (
                  <div
                    className="row"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div className="col-12 d-flex justify-content-center mb-0 apc-author-radio-row">
                      <div className="regardingRadio">
                        <div
                          className={`radioButtonCustom${apcPaymentOption === "society" ? " society-funded-label" : ""}`}
                        >
                          <div className="infoTextIcon">
                            <RadioButton
                              label={
                                apcPaymentOption === "society"
                                  ? "THIS ARTICLE IS FUNDED BY THE SOCIETY"
                                  : "THE APC IS PAID BY THE AUTHOR"
                              }
                              name="reviewType"
                              labelClass={" "}
                              id="pre-publication peer review only"
                              checked={true}
                              handleChange={handleReviewTypeChange}
                              required
                              disabled={subjects.completedTabs.review === true}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 pr-5 monthRemove">
                      <div className="regardingChkBox active">
                        <div className="articlePublishing">
                          ARTICLE PUBLISHING CHARGE
                        </div>
                        <hr className="mt-1" />
                        <div className="priceReview">
                          {isSocityJournal ? (
                            <ul>
                              <li className="priceReviewList">
                                <div className="priceReviewImg">
                                  <i className="priceIcon"></i>
                                  ORIGINAL PRICE
                                </div>
                                <div className="priceReviewRate">
                                  <span className="active">
                                    {ProfileDetails?.nationality ===
                                      "withInIndia"
                                      ? "INR " + APCData?.[0]?.lastPrice
                                      : ProfileDetails?.nationality ===
                                        "outSideIndia"
                                        ? "$" + APCData?.[1]?.lastPrice
                                        : APCData?.[1]?.lastPrice}
                                  </span>
                                </div>
                              </li>
                              <li className="priceReviewList saveprice">
                                <div className="priceReviewImg">
                                  <i className="saveIcon"></i>
                                  DISCOUNT OFFERED
                                </div>
                                <div className="priceReviewRate">
                                  {ProfileDetails?.nationality === "withInIndia"
                                    ? "INR " + APCData?.[0]?.saving
                                    : ProfileDetails?.nationality ===
                                      "outSideIndia"
                                      ? "$" + APCData?.[1]?.saving
                                      : APCData?.[1]?.saving}
                                </div>
                              </li>
                              <li className="priceReviewList">
                                <div className="priceReviewImg">
                                  <i className="roducIcon"></i>
                                  Final Price
                                </div>
                                <div className="priceReviewRate">
                                  <big>
                                    {ProfileDetails?.nationality ===
                                      "withInIndia"
                                      ? "INR " + APCData?.[0]?.introductoryPrice
                                      : ProfileDetails?.nationality ===
                                        "outSideIndia"
                                        ? "$" + APCData?.[1]?.introductoryPrice
                                        : APCData?.[1]?.introductoryPrice}
                                  </big>
                                </div>
                              </li>
                            </ul>
                          ) : (
                            <ul>
                              <li className="priceReviewList">
                                <div className="priceReviewImg">
                                  <i className="roducIcon"></i>
                                  Final Price
                                </div>
                                <div className="priceReviewRate">
                                  <big style={{ fontSize: "17px" }}>
                                    {ProfileDetails?.nationality ===
                                      "outSideIndia"
                                      ? "$99"
                                      : "INR 3999 (inclusive of 18% GST)"}
                                  </big>
                                </div>
                              </li>
                            </ul>
                          )}
                        </div>
                        {/* <div className="imp-info pt-0 pb-0">
                          <p>
                            Important Information
                            <div className="customTool">
                              {["bottom"].map((placement) => (
                                <OverlayTrigger
                                  key={placement}
                                  placement={placement}
                                  overlay={
                                    <Popover>
                                      <Popover.Body>
                                        <div className="popoverToolWrap ">
                                          <p>
                                            <sup className="supStar">*</sup>
                                            <i>
                                              The article turn-around time is
                                              within 45 days.
                                            </i>
                                          </p>
                                          <p>
                                            <sup className="supStar">*</sup>
                                            <i>
                                              The platform exercises the right
                                              to withdraw the offer anytime.
                                            </i>
                                          </p>
                                          <p>
                                            <sup className="supStar">*</sup>
                                            <i>
                                              All discount applied to the
                                              original amount will be applied at
                                              the final invoice stage.
                                            </i>
                                          </p>
                                          <p>
                                            <b>
                                              <sup className="supStar">*</sup>
                                              There is a one time registration
                                              charge of{" "}
                                              {ProfileDetails?.nationality ===
                                              "outSideIndia"
                                                ? "USD 50"
                                                : "INR 1000"}{" "}
                                              that will be refunded to your
                                              wallet as soon as your article is
                                              published. This is to prevent bots
                                              from accessing our system.
                                            </b>
                                          </p>
                                        </div>
                                      </Popover.Body>
                                    </Popover>
                                  }
                                >
                                  <img
                                    className="pe-cursor ps-1"
                                    src={vector}
                                    alt="no img"
                                  />
                                </OverlayTrigger>
                              ))}
                            </div>
                          </p>
                        </div> */}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="row justify-content-center">
                    <div className="col-12 d-flex justify-content-center mb-0 conference-paper-radio-row">
                      <div
                        className="regardingRadio"
                        style={{ marginBottom: "12px" }}
                      >
                        <div className="radioButtonCustom">
                          <div className="infoTextIcon">
                            <RadioButton
                              label="Conference Paper Submission"
                              name="reviewType"
                              labelClass={"Conference Paper Submission"}
                              id="Conference Paper Submission"
                              checked={true}
                              // disabled={
                              //   isSocityJournal ||
                              //   subjects.completedTabs.review === true
                              // }
                              handleChange={handleReviewTypeChange}
                              required
                            />
                            <div className="customTool">
                              {["bottom"].map((placement) => (
                                <OverlayTrigger
                                  key={placement}
                                  placement={placement}
                                  overlay={
                                    <Popover>
                                      <Popover.Body>
                                        <div className="popoverToolWrap ">
                                          <p>
                                            Please note that conference papers
                                            will only undergo post publishing
                                            review after acceptance.{" "}
                                          </p>
                                        </div>
                                      </Popover.Body>
                                    </Popover>
                                  }
                                >
                                  <img
                                    className="pe-cursor ps-1"
                                    src={vector}
                                    alt="no img"
                                  />
                                </OverlayTrigger>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="col-md-6 pl-5"
                      style={{ marginTop: "0px" }}
                    >
                      <div
                        className={
                          preValues.reviewType ===
                            "only post-publication open review"
                            ? "regardingChkBox active"
                            : "regardingChkBox"
                        }
                      >
                        <div className="priceReview">
                          <ul>
                            <li className="priceReviewList">
                              <div className="priceReviewImg">
                                <i className="priceIcon"></i>
                                Article Processing Charge:
                              </div>
                              <div className="priceReviewRate">
                                <del>
                                  {ProfileDetails?.nationality === "withInIndia"
                                    ? "INR " + APCData?.[3]?.lastPrice
                                    : ProfileDetails?.nationality ===
                                      "outSideIndia"
                                      ? "$" + APCData?.[3]?.lastPrice
                                      : APCData?.[3]?.lastPrice}
                                </del>
                              </div>
                            </li>
                            <li className="priceReviewList saveprice">
                              <div className="priceReviewImg">
                                <i className="saveIcon"></i>
                                Introductory Discount:
                              </div>
                              <div className="priceReviewRate">
                                {ProfileDetails?.nationality === "withInIndia"
                                  ? "INR " + APCData?.[3]?.saving
                                  : ProfileDetails?.nationality ===
                                    "outSideIndia"
                                    ? "$" + APCData?.[3]?.saving
                                    : APCData?.[3]?.saving}
                              </div>
                            </li>
                            <li className="priceReviewList">
                              <div className="priceReviewImg">
                                <i className="roducIcon"></i>
                                Introductory Price:
                              </div>
                              <div className="priceReviewRate">
                                <big>
                                  {ProfileDetails?.nationality === "withInIndia"
                                    ? "INR " + APCData?.[3]?.introductoryPrice
                                    : ProfileDetails?.nationality ===
                                      "outSideIndia"
                                      ? "$" + APCData?.[3]?.introductoryPrice
                                      : APCData?.[3]?.introductoryPrice}
                                </big>
                              </div>
                            </li>
                          </ul>
                        </div>
                        {preValues.articleType !=
                          "664aed76ada7b4f743b760a9" && (
                            <>
                              <div className="imp-info pt-0 pb-0">
                                <p>
                                  Important Information
                                  <div className="customTool">
                                    {["bottom"].map((placement) => (
                                      <OverlayTrigger
                                        key={placement}
                                        placement={placement}
                                        overlay={
                                          <Popover>
                                            <Popover.Body>
                                              <div className="popoverToolWrap ">
                                                <p>
                                                  <sup className="supStar">*</sup>
                                                  <i>
                                                    The article turn-around time
                                                    is within 30 days.
                                                  </i>
                                                </p>
                                                <p>
                                                  <sup className="supStar">*</sup>
                                                  <i>
                                                    The platform exercises the
                                                    right to withdraw the offer
                                                    anytime.
                                                  </i>
                                                </p>
                                                <p>
                                                  <sup className="supStar">*</sup>
                                                  <i>
                                                    All discount applied to the
                                                    original amount will be
                                                    applied at the final invoice
                                                    stage.
                                                  </i>
                                                </p>
                                                <p>
                                                  <b>
                                                    <sup className="supStar">
                                                      *
                                                    </sup>
                                                    There is a one time
                                                    registration charge of{" "}
                                                    {ProfileDetails?.nationality ===
                                                      "outSideIndia"
                                                      ? "USD 50"
                                                      : "INR 1000"}{" "}
                                                    that will be refunded to your
                                                    wallet as soon as your article
                                                    is published. This is to
                                                    prevent bots from accessing
                                                    our system.
                                                  </b>
                                                </p>
                                              </div>
                                            </Popover.Body>
                                          </Popover>
                                        }
                                      >
                                        <img
                                          className="pe-cursor ps-1"
                                          src={vector}
                                          alt="no img"
                                        />
                                      </OverlayTrigger>
                                    ))}
                                  </div>
                                </p>
                              </div>
                            </>
                          )}
                      </div>
                    </div>
                  </div>
                )}
                {subjects.prePaymentStatus === true && (
                  <div className="paymentSuccessWrap">
                    <div className="paymentSuccessText">
                      <img src={successful} /> Article Registration Payment
                      Successful
                    </div>
                    <div className="paymentSuccessTool">
                      Download Invoice
                      <div className="customTool">
                        {["bottom"].map((placement) => (
                          <OverlayTrigger
                            key={placement}
                            placement={placement}
                            overlay={
                              <Popover>
                                <Popover.Body>
                                  <div className="popoverToolWrap">
                                    <p>PEER REVIEW</p>
                                  </div>
                                </Popover.Body>
                              </Popover>
                            }
                          >
                            <img
                              className="pe-cursor ps-1"
                              src={vector}
                              alt="no img"
                            />
                          </OverlayTrigger>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                <div className="apc-covers-container mt-4">
                  <div className="primary-journal-divider">
                    <span>THE APC COVERS</span>
                  </div>
                  <div className="apc-points-grid">
                    {isSocityJournal !== true ? (
                      <>
                        <div className="apc-point">
                          <div className="apc-check-icon-wrapper">
                            <img
                              src={circle}
                              className="apc-circle"
                              alt="circle"
                            />
                            <img src={tick} className="apc-tick" alt="tick" />
                          </div>
                          <span>Evaluation and screening</span>
                        </div>
                        <div className="apc-point">
                          <div className="apc-check-icon-wrapper">
                            <img
                              src={circle}
                              className="apc-circle"
                              alt="circle"
                            />
                            <img src={tick} className="apc-tick" alt="tick" />
                          </div>
                          <span>Similarity Index Check</span>
                        </div>
                        <div className="apc-point">
                          <div className="apc-check-icon-wrapper">
                            <img
                              src={circle}
                              className="apc-circle"
                              alt="circle"
                            />
                            <img src={tick} className="apc-tick" alt="tick" />
                          </div>
                          <span>Editorial Review and Publishing Decision</span>
                        </div>
                        <div className="apc-point">
                          <div className="apc-check-icon-wrapper">
                            <img
                              src={circle}
                              className="apc-circle"
                              alt="circle"
                            />
                            <img src={tick} className="apc-tick" alt="tick" />
                          </div>
                          <span>
                            Long term open-access hosting and archiving
                          </span>
                        </div>
                        <div className="apc-point">
                          <div className="apc-check-icon-wrapper">
                            <img
                              src={circle}
                              className="apc-circle"
                              alt="circle"
                            />
                            <img src={tick} className="apc-tick" alt="tick" />
                          </div>
                          <span>Indexing in appropriate databases</span>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="apc-point">
                          <div className="apc-check-icon-wrapper">
                            <img
                              src={circle}
                              className="apc-circle"
                              alt="circle"
                            />
                            <img src={tick} className="apc-tick" alt="tick" />
                          </div>
                          <span>Manuscript screening and integrity checks</span>
                        </div>
                        <div className="apc-point">
                          <div className="apc-check-icon-wrapper">
                            <img
                              src={circle}
                              className="apc-circle"
                              alt="circle"
                            />
                            <img src={tick} className="apc-tick" alt="tick" />
                          </div>
                          <span>
                            Language, grammar and similarity index check
                          </span>
                        </div>
                        <div className="apc-point">
                          <div className="apc-check-icon-wrapper">
                            <img
                              src={circle}
                              className="apc-circle"
                              alt="circle"
                            />
                            <img src={tick} className="apc-tick" alt="tick" />
                          </div>
                          <span>
                            Peer review management and editorial processing
                          </span>
                        </div>
                        <div className="apc-point">
                          <div className="apc-check-icon-wrapper">
                            <img
                              src={circle}
                              className="apc-circle"
                              alt="circle"
                            />
                            <img src={tick} className="apc-tick" alt="tick" />
                          </div>
                          <span>Long-term open-access hosting</span>
                        </div>
                        <div className="apc-point">
                          <div className="apc-check-icon-wrapper">
                            <img
                              src={circle}
                              className="apc-circle"
                              alt="circle"
                            />
                            <img src={tick} className="apc-tick" alt="tick" />
                          </div>
                          <span>
                            Production, design and author/society dashboards
                          </span>
                        </div>
                        <div className="apc-point">
                          <div className="apc-check-icon-wrapper">
                            <img
                              src={circle}
                              className="apc-circle"
                              alt="circle"
                            />
                            <img src={tick} className="apc-tick" alt="tick" />
                          </div>
                          <span>
                            Indexed in OpenAlex, Google Scholar, and key OA
                            indexes
                          </span>
                        </div>
                        <div className="apc-point">
                          <div className="apc-check-icon-wrapper">
                            <img
                              src={circle}
                              className="apc-circle"
                              alt="circle"
                            />
                            <img src={tick} className="apc-tick" alt="tick" />
                          </div>
                          <span>DOI & index registration</span>
                        </div>
                        <div className="apc-point">
                          <div className="apc-check-icon-wrapper">
                            <img
                              src={circle}
                              className="apc-circle"
                              alt="circle"
                            />
                            <img src={tick} className="apc-tick" alt="tick" />
                          </div>
                          <span>Reader access & discovery tools</span>
                        </div>
                        <div className="apc-point">
                          <div className="apc-check-icon-wrapper">
                            <img
                              src={circle}
                              className="apc-circle"
                              alt="circle"
                            />
                            <img src={tick} className="apc-tick" alt="tick" />
                          </div>
                          <span>Hosting & server infrastructure</span>
                        </div>
                        <div className="apc-point">
                          <div className="apc-check-icon-wrapper">
                            <img
                              src={circle}
                              className="apc-circle"
                              alt="circle"
                            />
                            <img src={tick} className="apc-tick" alt="tick" />
                          </div>
                          <span>Archiving & preservation</span>
                        </div>
                      </>
                    )}
                  </div>

                  {isSocityJournal === true && isMWPOnly && (
                    <div className="primary-journal-divider mt-4">
                      <span>PAYMENT STRUCTURE</span>
                    </div>
                  )}
                  {isSocityJournal === true && isMWPOnly && (
                    <div className="payment-structure-list">
                      <div className="payment-point">
                        <div className="apc-check-icon-wrapper">
                          <img
                            src={circle}
                            className="apc-circle"
                            alt="circle"
                          />
                          <img src={tick} className="apc-tick" alt="tick" />
                        </div>
                        <span>
                          A registration amount of{" "}
                          {ProfileDetails?.nationality === "outSideIndia"
                            ? "USD 50"
                            : "INR 1,000"}{" "}
                          is payable at the time of submission.
                        </span>
                      </div>
                      <div className="payment-point">
                        <div className="apc-check-icon-wrapper">
                          <img
                            src={circle}
                            className="apc-circle"
                            alt="circle"
                          />
                          <img src={tick} className="apc-tick" alt="tick" />
                        </div>
                        <span>
                          After your manuscript clears editorial screening and
                          peer review, the remaining fee becomes due.
                        </span>
                      </div>
                      <div className="payment-point">
                        <div className="apc-check-icon-wrapper">
                          <img
                            src={circle}
                            className="apc-circle"
                            alt="circle"
                          />
                          <img src={tick} className="apc-tick" alt="tick" />
                        </div>
                        <span>
                          The final APC must be completed before the article
                          enters production and publication.
                        </span>
                      </div>
                      <div className="payment-point">
                        <div className="apc-check-icon-wrapper">
                          <img
                            src={circle}
                            className="apc-circle"
                            alt="circle"
                          />
                          <img src={tick} className="apc-tick" alt="tick" />
                        </div>
                        <span>
                          If your article is not accepted for publication, the{" "}
                          {ProfileDetails?.nationality === "outSideIndia"
                            ? "USD 50"
                            : "INR 1,000"}{" "}
                          registration amount is refunded to your mudra kosh
                          wallet.
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="apc-footer">
                    <div className="footer-left">
                      <img
                        src={crossref}
                        alt="Crossref DOI"
                        className="crossref-logo"
                      />
                      <div className="footer-divider"></div>
                      <div className="footer-links">
                        <Link
                          to="/publishing-editor-roles-and-responsibilities"
                          target="_blank"
                        >
                          Editor Responsibilities
                        </Link>
                        <div className="footer-divider"></div>
                        <Link to="/ethics-policy" target="_blank">
                          Publishing Information
                        </Link>
                      </div>
                    </div>
                    <button
                      className="save-btn"
                      disabled={isSubmissionReadOnly}
                      onClick={() => saveAndPay(1)}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>

          {defaultActiveKey === "2" &&
            (() => {
              const isMega =
                preValues.journalType === "6454a6390d88e62fa10503be" ||
                !isSocityJournal;
              const finalPriceIndia = isMega
                ? 3999
                : isSocityJournal
                  ? APCData?.[0]?.introductoryPrice || 0
                  : APCData?.[0]?.introductoryPrice || 0;
              const remainingIndia = isMega ? 3999 : finalPriceIndia - 1000;
              const finalPriceUSD = isSocityJournal
                ? APCData?.[1]?.introductoryPrice || 0
                : 99;
              const conferenceFinalIndia = APCData?.[3]?.introductoryPrice || 0;
              const conferenceRemainingIndia = conferenceFinalIndia - 1000;
              const conferenceFinalUSD = APCData?.[3]?.introductoryPrice || 0;
              const currentJournalName = preValues.journal?.trim()?.toLowerCase();
              const isMWP =
                currentJournalName === "minorities in world politics" ||
                currentJournalName === "community learning and social transformation" ||
                currentJournalName === "applied and basic obesity, diabetes and endocrinology";
              return (
                <div className="confirmFooter blueFooter">
                  <div className="confirmContent">
                    {isMega ? (
                      <>
                        <h3>
                          ARTICLE PROCESSING CHARGE:{" "}
                          <b>
                            {ProfileDetails?.nationality === "outSideIndia"
                              ? "USD"
                              : "INR"}{" "}
                            {ProfileDetails?.nationality === "outSideIndia"
                              ? finalPriceUSD
                              : remainingIndia}
                          </b>
                        </h3>
                        <div>
                          <div className="confirm-finger-row">
                            <img src={finger} alt="arrow" />
                            <span>
                              You may also be eligible for additional grants and
                              discounts
                            </span>
                          </div>
                          <div className="confirm-finger-row">
                            <img src={finger} alt="arrow" />
                            <span>
                              All offers and fees payable will be available
                              AFTER the article is accepted for publication. You
                              will not be asked for payment in advance
                            </span>
                          </div>
                        </div>
                      </>
                    ) : isSocityJournal && apcPaymentOption === "society" ? (
                      isMWPOnly ? (
                        <>
                          <h3>
                            THE ARTICLE PROCESSING CHARGE IS PAID BY THE SOCIETY
                          </h3>
                          <div>
                            <div className="confirm-finger-row">
                              <img src={finger} alt="arrow" />
                              <span>
                                For any queries regarding the APC, please contact
                                the editorial office.
                              </span>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <h3>THE APC IS PAID BY THE SOCIETY</h3>
                        </>
                      )
                    ) : (
                      <>
                        <h3>
                          ARTICLE REGISTRATION PAYMENT:{" "}
                          <b>
                            {ProfileDetails?.nationality === "outSideIndia"
                              ? "USD"
                              : "INR"}{" "}
                            {apcPaymentOption === "society" && !isMWP
                              ? ProfileDetails?.nationality === "outSideIndia"
                                ? preValues.articleType ===
                                  "664aed76ada7b4f743b760a9"
                                  ? conferenceFinalUSD
                                  : finalPriceUSD
                                : preValues.articleType ===
                                  "664aed76ada7b4f743b760a9"
                                  ? conferenceFinalIndia
                                  : finalPriceIndia
                              : ProfileDetails?.nationality === "outSideIndia"
                                ? preValues.articleType ===
                                  "664aed76ada7b4f743b760a9"
                                  ? conferenceFinalUSD -
                                  (APCData?.[2]?.introductoryPrice || 0)
                                  : finalPriceUSD -
                                  (APCData?.[2]?.introductoryPrice || 0)
                                : 1000}
                          </b>
                        </h3>
                        <p>
                          {apcPaymentOption === "society" && !isMWP ? (
                            "This payment is fully sponsored by the society for accepted articles."
                          ) : (
                            <>
                              The remaining balance of{" "}
                              {ProfileDetails?.nationality === "outSideIndia"
                                ? "USD"
                                : "INR"}{" "}
                              {ProfileDetails?.nationality === "outSideIndia"
                                ? preValues.articleType ===
                                  "664aed76ada7b4f743b760a9"
                                  ? conferenceFinalUSD
                                  : finalPriceUSD
                                : preValues.articleType ===
                                  "664aed76ada7b4f743b760a9"
                                  ? conferenceRemainingIndia
                                  : remainingIndia}{" "}
                              will be charged after the final editorial review
                            </>
                          )}
                        </p>
                      </>
                    )}
                  </div>
                  <div className="confirmBtn">
                    <button
                      className="button button-primary"
                      type="button"
                      disabled={isSubmissionReadOnly}
                      onClick={() => saveAndPay(1)}
                    >
                      Save & Continue
                    </button>
                  </div>
                </div>
              );
            })()}

          <Accordion.Item
            eventKey="3"
            className={!canOpenTab("3") ? "disabled" : ""}
          >
            <Accordion.Header onClick={() => handleAccordian("3")}>
              <p
                style={{
                  color: defaultActiveKey === "3" ? "#E76341" : "",
                }}
              >
                Authors and contributors
              </p>

              {subjects.completedTabs.author === false && (
                <b>
                  {subjects.isSocietyEditor ? "Completed" : "To be completed"}
                </b>
              )}
              {subjects.completedTabs.author === true && (
                <b className="">Completed</b>
              )}
            </Accordion.Header>
            <Accordion.Body>
              <div className="contributorsBody">
                {authorCount.map((num, index) => (
                  <React.Fragment key={`authr${num}`}>
                    <div
                      className={`contributorsDetails position-relative ${index === 0 ? "primaryAuthorBox" : ""
                        }`}
                      style={{
                        border: "1px dashed #006F94",
                        padding: "40px 80px 40px 80px",
                        borderRadius: "10px",
                        marginBottom: "20px",
                        marginTop: index > 0 ? "20px" : "0",
                      }}
                    >
                      {index === 0 && (
                        <div className="contributorsTitle">
                          <div
                            className="d-flex justify-content-between align-items-center w-100 mb-3"
                            style={{ flexWrap: "wrap", gap: "10px" }}
                          >
                            <h3
                              style={{ margin: "0 0 16px 0", color: "#006F94" }}
                            >
                              PRIMARY AUTHOR DETAILS
                            </h3>
                            <div className="d-flex align-items-center gap-3 mb-10">
                              {preValues.articleType ===
                                "664aed76ada7b4f743b760a9" ? null : (
                                <>
                                  <label className="customCheck mb-0">
                                    <Checkbox
                                      onRadioChange={
                                        handlePrimaryAuthorCheckbox
                                      }
                                      name="isReviwer"
                                      checked={
                                        !authorContent?.isMePrimaryAuthor
                                      }
                                      className="form-check-input"
                                    />

                                    <i></i>
                                    <b
                                      style={{
                                        fontWeight: "normal",
                                        margin: "0 0 20px 0",
                                      }}
                                    >
                                      I am not the Primary Author
                                    </b>
                                    <div
                                      className="customTool"
                                      style={{
                                        display: "inline-block",
                                        marginLeft: "6px",
                                      }}
                                    >
                                      {["bottom"].map((placement) => (
                                        <OverlayTrigger
                                          key={placement}
                                          placement={placement}
                                          overlay={
                                            <Popover>
                                              <Popover.Body>
                                                <div className="popoverToolWrap">
                                                  <p>
                                                    If you are not the Primary
                                                    Author, please check the
                                                    box, ‘I am not the Primary
                                                    Author’. Your details will
                                                    be automatically populated
                                                    under the ‘Secondary Author’
                                                    section. At this stage, you
                                                    are required to fill in the
                                                    details of the Primary
                                                    Author, to move ahead with
                                                    your submission.{" "}
                                                  </p>
                                                </div>
                                              </Popover.Body>
                                            </Popover>
                                          }
                                        >
                                          <img
                                            className="pe-cursor ps-1 mt-[-10px]"
                                            src={vector}
                                            alt="no img"
                                          />
                                        </OverlayTrigger>
                                      ))}
                                    </div>
                                  </label>
                                </>
                              )}
                              <div
                                className="helpText"
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  color: "#333",
                                  marginBottom: "2px",
                                }}
                                onClick={() => setneedHelpPopup(true)}
                              >
                                Need Help?
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {index == 1 && (
                        <div className="contributorsTitle secondryAuthor">
                          <h3>
                            SECONDARY AUTHOR DETAILS
                            <sup className="supStar">*</sup>
                          </h3>
                        </div>
                      )}
                      {index > 1 && (
                        <div className="contributorsTitle secondryAuthor">
                          <h3>
                            Other AUTHOR DETAILS<sup className="supStar">*</sup>
                          </h3>
                        </div>
                      )}
                      <div>
                        {/* Row 1: Title and Full Name */}
                        <div className="d-flex w-100 gap-4 mb-10">
                          <div className="defaultInput title w-100">
                            <label>Title</label>
                            <div className="selectBox">
                              <Select
                                selectedValue={
                                  authorContent?.authorTitle[index].val
                                }
                                options={editorTitleOptionsNew?.map(
                                  (val) => val?.key,
                                )}
                                optionValues={editorTitleOptionsNew?.map(
                                  (val) => val?.value,
                                )}
                                name={`title${index}`}
                                placeholder=""
                                handleChange={(e) =>
                                  handleauthorInput(e, index, "title")
                                }
                                required={true}
                                mandatory={false}
                                disabled={
                                  isSubmissionReadOnly ||
                                  (authorContent?.isMePrimaryAuthor === true &&
                                    index === 0) ||
                                  (authorContent?.isMePrimaryAuthor === false &&
                                    index === 1)
                                }
                              />
                              {authorError?.authorTitleError[index] !== "" && (
                                <div class="label-error">
                                  {authorError?.authorTitleError[index]}
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="defaultInput w-100">
                            <label>Full Name</label>

                            <Input
                              errors={authorError?.authornameError[index]}
                              name={`fname${index}`}
                              handleChange={(e) =>
                                handleauthorInput(e, index, "name")
                              }
                              className="fieldForm"
                              type="text"
                              required={"required"}
                              value={authorContent?.authorname[index].val}
                              placeholder="Enter"
                              readOnly={
                                (authorContent?.isMePrimaryAuthor === true &&
                                  index === 0) ||
                                (authorContent?.isMePrimaryAuthor === false &&
                                  index === 1)
                              }
                            />
                          </div>
                        </div>

                        {/* Row 2: Email ID and Institution */}
                        <div
                          className="d-flex w-100 gap-4"
                          style={{ marginTop: index > 0 ? "32px" : "16px" }}
                        >
                          <div className="defaultInput w-100">
                            <label>Email ID</label>
                            <Input
                              errors={authorError?.authorEmailError[index]}
                              name={`email${index}`}
                              handleChange={(e) =>
                                handleauthorInput(e, index, "email")
                              }
                              className="fieldForm"
                              type="text"
                              required={"required"}
                              value={authorContent?.authorEmail[index].val}
                              placeholder="Enter"
                              readOnly={
                                (authorContent?.isMePrimaryAuthor === true &&
                                  index === 0) ||
                                (authorContent?.isMePrimaryAuthor === false &&
                                  index === 1)
                              }
                            />
                          </div>
                          <div className="defaultInput w-100">
                            <label>Affiliated Institution/University</label>
                            <Input
                              errors={authorError?.authorUniversityError[index]}
                              name={`university${index}`}
                              handleChange={(e) =>
                                handleauthorInput(e, index, "university")
                              }
                              className="fieldForm"
                              type="text"
                              required={"required"}
                              value={authorContent?.authorUniversity[index].val}
                              placeholder="Enter"
                              readOnly={
                                (authorContent?.isMePrimaryAuthor === true &&
                                  index === 0) ||
                                (authorContent?.isMePrimaryAuthor === false &&
                                  index === 1)
                              }
                            />
                          </div>
                        </div>

                        {/* Row 3: Department and ORCiD */}
                        <div
                          className="d-flex w-100 gap-4"
                          style={{ marginTop: index > 0 ? "28px" : "16px" }}
                        >
                          <div className="defaultInput w-100">
                            <label>Affiliated Department</label>
                            <Input
                              errors={authorError?.authorDepartmentError[index]}
                              name={`department${index}`}
                              handleChange={(e) =>
                                handleauthorInput(e, index, "department")
                              }
                              className="fieldForm"
                              type="text"
                              required={"required"}
                              value={authorContent?.authorDepartment[index].val}
                              placeholder="Enter"
                              readOnly={
                                (authorContent?.isMePrimaryAuthor === true &&
                                  index === 0) ||
                                (authorContent?.isMePrimaryAuthor === false &&
                                  index === 1)
                              }
                            />
                          </div>
                          <div className="defaultInput w-100">
                            <label>
                              ORCiD ID
                              <div className="customTool">
                                {["bottom"].map((placement) => (
                                  <OverlayTrigger
                                    key={placement}
                                    placement={placement}
                                    overlay={
                                      <Popover>
                                        <Popover.Body>
                                          <div className="popoverToolWrap">
                                            <p>
                                              We encourage you to provide your
                                              ORCID iDs as it helps identify
                                              researchers ensuring proper
                                              attribution, safeguarding against
                                              mistaken identity and plagiarism.
                                              If you don’t have an ORCiD id,
                                              create one now:{" "}
                                              <u>https://orcid.org/</u>
                                            </p>
                                            <br />
                                            <p>
                                              As the scholarly landscape becomes
                                              increasingly digital and
                                              interconnected, embracing ORCID
                                              iDs aligns with the modernization
                                              of research practices, solidifying
                                              researchers' profiles and enabling
                                              them to actively participate in a
                                              dynamic and globally collaborative
                                              academic ecosystem.
                                            </p>
                                          </div>
                                        </Popover.Body>
                                      </Popover>
                                    }
                                  >
                                    <img
                                      className="pe-cursor ps-1"
                                      src={vector}
                                      alt="no img"
                                    />
                                  </OverlayTrigger>
                                ))}
                              </div>
                            </label>
                            <Input
                              errors={""}
                              name={`orcid${index}`}
                              handleChange={(e) =>
                                handleauthorInput(e, index, "orcid")
                              }
                              className="fieldForm"
                              type="text"
                              required={"required"}
                              value={authorContent?.authorOrcidID[index].val}
                              placeholder="Enter"
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "0 20px",
                      }}
                    >
                      {/* Add Co-Author (Only on last item) */}
                      {index === authorCount.length - 1 &&
                        preValues.articleType !==
                        "664aed76ada7b4f743b760a9" && (
                          <div
                            style={{
                              color: "#006F94",
                              fontWeight: "bold",
                              cursor: "pointer",
                            }}
                            onClick={() => addMoreAuthor()}
                          >
                            + ADD CO-AUTHOR
                          </div>
                        )}

                      {/* Action Buttons Row - only for co-authors (index > 0) */}
                      {index > 0 && (
                        <div
                          className="d-flex align-items-center mt-3"
                          style={{ gap: "20px" }}
                        >
                          {/* Remove Details */}
                          <div
                            style={{
                              color: "#006F94",
                              textDecoration: "underline",
                              cursor: "pointer",
                              fontWeight: "500",
                              fontSize: "16px",
                            }}
                            onClick={() => removeAuthorInputs(index)}
                          >
                            Remove Details
                          </div>
                        </div>
                      )}
                    </div>
                  </React.Fragment>
                ))}

                <div
                  className="statementWrap authorStatement noBorderTop"
                  style={{
                    border: "1px dashed #0093CB",
                    borderRadius: "10px",
                    padding: "20px",
                    marginTop: "30px",
                    marginLeft: "0",
                    width: "100%",
                  }}
                >
                  <div className="defaultInput">
                    <label
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span>
                        <b
                          style={{
                            color: "#006F94",
                            fontSize: "16px",
                            fontWeight: "600",
                            textTransform: "uppercase",
                            marginLeft: "56px",
                          }}
                        >
                          Author/s contribution statement
                        </b>
                        <div className="customTool">
                          {["bottom"].map((placement) => (
                            <OverlayTrigger
                              key={placement}
                              placement={placement}
                              overlay={
                                <Popover className="authorGuidelinesPopover">
                                  <Popover.Body>
                                    <div className="popoverToolWrap">
                                      <h2>
                                        Author Contribution Guidelines
                                        <span className="close-popover">×</span>
                                      </h2>
                                      <p>
                                        Please add information about the
                                        contribution of each author. The
                                        statement can be up to several sentences
                                        long, describing the tasks of individual
                                        authors. For more information on author
                                        contribution statement, please refer to
                                        our{" "}
                                        <Link
                                          to="/author-submission-guidelines"
                                          target="_blank"
                                        >
                                          Author Guidelines
                                        </Link>
                                        .
                                      </p>
                                      <p>
                                        The author contributor statement
                                        typically includes information about the
                                        following:
                                      </p>
                                      <ol>
                                        <li>
                                          Conceptualization and design of the
                                          study
                                        </li>
                                        <li>Acquisition of data</li>
                                        <li>
                                          Analysis and interpretation of data
                                        </li>
                                        <li>Drafting of the manuscript</li>
                                        <li>
                                          Critical revision of the manuscript
                                        </li>
                                        <li>
                                          Approval of the final version of the
                                          manuscript for submission
                                        </li>
                                      </ol>
                                      <p>
                                        Overall, the author contributor
                                        statement is an important component of a
                                        research article, and it helps to ensure
                                        that the research process is transparent
                                        and accountable.
                                      </p>
                                    </div>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              <img
                                className="pe-cursor ps-1"
                                src={vector}
                                alt="no img"
                              />
                            </OverlayTrigger>
                          ))}
                        </div>
                      </span>
                      <span style={{ marginRight: "51px", font: "400" }}>
                        <b>Word Limit</b>: 300
                      </span>
                    </label>
                    <Textarea
                      name="contribution"
                      rows="4"
                      className="form-control grey-input title"
                      placeholder="Give your statement"
                      value={authorContent.contributionStatement}
                      onChange={(e) => {
                        handleauthorInput(e.target.value, 0, "contribution");
                      }}
                    />
                    {authorError.contributionStatementError !== "" && (
                      <div className="label-error">
                        {authorError.contributionStatementError}
                      </div>
                    )}
                  </div>

                  <div className="footer-inner-card mt-5">
                    <div className="brand-section">
                      <img src={crossref} alt="Crossref" />
                      <div className="divider"></div>
                      <div className="footer-links">
                        <Link
                          to="/author-submission-guidelines"
                          target="_blank"
                          style={{ color: "#ef5c23", textDecoration: "underline", textDecorationColor: "#ef5c23" }}
                        >
                          Author Guidelines
                        </Link>
                        <div className="divider"></div>
                        <Link
                          to={getJournalUrl()}
                          target="_blank"
                          style={{ color: "#ef5c23", textDecoration: "underline", textDecorationColor: "#ef5c23" }}
                        >
                          About the Journal
                        </Link>
                        <div className="divider"></div>
                        <Link
                          onClick={() => setShowMegaGuidelineModal(true)}
                          style={{ cursor: "pointer", color: "#ef5c23", textDecoration: "underline", textDecorationColor: "#ef5c23" }}
                        >
                          Mega Journal Formatting Guideline
                        </Link>
                      </div>
                    </div>
                    <div className="action-buttons">
                      <button
                        className="btn-save-outline"
                        disabled={isSubmissionReadOnly}
                        onClick={() => {
                          if (preValues?.journalType === journalTypes.mega && localStorage.getItem("megaGuidelineAgreed") !== "true") {
                            toast.error("Please read and accept the Mega Journal Formatting Guidelines.");
                            return;
                          }
                          saveAndPay(1);
                        }}
                        type="button"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  <div className="text-end mt-3">
                    <span style={{ fontSize: "16px" }}>
                      <span
                        className="mandatory-star"
                        style={{ color: "#BF1E2E" }}
                      >
                        *
                      </span>{" "}
                      All fields are mandatory
                    </span>
                  </div>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
          {defaultActiveKey === "3" && (
            <div className="confirmFooter blueFooter">
              <div className="confirmContent">
                {preValues.articleType === "664aed76ada7b4f743b760a9" ? (
                  <h3>
                    CONFERENCE DETAILS: <b>TO BE SAVED</b>
                  </h3>
                ) : (
                  <>
                    {preValues.journal?.trim()?.toLowerCase() ===
                      "minorities in world politics" &&
                      apcPaymentOption === "self" ? (
                      <>
                        <h3>
                          {isSocityJournal ? "REMAINING " : ""}ARTICLE
                          PROCESSING CHARGE: INR 6499{" "}
                          <span style={{ textTransform: "lowercase" }}>
                            plus
                          </span>{" "}
                          GST
                        </h3>
                        <div>
                          <div className="confirm-finger-row">
                            <span>
                              For any questions regarding the submission, please
                              write to{" "}
                              <span
                                style={{
                                  color: "#ffffff",
                                  textDecoration: "underline",
                                }}
                              >
                                journal.mwp@gmail.com
                              </span>
                            </span>
                          </div>
                        </div>
                      </>
                    ) : isSocityJournal && apcPaymentOption === "society" ? (
                      isMWPOnly ? (
                        <>
                          <h3>
                            THE ARTICLE PROCESSING CHARGE IS PAID BY THE SOCIETY
                          </h3>
                          <div>
                            <div className="confirm-finger-row">
                              <img src={finger} alt="arrow" />
                              <span>
                                For any queries regarding the APC, please contact
                                the editorial office.
                              </span>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <h3>THE APC IS PAID BY THE SOCIETY</h3>
                        </>
                      )
                    ) : (
                      <>
                        <h3>
                          {isSocityJournal ? "Remaining " : ""}ARTICLE
                          PROCESSING CHARGE:{" "}
                          <b>
                            {ProfileDetails?.nationality === "outSideIndia"
                              ? "USD"
                              : "INR"}{" "}
                            {ProfileDetails?.nationality === "outSideIndia"
                              ? (isSocityJournal
                                ? (APCData?.[1]?.introductoryPrice || 0) -
                                  (APCData?.[2]?.introductoryPrice || 0)
                                : 99)
                              : preValues.journalType ===
                                "6454a6390d88e62fa10503be"
                                ? 3999
                                : (APCData?.[0]?.introductoryPrice || 0) - 1000}
                          </b>
                        </h3>
                        <div>
                          <div className="confirm-finger-row">
                            <img src={finger} alt="arrow" />
                            <span>
                              You may also be eligible for additional grants and
                              discounts
                            </span>
                          </div>
                          <div className="confirm-finger-row">
                            <img src={finger} alt="arrow" />
                            <span>
                              {preValues.journalType ===
                                "6454a6390d88e62fa10503be" || !isSocityJournal
                                ? "All offers and fees payable will be available AFTER the article is accepted for publication. You will not be asked for payment in advance"
                                : "All offers will be applied after the article is accepted for publication"}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
              <div className="confirmBtn">
                <button
                  className="button button-primary"
                  type="button"
                  disabled={isSubmissionReadOnly}
                  onClick={() => saveAndPay(1)}
                >
                  Save & Continue
                </button>
              </div>
            </div>
          )}

          <Accordion.Item
            eventKey="4"
            className={!canOpenTab("4") ? "disabled" : ""}
          >
            <Accordion.Header onClick={() => handleAccordian("4")}>
              <p>Funding details</p>
              {/* <b
                className={
                  subjects.completedTabs.funding === true ? "completed" : ""
                }
              >
                {subjects.completedTabs.funding === true
                  ? "Completed"
                  : "Optional"}{" "}
              </b> */}

              {subjects.completedTabs.funding === false && (
                <b>
                  {subjects.isSocietyEditor ? "Completed" : "To be completed"}
                </b>
              )}
              {subjects.completedTabs.funding === true && (
                <b className="">Completed</b>
              )}
            </Accordion.Header>
            <Accordion.Body>
              <div className="fundingWrap">
                <div className="funding-dashed-wrapper">
                  <h3 className="commanTitle02">
                    <div
                      className="text-[16px] font-normal"
                      style={{ fontSize: "16px", fontWeight: "normal" }}
                    >
                      Important Information
                      <div className="customTool">
                        {["bottom"].map((placement) => (
                          <OverlayTrigger
                            key={placement}
                            placement={placement}
                            overlay={
                              <Popover>
                                <Popover.Body>
                                  <div className="popoverToolWrap">
                                    <p>
                                      We request you to list all your funding
                                      information here including funds received
                                      for open access publication fees, from
                                      your institution, library, or other
                                      grants. It will be included in your
                                      article upon final publication. Disclosure
                                      of funding information demonstrates your
                                      commitment to transparency. If the study
                                      or research was commercially funded,
                                      please declare this information in the
                                      conflict-of-interest statement in the
                                      section below, clearly stating the role of
                                      each funder in the study including design
                                      and collection, analysis, and
                                      interpretation of the results, if any.
                                      Leave empty if no funding received.
                                    </p>
                                  </div>
                                </Popover.Body>
                              </Popover>
                            }
                          >
                            <img
                              className="pe-cursor ps-1"
                              src={vector}
                              alt="no img"
                            />
                          </OverlayTrigger>
                        ))}
                      </div>
                    </div>
                  </h3>
                  <div className="recivedCheck" style={{ marginTop: "30px" }}>
                    <label className="customCheck">
                      <Checkbox
                        onRadioChange={handleFundingCheckbox}
                        name="noFundingRecevied"
                        checked={fundingDetails?.noFundingRecevied}
                        className="form-check-input"
                      />
                      <i></i>
                      <b>No funding received</b>
                    </label>
                  </div>
                  <div className="fundingInfo">
                    <p className="funderContent">
                      Please declare all sources of funding received for the
                      research being submitted. This information includes the
                      name of funding agencies, grant amount, and a short
                      description of each funder’s role.
                    </p>
                    <div className="funderTextBoxArea border-t-[#4b4e52] border-r-[#4b4e52] border-b-[#4b4e52] border-l-[#4b4e52]">
                      <Textarea
                        name="fundingInformation"
                        rows="3"
                        className="defaultFeild border-t-[#A7A7A7] border-r-[#A7A7A7] border-b-[#A7A7A7] border-l-[#A7A7A7] border-t-[0.5px] border-r-[0.5px] border-b-[0.5px] border-l-[0.5px]"
                        placeholder="Type here..."
                        value={fundingDetails.fundingInformation}
                        readOnly={fundingDetails?.noFundingRecevied}
                        onChange={(e) => {
                          handleFundingInput(
                            e.target.value,
                            0,
                            "fundingInformation",
                          );
                        }}
                      />
                      {fundingDetailsError.fundingInformationError !== "" && (
                        <div className="label-error">
                          {fundingDetailsError.fundingInformationError}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="funderWrap">
                  {!fundingDetails?.noFundingRecevied &&
                    fundingCount.map((num, index) => (
                      <div
                        className="funding-dashed-wrapper mt-[0px] pl-[50px] pr-[50px] pt-[20px] pb-[0px]"
                        key={index}
                        style={{
                          marginTop: "0px",
                          paddingLeft: "80px",
                          paddingRight: "80px",
                          paddingTop: "20px",
                          paddingBottom: "0px",
                        }}
                      >
                        <div className={index > 0 ? " primaryRepeatWrap" : ""}>
                          {index == 0 && (
                            <h3
                              className="commanTitle02 mt-[40px]"
                              style={{ marginTop: "20px" }}
                            >
                              Primary Funder
                            </h3>
                          )}
                          {index == 1 && (
                            <h3
                              className="commanTitle02 secondryFunder mt-0"
                              style={{ paddingTop: "20px" }}
                            >
                              SECONDARY Funder
                            </h3>
                          )}
                          {index > 1 && (
                            <h3
                              className="commanTitle02 secondryFunder mt-0"
                              style={{ paddingTop: "20px" }}
                            >
                              Other Funder
                            </h3>
                          )}

                          <div className="primaryFunder">
                            {num > 0 && (
                              <div className="removeAuthors">
                                <i onClick={() => removeFundingInputs(index)}>
                                  Remove Details
                                </i>
                              </div>
                            )}
                            <div className="primaryFunderLeft">
                              <div className="defaultInput">
                                <label>Name of Funding Agency</label>
                                <Input
                                  errors={
                                    fundingDetailsError?.fundingAgencyError[
                                    index
                                    ]
                                  }
                                  name={`fundingAgency${index}`}
                                  handleChange={(e) =>
                                    handleFundingInput(
                                      e,
                                      index,
                                      "fundingAgency",
                                    )
                                  }
                                  className="defaultFeild"
                                  type="text"
                                  required={"required"}
                                  value={
                                    fundingDetails?.fundingAgency[index]?.val
                                  }
                                  placeholder="Enter"
                                  readOnly={fundingDetails?.noFundingRecevied}
                                />
                              </div>

                              <div className="defaultInput">
                                <label>
                                  Grant Amount{" "}
                                  <i>
                                    {ProfileDetails?.nationality ===
                                      "withInIndia"
                                      ? "(INR)"
                                      : "USD"}
                                  </i>
                                </label>

                                <Input
                                  errors={
                                    fundingDetailsError?.grantAmountError[index]
                                  }
                                  name={`grantAmount${index}`}
                                  handleChange={(e) =>
                                    handleFundingInput(e, index, "grantAmount")
                                  }
                                  className="defaultFeild"
                                  type="number"
                                  required={"required"}
                                  value={
                                    fundingDetails?.grantAmount[index]?.val
                                  }
                                  placeholder="Enter"
                                  readOnly={fundingDetails?.noFundingRecevied}
                                />
                              </div>
                            </div>
                            <div className="primaryFunderRight">
                              <div className="defaultInput">
                                <label>URL of Funding Agency</label>
                                <Input
                                  errors={
                                    fundingDetailsError?.fundingAgencyUrlError[
                                    index
                                    ]
                                  }
                                  name={`fundingAgencyUrl${index}`}
                                  handleChange={(e) =>
                                    handleFundingInput(
                                      e,
                                      index,
                                      "fundingAgencyUrl",
                                    )
                                  }
                                  className="defaultFeild"
                                  type="text"
                                  required={"required"}
                                  value={
                                    fundingDetails?.fundingAgencyUrl[index]?.val
                                  }
                                  placeholder="Enter"
                                  readOnly={fundingDetails?.noFundingRecevied}
                                />
                              </div>
                            </div>
                            <div
                              className="contactFounder ml-[0px] mr-[0px] mt-[40px] mb-[40px]"
                              style={{
                                marginLeft: "0px",
                                marginRight: "0px",
                                marginTop: "10px",
                                marginBottom: "30px",
                              }}
                            >
                              <h3
                                className="commanTitle02 mb-[30px]"
                                style={{ marginBottom: "30px" }}
                              >
                                Contact Details
                              </h3>
                              <div className="primaryFunderLeft">
                                <div className="defaultInput">
                                  <label>Name of Contact Person</label>
                                  <Input
                                    errors={
                                      fundingDetailsError?.nameError[index]
                                    }
                                    name={`name${index}`}
                                    handleChange={(e) =>
                                      handleFundingInput(e, index, "name")
                                    }
                                    className="defaultFeild"
                                    type="text"
                                    required={"required"}
                                    value={fundingDetails?.name[index]?.val}
                                    placeholder="Enter"
                                    readOnly={fundingDetails?.noFundingRecevied}
                                  />
                                </div>
                                <div className="defaultInput">
                                  <label>Mobile Number</label>
                                  <Input
                                    errors={
                                      fundingDetailsError?.phoneError[index]
                                    }
                                    name={`phone${index}`}
                                    handleChange={(e) =>
                                      handleFundingInput(e, index, "phone")
                                    }
                                    className="defaultFeild"
                                    type="text"
                                    required={"required"}
                                    value={fundingDetails?.phone[index]?.val}
                                    placeholder="Enter"
                                    readOnly={fundingDetails?.noFundingRecevied}
                                  />
                                </div>
                              </div>
                              <div className="primaryFunderRight">
                                <div className="defaultInput">
                                  <label>Email ID</label>
                                  <Input
                                    errors={
                                      fundingDetailsError?.emailError[index]
                                    }
                                    name={`email${index}`}
                                    handleChange={(e) =>
                                      handleFundingInput(e, index, "email")
                                    }
                                    className="defaultFeild"
                                    type="text"
                                    required={"required"}
                                    value={fundingDetails?.email[index]?.val}
                                    placeholder="Enter"
                                    readOnly={fundingDetails?.noFundingRecevied}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  {!fundingDetails?.noFundingRecevied && (
                    <div className="col-md-12 fieldMore mb-4">
                      <div className="fieldMoreArange">
                        <a
                          className={
                            fundingDetails?.noFundingRecevied ? "opacity5" : ""
                          }
                          onClick={() => addMoreFunder()}
                        >
                          <img
                            src={roundplus}
                            alt="roundplus"
                            style={{ marginRight: "10px" }}
                          />
                          ADD FUNDER
                        </a>
                      </div>
                    </div>
                  )}
                  <div className="footer-inner-card mt-5">
                    <div className="brand-section">
                      <img src={crossref} alt="Crossref" />
                      <div className="divider"></div>
                      <div className="footer-links">
                        <Link
                          to="/author-submission-guidelines"
                          target="_blank"
                          style={{ color: "#ef5c23", textDecoration: "underline", textDecorationColor: "#ef5c23" }}
                        >
                          Author Guidelines
                        </Link>
                        <div className="divider"></div>
                        <Link
                          to={getJournalUrl()}
                          target="_blank"
                          style={{ color: "#ef5c23", textDecoration: "underline", textDecorationColor: "#ef5c23" }}
                        >
                          About the Journal
                        </Link>
                        <div className="divider"></div>
                        <Link
                          onClick={() => setShowMegaGuidelineModal(true)}
                          style={{ cursor: "pointer", color: "#ef5c23", textDecoration: "underline", textDecorationColor: "#ef5c23" }}
                        >
                          Mega Journal Formatting Guideline
                        </Link>
                      </div>
                    </div>
                    <div className="action-buttons">
                      <button
                        className="btn-save-outline"
                        type="button"
                        disabled={isSubmissionReadOnly}
                        onClick={() => {
                          if (preValues?.journalType === journalTypes.mega && localStorage.getItem("megaGuidelineAgreed") !== "true") {
                            toast.error("Please read and accept the Mega Journal Formatting Guidelines.");
                            return;
                          }
                          saveAndPay(1);
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  <div className="text-end mt-3 mb-2">
                    <span style={{ fontSize: "16px" }}>
                      <span
                        className="mandatory-star"
                        style={{ color: "#BF1E2E" }}
                      >
                        *
                      </span>{" "}
                      All fields are mandatory
                    </span>
                  </div>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>

          {defaultActiveKey === "4" && (
            <div className="confirmFooter blueFooter">
              <div className="confirmContent">
                {preValues.articleType === "664aed76ada7b4f743b760a9" ? (
                  <h3>
                    CONFERENCE DETAILS: <b>TO BE SAVED</b>
                  </h3>
                ) : (
                  <>
                    {preValues.journal?.trim()?.toLowerCase() ===
                      "minorities in world politics" &&
                      apcPaymentOption === "self" ? (
                      <>
                        <h3>
                          {isSocityJournal ? "REMAINING " : ""}ARTICLE
                          PROCESSING CHARGE: INR 6499{" "}
                          <span style={{ textTransform: "lowercase" }}>
                            plus
                          </span>{" "}
                          GST
                        </h3>
                        <div>
                          <div className="confirm-finger-row">
                            <span>
                              For any questions regarding the submission, please
                              write to{" "}
                              <span
                                style={{
                                  color: "#ffffff",
                                  textDecoration: "underline",
                                }}
                              >
                                journal.mwp@gmail.com
                              </span>
                            </span>
                          </div>
                        </div>
                      </>
                    ) : isSocityJournal && apcPaymentOption === "society" ? (
                      isMWPOnly ? (
                        <>
                          <h3>
                            THE ARTICLE PROCESSING CHARGE IS PAID BY THE SOCIETY
                          </h3>
                          <div>
                            <div className="confirm-finger-row">
                              <img src={finger} alt="arrow" />
                              <span>
                                For any queries regarding the APC, please contact
                                the editorial office.
                              </span>
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          <h3>THE APC IS PAID BY THE SOCIETY</h3>
                        </>
                      )
                    ) : (
                      <>
                        <h3>
                          {isSocityJournal ? "Remaining " : ""}ARTICLE
                          PROCESSING CHARGE:{" "}
                          <b>
                            {ProfileDetails?.nationality === "outSideIndia"
                              ? "USD"
                              : "INR"}{" "}
                            {ProfileDetails?.nationality === "outSideIndia"
                              ? (isSocityJournal
                                ? (APCData?.[0]?.introductoryPrice || 0) -
                                  (APCData?.[2]?.introductoryPrice || 0)
                                : 99)
                              : preValues.journalType ===
                                "6454a6390d88e62fa10503be"
                                ? 3999
                                : (APCData?.[0]?.introductoryPrice || 0) - 1000}
                          </b>
                        </h3>
                        <div>
                          <div className="confirm-finger-row">
                            <img src={finger} alt="arrow" />
                            <span>
                              You may also be eligible for additional grants and
                              discounts
                            </span>
                          </div>
                          <div className="confirm-finger-row">
                            <img src={finger} alt="arrow" />
                            <span>
                              {preValues.journalType ===
                                "6454a6390d88e62fa10503be" || !isSocityJournal
                                ? "All offers and fees payable will be available AFTER the article is accepted for publication. You will not be asked for payment in advance"
                                : "All offers will be applied after the article is accepted for publication"}
                            </span>
                          </div>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
              <div className="confirmBtn">
                <button
                  className="button button-primary"
                  type="button"
                  disabled={isSubmissionReadOnly}
                  onClick={() => saveAndPay(1)}
                >
                  Save & Continue
                </button>
              </div>
            </div>
          )}

          <Accordion.Item
            eventKey="5"
            className={!canOpenTab("5") ? "disabled" : ""}
          >
            <Accordion.Header onClick={() => handleAccordian("5")}>
              <p>
                Statements
                <sup className="supStar">*</sup>
              </p>
              <b
                className={
                  subjects.completedTabs.statement === false ||
                    statements?.checkedCondition === false
                    ? ""
                    : "completed"
                }
              >
                {subjects.completedTabs.statement === false ||
                  statements?.checkedCondition === false
                  ? subjects.isSocietyEditor
                    ? "Completed"
                    : "To be completed"
                  : "Completed"}
              </b>
            </Accordion.Header>

            <Accordion.Body className="pt-0 pb-0">
              <div className="new-statements-layout">
                <div className="questions-section">
                  {/* Commercial Conflict Question */}
                  <h4 className="question-header font-semibold">
                    Commercial or financial conflict of interest
                  </h4>
                  <div className="question-row">
                    <div className="question-options">
                      <div className="regardingChklist">
                        <div className="regardingRadio">
                          <RadioButton
                            label="The authors declare that the research was conducted in the absence of any commercial or financial relationships that could be construed as a potential conflict of interest."
                            name="conflict"
                            id="conflictno"
                            labelClass={"font-normal"}
                            checked={
                              statements.commercialFinanceConflict === "1"
                            }
                            handleChange={handleStatementConflictChange}
                            required
                          />
                        </div>
                        <div className="regardingRadio mt-2">
                          <RadioButton
                            label="The authors declare a conflict of interest."
                            name="conflict"
                            id="conflictyes"
                            labelClass={"font-normal"}
                            checked={
                              statements.commercialFinanceConflict === "2"
                            }
                            handleChange={handleStatementConflictChange}
                            required
                          />
                        </div>
                        {statements.conflictError !== "" && (
                          <div className="label-error">
                            {statements.conflictError}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="question-details">
                      <Textarea
                        name="conflictDetail"
                        rows="4"
                        className="form-control"
                        placeholder="Provide more details..."
                        value={statements.conflictDetail}
                        onChange={(e) => {
                          handleStatementInput(
                            e.target.value,
                            "conflictDetail",
                          );
                        }}
                        disabled={statements.commercialFinanceConflict !== "2"}
                      />
                    </div>
                  </div>

                  {/* Manuscript Version Question */}
                  <h4 className="question-header-2 font-semibold">
                    Has a version of this manuscript been submitted previously
                    to another journal?
                  </h4>
                  <div className="question-row">
                    <div className="question-options">
                      <div className="regardingChklist">
                        <div className="regardingRadio">
                          <RadioButton
                            label="No"
                            name="scriptversion"
                            id="scriptversionno"
                            labelClass={"font-normal"}
                            checked={statements.manuscriptVersion === "no"}
                            handleChange={handleStatementScriptChange}
                            required
                          />
                        </div>
                        <div className="regardingRadio mt-2">
                          <RadioButton
                            label="Yes"
                            name="scriptversion"
                            id="scriptversionyes"
                            labelClass={"font-normal"}
                            checked={statements.manuscriptVersion === "yes"}
                            handleChange={handleStatementScriptChange}
                            required
                          />
                        </div>
                      </div>
                      {statements.versionError !== "" && (
                        <div className="label-error">
                          {statements.versionError}
                        </div>
                      )}
                    </div>
                    <div className="question-details">
                      <Textarea
                        name="manuscriptVersionDetail"
                        rows="4"
                        className="form-control-2"
                        placeholder="Provide more details..."
                        value={statements.manuscriptVersionDetail}
                        onChange={(e) => {
                          handleStatementInput(
                            e.target.value,
                            "manuscriptVersionDetail",
                          );
                        }}
                        disabled={statements.manuscriptVersion !== "yes"}
                      />
                    </div>
                  </div>

                  <div className="footer-inner-card mt-5">
                    <div className="brand-section">
                      <img src={crossref} alt="Crossref" />
                      <div className="divider"></div>
                      <div className="footer-links">
                        <Link
                          to="/author-submission-guidelines"
                          target="_blank"
                          style={{ color: "#ef5c23", textDecoration: "underline", textDecorationColor: "#ef5c23" }}
                        >
                          Author Guidelines
                        </Link>
                        <div className="divider"></div>
                        <Link
                          to={getJournalUrl()}
                          target="_blank"
                          style={{ color: "#ef5c23", textDecoration: "underline", textDecorationColor: "#ef5c23" }}
                        >
                          About the Journal
                        </Link>
                        <div className="divider"></div>
                        <Link
                          onClick={() => setShowMegaGuidelineModal(true)}
                          style={{ cursor: "pointer", color: "#ef5c23", textDecoration: "underline", textDecorationColor: "#ef5c23" }}
                        >
                          Mega Journal Formatting Guideline
                        </Link>
                      </div>
                    </div>
                    <div className="action-buttons">
                      <button
                        className="btn-save-outline"
                        type="button"
                        disabled={isSubmissionReadOnly}
                        onClick={() => {
                          if (preValues?.journalType === journalTypes.mega && localStorage.getItem("megaGuidelineAgreed") !== "true") {
                            toast.error("Please read and accept the Mega Journal Formatting Guidelines.");
                            return;
                          }
                          saveAndPay(1);
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  <div className="text-end mt-3 mb-2">
                    <span style={{ fontSize: "16px" }}>
                      <span
                        className="mandatory-star"
                        style={{ color: "#BF1E2E" }}
                      >
                        *
                      </span>{" "}
                      All fields are mandatory
                    </span>
                  </div>
                </div>
              </div>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>

        {defaultActiveKey === "5" && (
          <div className="author-declaration-section mt-5">
            <div className="declaration-box dashed-border-box">
              <h4
                className="commanTitle02 mb-[30px]"
                style={{ marginBottom: "30px" }}
              >
                AUTHOR DECLARATION
              </h4>
              <div className="declaration-inner-wrapper">
                <div className="declaration-checkbox-wrapper">
                  <label className="customCheck big-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="acceptStatement"
                      checked={statements?.checkedCondition}
                      onChange={handleAcceptStatementCheckbox}
                    />
                    <i></i>
                  </label>
                </div>
                <div className="declaration-content">
                  <p className="declaration-intro">
                    <strong>
                      I warrant that I am expressly authorized to submit this
                      article and to agree to the following conditions on behalf
                      of myself and every author <br />
                      of this manuscript:
                    </strong>
                  </p>

                  <ul className="declaration-list">
                    <li>
                      This manuscript is not currently under consideration for
                      publication elsewhere and has not been previously
                      published by any other journal <br />
                      or publication forum.
                    </li>
                    <li>
                      This manuscript adhered to Aakashganga{" "}
                      <a
                        href=""
                        onClick={(e) => {
                          e.preventDefault();
                          setShowMaterialPolicy(true);
                        }}
                      >
                        materials and data policies
                      </a>{" "}
                      in its reporting requirements and data availability
                      standards.
                    </li>
                    <li>
                      I have obtained all necessary consents to permit
                      Aakashganga to publish this article, including any
                      third-party materials, on CC-BY terms.
                    </li>
                    <li>
                      I have read, understood and hereby accept the{" "}
                      <a href="/terms-conditions" target="_blank">
                        Aakashganga Terms & Conditions
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}

        {defaultActiveKey === "5" && (
          <div className="confirmFooter blueFooter">
            <div className="confirmContent">
              {preValues.articleType === "664aed76ada7b4f743b760a9" ? (
                <h3>
                  CONFERENCE DETAILS: <b>TO BE SAVED</b>
                </h3>
              ) : (
                <>
                  {preValues.journal?.trim()?.toLowerCase() ===
                    "minorities in world politics" &&
                    apcPaymentOption === "self" ? (
                    <>
                      <h3>
                        {isSocityJournal ? "REMAINING " : ""}ARTICLE PROCESSING
                        CHARGE: INR 6499{" "}
                        <span style={{ textTransform: "lowercase" }}>plus</span>{" "}
                        GST
                      </h3>
                      <div>
                        <div className="confirm-finger-row">
                          <span>
                            For any questions regarding the submission, please
                            write to{" "}
                            <span
                              style={{
                                color: "#ffffff",
                                textDecoration: "underline",
                              }}
                            >
                              journal.mwp@gmail.com
                            </span>
                          </span>
                        </div>
                      </div>
                    </>
                  ) : isSocityJournal && apcPaymentOption === "society" ? (
                    isMWPOnly ? (
                      <>
                        <h3>
                          THE ARTICLE PROCESSING CHARGE IS PAID BY THE SOCIETY
                        </h3>
                        <div>
                          <div className="confirm-finger-row">
                            <img src={finger} alt="arrow" />
                            <span>
                              For any queries regarding the APC, please contact
                              the editorial office.
                            </span>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <h3>THE APC IS PAID BY THE SOCIETY</h3>
                      </>
                    )
                  ) : (
                    <>
                      <h3>
                        {isSocityJournal ? "Remaining " : ""}ARTICLE PROCESSING
                        CHARGE:{" "}
                        <b>
                          {ProfileDetails?.nationality === "outSideIndia"
                            ? "USD"
                            : "INR"}{" "}
                          {ProfileDetails?.nationality === "outSideIndia"
                            ? (isSocityJournal
                              ? (APCData?.[0]?.introductoryPrice || 0) -
                              (APCData?.[2]?.introductoryPrice || 0)
                              : 99)
                            : preValues.journalType ===
                              "6454a6390d88e62fa10503be"
                              ? 3999
                              : (APCData?.[0]?.introductoryPrice || 0) - 1000}
                        </b>
                      </h3>
                      <div>
                        <div className="confirm-finger-row">
                          <img src={finger} alt="arrow" />
                          <span>
                            You may also be eligible for additional grants and
                            discounts
                          </span>
                        </div>
                        <div className="confirm-finger-row">
                          <img src={finger} alt="arrow" />
                          <span>
                            {preValues.journalType ===
                              "6454a6390d88e62fa10503be" || !isSocityJournal
                              ? "All offers and fees payable will be available AFTER the article is accepted for publication. You will not be asked for payment in advance"
                              : "All offers will be applied after the article is accepted for publication"}
                          </span>
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
            <div className="confirmBtn">
              <button
                className="button button-primary"
                type="button"
                disabled={isSubmissionReadOnly}
                onClick={() => saveAndPay(1)}
              >
                Save & Continue
              </button>
            </div>
          </div>
        )}

        {subjects.preStepData.plagirismCheck === "notDone" && (
          <>
            {/* {defaultActiveKey === "0" && (
              <div className="confirmFooter">
                <div className="confirmContent"></div>
                <div className="confirmBtn">
                  <span
                    className={
                      preValues.journal === "" ||
                        preValues.subjectId === "" ||
                        preValues.articleType === ""
                        ? "btn-link-active opacity5"
                        : "btn-link-active"
                    }
                    onClick={() => saveAndPay(1)}
                  >
                    Save
                  </span>
                  <button
                    disabled={
                      preValues.journal === "" ||
                        preValues.subjectId === "" ||
                        preValues.articleType === ""
                        ? true
                        : false
                    }
                    className="button button-primary"
                    type="button"
                    onClick={() => {
                      saveAndPay(2);
                    }}
                  >
                    SAVE AND CONTINUE
                  </button>
                </div>
              </div>
            )} */}
            {/* {subjects.completedTabs.mySubmission === true &&
              defaultActiveKey === "1" && (
                <div className="confirmFooter">
                  <div className="confirmContent">
                    {preValues.articleType ===
                      "664aed76ada7b4f743b760a9" ? null : (
                      <>
                        <h3>
                          {isSocityJournal ? "Remaining " : ""}ARTICLE PROCESSING CHARGE:{" "}
                          <b>
                            {ProfileDetails?.nationality === "outSideIndia"
                              ? "USD"
                              : "INR"}{" "}
                            {preValues.reviewType ===
                              "only post-publication open review"
                              ? APCData[0].introductoryPrice -
                              APCData[2].introductoryPrice
                              : APCData[1].introductoryPrice -
                              APCData[2].introductoryPrice}
                          </b>
                        </h3>

                        <div className="questionBox">
                          <span>
                            You also be eligible for additional grants and
                            discounts
                          </span>
                          <span>
                            All offers will be applied after the article is
                            accepted for publication
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                  <div className="confirmBtn">
                    <span
                      className="btn-link-active"
                      onClick={() => saveAndPay(1)}
                    >
                      Save
                    </span>
                    <button
                      className="button button-primary"
                      type="button"
                      onClick={() => saveAndPay(2)}
                    >
                      SAVE AND CONTINUE
                    </button>
                  </div>
                </div>
              )} */}
            {/* 
            {subjects.completedTabs.review === true &&
              defaultActiveKey === "3" && (
                <div className="confirmFooter">
                  <div className="confirmContent">
                    <h3>
                      {isSocityJournal ? "Remaining " : ""}ARTICLE PROCESSING CHARGE:{" "}
                      <b>
                        {ProfileDetails?.nationality === "outSideIndia"
                          ? "USD"
                          : "INR"}{" "}
                        {preValues.reviewType ===
                          "only post-publication open review"
                          ? APCData[0].introductoryPrice -
                          APCData[2].introductoryPrice
                          : APCData[1].introductoryPrice -
                          APCData[2].introductoryPrice}
                      </b>
                    </h3>
                    <div className="questionBox">
                      <span>
                        You may also be eligible for additional grants and
                        discounts
                      </span>
                      <span>
                        All offers will be applied after the article is accepted
                        for publication
                      </span>
                    </div>
                  </div>
                  <div className="confirmBtn">
                    <span
                      className="btn-link-active"
                      onClick={() => saveAndPay(1)}
                    >
                      Save
                    </span>
                    <button
                      className="button button-primary"
                      type="button"
                      onClick={() => saveAndPay(2)}
                    >
                      SAVE AND CONTINUE
                    </button>
                  </div>
                </div>
              )} */}
            {/* The following two footers were moved out of this block */}
            {/* {subjects.completedTabs.author === true &&
              defaultActiveKey === "4" && (
                <div
                  className="confirmFooter"
                  style={{
                    position: "fixed",
                    bottom: "30px",
                    left: "50%",
                    width: "80%",
                    transform: "translateX(-50%)",
                    zIndex: "999",
                    backgroundColor: "#006F94",
                    boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
                    color: "#FFFFFF",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "15px 30px",
                    borderRadius: "10px",
                  }}
                >
                  <div className="confirmContent">
                    {preValues.articleType ===
                    "664aed76ada7b4f743b760a9" ? null : (
                      <>
                        <h3
                          style={{
                            color: "#FFFFFF",
                            textTransform: "uppercase",
                            fontSize: "16px",
                            marginBottom: "4px",
                          }}
                        {isSocityJournal && apcPaymentOption === "society" ? (
                          <>
                            <h3
                              style={{
                                color: "#FFFFFF",
                                textTransform: "uppercase",
                                fontSize: "16px",
                                marginBottom: "4px",
                              }}
                            >
                              THE ARTICLE PROCESSING CHARGE IS PAID BY THE SOCIETY
                            </h3>
                            <div style={{ marginTop: "10px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={finger}
                                  alt="arrow"
                                  style={{ marginRight: "10px", height: "16px" }}
                                />
                                <span
                                  style={{ color: "#FFFFFF", fontSize: "14px" }}
                                >
                                  For any queries regarding the APC, please contact the
                                  editorial office.
                                </span>
                              </div>
                            </div>
                          </>
                        ) : (
                          <>
                            <h3
                              style={{
                                color: "#FFFFFF",
                                textTransform: "uppercase",
                                fontSize: "16px",
                                marginBottom: "4px",
                              }}
                            >
                              {isSocityJournal ? "Remaining " : ""}ARTICLE PROCESSING CHARGE:{" "}
                              <b>
                                {ProfileDetails?.nationality === "outSideIndia"
                                  ? "USD"
                                  : "INR"}{" "}
                                {ProfileDetails?.nationality === "outSideIndia"
                                  ? (isSocityJournal
                                    ? (APCData?.[0]?.introductoryPrice || 0) -
                                      (APCData?.[2]?.introductoryPrice || 0)
                                    : 99)
                                  : (preValues.journalType === "6454a6390d88e62fa10503be" ? 3999 : (APCData?.[0]?.introductoryPrice || 0) - 1000)}
                              </b>
                            </h3>
                            <div style={{ marginTop: "10px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginBottom: "5px",
                                }}
                              >
                                <img
                                  src={finger}
                                  alt="arrow"
                                  style={{ marginRight: "10px", height: "16px" }}
                                />
                                <span
                                  style={{ color: "#FFFFFF", fontSize: "14px" }}
                                >
                                  You may also be eligible for additional grants and
                                  discounts
                                </span>
                              </div>
                              <div
                                style={{ display: "flex", alignItems: "center" }}
                              >
                                <img
                                  src={finger}
                                  alt="arrow"
                                  style={{ marginRight: "10px", height: "16px" }}
                                />
                                <span
                                  style={{ color: "#FFFFFF", fontSize: "14px" }}
                                >
                                  {(preValues.journalType === "6454a6390d88e62fa10503be" || !isSocityJournal)
                                    ? "All offers and fees payable will be available AFTER the article is accepted for publication. You will not be asked for payment in advance"
                                    : "All offers will be applied after the article is accepted for publication"}
                                </span>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                  <div className="confirmBtn">
                    <button
                      className="button button-primary"
                      type="button"
                      disabled={isSubmissionReadOnly}
                      onClick={() => saveAndPay(1, "5")}
                      style={{
                        backgroundColor: "#ffffff",
                        height: "44px",
                        color: "#006F94",
                        border: "none",
                        borderRadius: "10px",
                        textTransform: "capitalize",
                        fontWeight: "bold",
                        padding: "0 25px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      Save & Continue
                    </button>
                  </div>
                </div>
              )}
            {subjects.completedTabs.funding === true &&
              defaultActiveKey === "5" && (
                <div
                  className="confirmFooter"
                  style={{
                    position: "fixed",
                    bottom: "30px",
                    left: "50%",
                    width: "80%",
                    transform: "translateX(-50%)",
                    zIndex: "999",
                    backgroundColor: "#006F94",
                    boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
                    color: "#FFFFFF",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "15px 30px",
                    borderRadius: "10px",
                  }}
                >
                  <div className="confirmContent">
                    {preValues.articleType ===
                    "664aed76ada7b4f743b760a9" ? null : (
                      <>
                        <h3
                          style={{
                            color: "#FFFFFF",
                            textTransform: "uppercase",
                            fontSize: "16px",
                            marginBottom: "4px",
                          }}
                        {isSocityJournal && apcPaymentOption === "society" ? (
                          isMWPOnly ? (
                            <>
                              <h3
                                style={{
                                  color: "#FFFFFF",
                                  textTransform: "uppercase",
                                  fontSize: "16px",
                                  marginBottom: "4px",
                                }}
                              >
                                THE ARTICLE PROCESSING CHARGE IS PAID BY THE SOCIETY
                              </h3>
                              <div style={{ marginTop: "10px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src={finger}
                                    alt="arrow"
                                    style={{ marginRight: "10px", height: "16px" }}
                                  />
                                  <span
                                    style={{ color: "#FFFFFF", fontSize: "14px" }}
                                  >
                                    For any queries regarding the APC, please contact the
                                    editorial office.
                                  </span>
                                </div>
                              </div>
                            </>
                          ) : (
                            <>
                              <h3
                                style={{
                                  color: "#FFFFFF",
                                  textTransform: "uppercase",
                                  fontSize: "16px",
                                  marginBottom: "4px",
                                }}
                              >
                                THE APC IS PAID BY THE SOCIETY
                              </h3>
                            </>
                          )
                        ) : (
                          <>
                            <h3
                              style={{
                                color: "#FFFFFF",
                                textTransform: "uppercase",
                                fontSize: "16px",
                                marginBottom: "4px",
                              }}
                            >
                              {isSocityJournal ? "Remaining " : ""}ARTICLE PROCESSING CHARGE:{" "}
                              <b>
                                {ProfileDetails?.nationality === "outSideIndia"
                                  ? "USD"
                                  : "INR"}{" "}
                                {ProfileDetails?.nationality === "outSideIndia"
                                  ? (isSocityJournal
                                    ? (APCData?.[0]?.introductoryPrice || 0) -
                                      (APCData?.[2]?.introductoryPrice || 0)
                                    : 99)
                                  : (preValues.journalType === "6454a6390d88e62fa10503be" ? 3999 : (APCData?.[0]?.introductoryPrice || 0) - 1000)}
                              </b>
                            </h3>
                            <div style={{ marginTop: "10px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  marginBottom: "5px",
                                }}
                              >
                                <img
                                  src={finger}
                                  alt="arrow"
                                  style={{ marginRight: "10px", height: "16px" }}
                                />
                                <span
                                  style={{ color: "#FFFFFF", fontSize: "14px" }}
                                >
                                  You may also be eligible for additional grants and
                                  discounts
                                </span>
                              </div>
                              <div
                                style={{ display: "flex", alignItems: "center" }}
                              >
                                <img
                                  src={finger}
                                  alt="arrow"
                                  style={{ marginRight: "10px", height: "16px" }}
                                />
                                <span
                                  style={{ color: "#FFFFFF", fontSize: "14px" }}
                                >
                                  {(preValues.journalType === "6454a6390d88e62fa10503be" || !isSocityJournal)
                                    ? "All offers and fees payable will be available AFTER the article is accepted for publication. You will not be asked for payment in advance"
                                    : "All offers will be applied after the article is accepted for publication"}
                                </span>
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                  <div className="confirmBtn">
                    <button
                      className="button button-primary"
                      type="button"
                      disabled={isSubmissionReadOnly}
                      onClick={() => saveAndPay(1)}
                      style={{
                        backgroundColor: "#ffffff",
                        height: "44px",
                        color: "#006F94",
                        border: "none",
                        borderRadius: "10px",
                        textTransform: "capitalize",
                        fontWeight: "bold",
                        padding: "0 25px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      Save & Continue
                    </button>
                  </div>
                </div>
              )} */}
          </>
        )}
      </div>
      <Modal
        dialogclassName="modal-dialog-centered modal-md md-x"
        show={incompleteInfoPopup}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal authorModalRed md-x"
      >
        <Modal.Header className="modal-header">
          <div className="modal-icon">
            {" "}
            <img src={alertSvg} alt="#" />
          </div>
          <h5 className="modal-title">{popupTitle}</h5>
          <button
            type="button"
            className="btn-close"
            ariaLabel="Close"
            onClick={() => setincompleteInfoPopup(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pb-4 pt-0">
          <div className="grantDetails alertPopup">
            <div className="incompleteText w-100 m-auto mb-3 text-start ps-2">
              <p
                className="pl-4 pr-4"
                dangerouslySetInnerHTML={{ __html: popupError }}
              />
            </div>
          </div>
          <div className="clearfix">
            <button
              className="button button-primary redBtn"
              type="button"
              onClick={() => setincompleteInfoPopup(false)}
            >
              Okay
            </button>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer pb-3">
          <div className="helpPopupText">
            Need help? Write to us at<a href="">contactus@vikramshilaedu.in</a>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogclassName="modal-dialog-centered modal-md"
        show={createcitationPopup}
        size="md"
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal"
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title">Create Citation</h5>
          <button
            type="button"
            className="btn-close"
            ariaLabel="Close"
            onClick={() => setcreatecitationPopup(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pb-0 pt-0">
          <div className="createCitationAlertPopup">
            <h2>
              Author Name<sup className="supStar">*</sup>
            </h2>

            <div className="row">
              <div className="col-md-6">
                <div className="defaultInput mt-0">
                  <label className="defaultLable">
                    Full Name<sup className="supStar">*</sup>
                  </label>
                  <Input
                    name={`name`}
                    className="defaultFeild"
                    type="text"
                    placeholder="Full Name"
                  />
                </div>
              </div>

              <div className="col-md-6">
                <div className="defaultInput mt-0">
                  <label className="defaultLable">
                    Last Name<sup className="supStar">*</sup>
                  </label>
                  <Input
                    name={`Lastname`}
                    className="defaultFeild"
                    type="text"
                    placeholder="Last Name"
                  />
                </div>
              </div>
            </div>

            <div className="urlPopup">
              <div className="row">
                <div className="col-md-12">
                  <div className="defaultInput">
                    <label className="defaultLable">
                      URL<sup className="supStar">*</sup>
                    </label>
                    <Input
                      name={`name`}
                      className="defaultFeild"
                      type="text"
                      placeholder="Name of contact person"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="defaultInput">
                  <label className="defaultLable">
                    Year of Publication<sup className="supStar">*</sup>
                  </label>
                  <Input
                    name={`name`}
                    className="defaultFeild"
                    type="number"
                    placeholder="Year of Publication"
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 citationButton">
                <button
                  className="button button-primary"
                  type="button"
                  onClick={() => setcreatecitationPopup(false)}
                >
                  Generate
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer pb-3">
          <div className="mandatoryCount">
            <sup className="supStar">*</sup>Mandatory
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogclassName="modal-dialog-centered modal-md"
        show={citationGeneratedPopup}
        size="md"
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal"
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title">Citation Generated</h5>
          <button
            type="button"
            className="btn-close"
            ariaLabel="Close"
            onClick={() => setcitationGeneratedPopup(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="createCitationAlertPopup">
            <div className="createCitationText">
              <div className="col-md-12 pt-3">
                <div className="defaultInput mt-0">
                  <label className="defaultLable">In-text Citation</label>
                  <div className="copyInput">
                    <Input
                      name={`name`}
                      className="defaultFeild"
                      type="text"
                      placeholder="In-text Citation"
                    />
                    <i>Copy</i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer pb-4">
          <button
            className="button button-primary"
            type="button"
            onClick={() => setincompleteInfoPopup(false)}
          >
            DONE
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogclassName="modal-dialog-centered modal-md"
        show={needHelpPopup}
        size="sm"
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal"
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title">Need Help?</h5>
          <button
            type="button"
            className="btn-close"
            ariaLabel="Close"
            onClick={() => setneedHelpPopup(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="needNewPopup">
            <p>For any questions, write to us at</p>
            <a href="">contactus@vikramshilaedu.in</a>
            <p className="pt-2">We will strike to respond at the earliest.</p>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <button
            className="button button-primary"
            type="button"
            onClick={() => setneedHelpPopup(false)}
          >
            Okay
          </button>
        </Modal.Footer>
      </Modal>
      <Modal
        dialogclassName="modal-dialog-centered modal-md"
        show={subjectApproval}
        size="sm"
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal md-x"
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title">ALL GOOD THINGS TAKE TIME</h5>
          <button
            type="button"
            className="btn-close"
            ariaLabel="Close"
            onClick={() => setsubjectApproval(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="needNewPopup text-center">
            <p>You can continue filling out the submission</p>
            <p>form after we have approved the subject.</p>
            <p className="pt-2">Thank you for your patience</p>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <button
            className="button button-primary"
            type="button"
            onClick={() => setsubjectApproval(false)}
          >
            Okay
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        dialogclassName="modal-dialog-centered modal-lg"
        size="lg"
        className="authorModal"
        show={showMaterialPolicy}
        backdrop="static"
        id="congratsMobile"
        tabIndex={-1}
        centered
      >
        <Modal.Header className="modal-header">
          <h5 className="modal-title">Material and Data Policies</h5>
          <button
            type="button"
            className="btn-close"
            ariaLabel="Close"
            onClick={() => setShowMaterialPolicy(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="needNewPopup">
            <p className="mb-3">
              We are committed to open data and being transparent. We require
              that you make available all data relevant to the conclusions of
              the manuscript. We work towards having the correct data available,
              ensuring increased levels of transparency and reproducibility in
              our published articles.
            </p>
            <p className="mb-3">
              Relevant materials such as analytic methods, study material,
              tables etc should preferably be made available through a link; you
              are encouraged to make this material available upon request to
              interested researchers, and be stated in the manuscript.
            </p>
            <p>
              You must comply with the General Data Protection Regulation
              (‘GDPR’) [in case it is applicable to you] and all relevant data
              protection and privacy legislation in other jurisdictions,
              including India.
            </p>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        dialogclassName=""
        show={showSaveSuccessModal}
        id="congratsMobile"
        tabIndex={-1}
        centered
        className="authorModal md-x"
      >
        <Confetti width={"450px"} height={"350px"} numberOfPieces={100} />
        <Modal.Header className="modal-header">
          <div className="modal-icon">
            <img src={doneSvg} alt="#" />
          </div>
          <h5 className="modal-title">Your work has been saved</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShowSaveSuccessModal(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pt-0">
          <div className="beensave text-center">
            <div style={{ textAlign: "left", marginLeft: "10px" }}>
              {preValues.journalType === journalTypes.mega ||
                (!isSocityJournal &&
                  preValues.journalType !== journalTypes.society) ? (
                <>
                  <div style={{ marginBottom: "15px" }}>
                    <span style={{ display: "block" }}>
                      Please complete all sections of the submission journey to
                      be able to upload your article.
                    </span>
                  </div>
                  <div>
                    <span style={{ display: "block" }}>
                      The details you fill in form a critical part of the
                      Article’s Meta Data and assist in global visibility.
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <div style={{ marginBottom: "15px" }}>
                    <span style={{ display: "block" }}>
                      Please complete all sections of the submission
                    </span>
                    <span style={{ display: "block" }}>
                      {" "}
                      journey to access the article editor and begin writing
                      your article.
                    </span>
                  </div>
                  <div>
                    <span style={{ display: "block" }}>
                      These details are required for a smooth and
                    </span>
                    <span style={{ display: "block" }}>
                      accurate submission process.
                    </span>
                  </div>
                </>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className="modal-footer">
          <button
            className="button button-primary sm ml-3"
            onClick={() => {
              setShowSaveSuccessModal(false);
              setShowCelebrationModal(true);
            }}
          >
            CONTINUE
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showCelebrationModal}
        onHide={() => setShowCelebrationModal(false)}
        centered
        className={`submissionSuccessModal ${preValues.journalType === journalTypes.mega ||
            (!isSocityJournal && preValues.journalType !== journalTypes.society)
            ? "megaSubmissionSuccessModal"
            : ""
          }`}
        backdrop="static"
      >
        <div className="modal-header border-0 pb-0">
          <button
            type="button"
            className="btn-close ms-auto"
            onClick={() => setShowCelebrationModal(false)}
          ></button>
        </div>
        <Modal.Body className="text-center pb-5 pt-0 px-5">
          <div className="success-icon-wrap">
            <img src={correct} alt="success" />
          </div>
          <h2 className="modal-title-main">SUBMISSION DETAILS COMPLETED</h2>
          <div className="modal-desc text-center">
            {preValues.journalType === journalTypes.mega ||
              (!isSocityJournal &&
                preValues.journalType !== journalTypes.society) ? (
              <div>
                <span
                  style={{
                    display: "block",
                    fontSize: "18px",
                    lineHeight: "1.6",
                    textAlign: "center",
                  }}
                >
                  You can now proceed to upload your Article.
                  <br />
                  Please read the{" "}
                  <Link
                    to="/author-submission-guidelines"
                    target="_blank"
                    style={{ color: "#006f94", textDecoration: "underline" }}
                  >
                    Article Submission Guidelines
                  </Link>{" "}
                  to avoid rejection.
                </span>
              </div>
            ) : (
              <>
                <div style={{ marginBottom: "20px" }}>
                  <span
                    style={{
                      display: "block",
                      fontSize: "18px",
                      lineHeight: "1.6",
                      textAlign: "center",
                    }}
                  >
                    You’ve successfully completed all
                    <br />
                    sections of the submission journey.
                  </span>
                </div>
                <div>
                  <span
                    style={{
                      display: "block",
                      fontSize: "18px",
                      lineHeight: "1.6",
                      textAlign: "center",
                    }}
                  >
                    You can now proceed to the article <br />
                    editor to start writing your manuscript,
                    <br />
                    or return to your dashboard.
                  </span>
                </div>
              </>
            )}
          </div>
          <div className="modal-actions">
            {!(
              preValues.journalType === journalTypes.mega ||
              (!isSocityJournal &&
                preValues.journalType !== journalTypes.society)
            ) && (
                <button
                  className="btn btn-primary-custom"
                  style={{ padding: "10px 40px" }}
                  onClick={() => {
                    setShowCelebrationModal(false);
                    if (subjects.onContinueToEditor) {
                      subjects.onContinueToEditor();
                    } else {
                      setdefaultActiveKey("6");
                    }
                  }}
                >
                  Start Writing
                </button>
              )}
            {(preValues.journalType === journalTypes.mega ||
              (!isSocityJournal &&
                preValues.journalType !== journalTypes.society)) && (
                <button
                  className="btn btn-outline-primary-custom"
                  style={{ padding: "10px 24px" }}
                  onClick={() => {
                    setShowCelebrationModal(false);
                    setShowUploadArticleModal(true);
                  }}
                >
                  Upload Article
                </button>
              )}
            <Link
              to="/dashboard"
              className="btn btn-outline-primary-custom"
              style={{
                padding:
                  preValues.journalType === journalTypes.mega ||
                    (!isSocityJournal &&
                      preValues.journalType !== journalTypes.society)
                    ? "10px 24px"
                    : "10px 40px",
                marginLeft:
                  preValues.journalType === journalTypes.mega ||
                    (!isSocityJournal &&
                      preValues.journalType !== journalTypes.society)
                    ? "0"
                    : "10px",
              }}
            >
              Go to Dashboard
            </Link>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showUploadArticleModal && !isSocietyArticle()}
        onHide={() => {
          setShowUploadArticleModal(false);
          if (!isUploadingArticle) {
            setUploadFile(null);
            setImageList([]);
          }
        }}
        centered
        size="lg"
        className="uploadArticleModal"
      >
        <div className="modal-header border-0 pb-0">
          <button
            type="button"
            className="btn-close ms-auto"
            onClick={() => {
              setShowUploadArticleModal(false);
              if (!isUploadingArticle) {
                setUploadFile(null);
                setImageList([]);
              }
            }}
          ></button>
        </div>
        <Modal.Body className="px-4 pb-4 pt-0 text-start">
          <div className="text-center mb-4">
            <div
              className="mx-auto mb-2 d-flex align-items-center justify-content-center"
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                backgroundColor: "#e6f4f8",
                color: "#006f94",
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17 8 12 3 7 8" />
                <line x1="12" y1="3" x2="12" y2="15" />
              </svg>
            </div>
            <h4
              className="modal-title-main"
              style={{
                color: "#006f94",
                fontWeight: "700",
                fontSize: "20px",
                marginBottom: "4px",
              }}
            >
              Upload Article Manuscript and Figures
            </h4>
            <p
              className="text-muted"
              style={{ fontSize: "13px", marginBottom: "0" }}
            >
              Upload your manuscript document first, then attach any figure
              images with title labels.
            </p>
          </div>

          <div className="d-flex flex-column gap-3 mb-4">
            {/* Step 1: Upload Document (First, Vertical) */}
            <div
              className="p-3 border rounded-3"
              style={{
                backgroundColor: uploadFile ? "#f0f7f9" : "#fafafa",
                borderColor: uploadFile ? "#006f94" : "#dee2e6",
                transition: "all 0.2s ease-in-out",
              }}
            >
              <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="d-flex align-items-center gap-2">
                  <span
                    className="badge rounded-pill"
                    style={{
                      backgroundColor: "#006f94",
                      color: "#fff",
                      fontSize: "11px",
                    }}
                  >
                    STEP 1
                  </span>
                  <h6
                    className="mb-0"
                    style={{
                      fontWeight: "700",
                      color: "#006f94",
                      fontSize: "15px",
                    }}
                  >
                    Upload Article and Figures
                  </h6>
                </div>
                {uploadFile && (
                  <span
                    className="badge bg-success"
                    style={{ fontSize: "11px" }}
                  >
                    ✓ Document Selected
                  </span>
                )}
              </div>

              {!uploadFile ? (
                <div
                  className="p-4 border border-dashed rounded-3 text-center"
                  style={{
                    backgroundColor: "#ffffff",
                    borderColor: "#006f94",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (documentInputRef.current)
                      documentInputRef.current.click();
                  }}
                >
                  <div className="mb-2" style={{ color: "#006f94" }}>
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                      <line x1="16" y1="13" x2="8" y2="13" />
                      <line x1="16" y1="17" x2="8" y2="17" />
                    </svg>
                  </div>
                  <h6
                    style={{
                      color: "#006f94",
                      fontWeight: "600",
                      marginBottom: "4px",
                    }}
                  >
                    Click here to select Manuscript Document
                  </h6>
                  <span className="text-muted" style={{ fontSize: "12px" }}>
                    Supports PDF, DOC, DOCX files (.pdf, .doc, .docx)
                  </span>
                </div>
              ) : (
                <div
                  className="p-3 rounded-3 bg-white border text-start"
                  style={{ borderColor: "#006f94" }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-3 overflow-hidden">
                      <span style={{ fontSize: "24px" }}>📄</span>
                      <div className="overflow-hidden">
                        <h6
                          className="mb-0 text-truncate"
                          style={{
                            fontWeight: "600",
                            color: "#333",
                            fontSize: "14px",
                          }}
                        >
                          {uploadFile.name}
                        </h6>
                        <span
                          className="text-muted"
                          style={{ fontSize: "12px" }}
                        >
                          {(uploadFile.size / (1024 * 1024)).toFixed(2)} MB •
                          Manuscript Document
                        </span>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn border-0 p-1 ms-2"
                      style={{
                        background: "transparent",
                        color: "#dc3545",
                        fontSize: "18px",
                        fontWeight: "bold",
                        lineHeight: 1,
                        cursor: "pointer",
                        boxShadow: "none",
                      }}
                      onClick={() => {
                        setUploadFile(null);
                        setUploadErrorMessage("");
                      }}
                      disabled={isUploadingArticle}
                      title="Change file"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Step 2: Supplementary Material (Enabled only after document is selected) */}
            <div
              className="p-3 border rounded-3"
              style={{
                backgroundColor: uploadFile ? "#ffffff" : "#f8f9fa",
                opacity: uploadFile ? 1 : 0.6,
                transition: "all 0.2s ease-in-out",
              }}
            >
              <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="d-flex align-items-center gap-2">
                  <span
                    className="badge rounded-pill"
                    style={{
                      backgroundColor: uploadFile ? "#006f94" : "#6c757d",
                      color: "#fff",
                      fontSize: "11px",
                    }}
                  >
                    STEP 2
                  </span>
                  <h6
                    className="mb-0"
                    style={{
                      fontWeight: "700",
                      color: "#333",
                      fontSize: "15px",
                    }}
                  >
                    Supplementary Material{" "}
                    <span
                      className="text-muted fw-normal"
                      style={{ fontSize: "13px" }}
                    >
                      (Optional)
                    </span>
                  </h6>
                </div>
                {supplementaryList.length > 0 && (
                  <span
                    className="badge bg-info text-dark"
                    style={{ fontSize: "11px" }}
                  >
                    {supplementaryList.length}{" "}
                    {supplementaryList.length === 1 ? "File" : "Files"} Added
                  </span>
                )}
              </div>
              <p className="text-muted mb-3" style={{ fontSize: "12px" }}>
                Upload supplementary material (e.g. Datasets, Extended tables, or Multimedia files). Supports PDF, WORD, EXCEL, JPG/PNG files (.pdf, .doc, .docx, .xls, .xlsx, .jpg, .jpeg, .png).
              </p>

              {/* List of Uploaded Supplementary Files */}
              {supplementaryList.length > 0 && (
                <div className="d-flex flex-column gap-2 mb-3">
                  {supplementaryList.map((item) => (
                    <div
                      key={item.id}
                      className="p-2 border rounded-3 d-flex align-items-center justify-content-between gap-3"
                      style={{ backgroundColor: "#f9fbfd" }}
                    >
                      <div className="d-flex align-items-center gap-2 overflow-hidden flex-grow-1">
                        <span style={{ fontSize: "22px", flexShrink: 0 }}>
                          {item.file.name.match(/\.(xlsx?|csv)$/i)
                            ? "📊"
                            : item.file.name.match(/\.(jpe?g|png)$/i)
                            ? "🖼️"
                            : "📄"}
                        </span>
                        <div className="flex-grow-1 overflow-hidden">
                          <h6
                            className="mb-0 text-truncate"
                            style={{
                              fontWeight: "600",
                              color: "#333",
                              fontSize: "13px",
                            }}
                          >
                            {item.file.name}
                          </h6>
                          <span
                            className="text-muted"
                            style={{ fontSize: "11px" }}
                          >
                            {(item.file.size / (1024 * 1024) >= 1)
                              ? `${(item.file.size / (1024 * 1024)).toFixed(2)} MB`
                              : `${(item.file.size / 1024).toFixed(1)} KB`}{" "}
                            • Supplementary File
                          </span>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn border-0 p-1 ms-2"
                        style={{
                          background: "transparent",
                          color: "#dc3545",
                          fontSize: "18px",
                          fontWeight: "bold",
                          lineHeight: 1,
                          cursor: "pointer",
                          boxShadow: "none",
                        }}
                        onClick={() => handleRemoveSupplementaryFile(item.id)}
                        disabled={isUploadingArticle}
                        title="Remove file"
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              )}

              {/* Add Supplementary File Button */}
              <button
                type="button"
                className="btn btn-sm"
                disabled={!uploadFile || isUploadingArticle}
                onClick={() => {
                  if (supplementaryInputRef.current)
                    supplementaryInputRef.current.click();
                }}
                style={{
                  backgroundColor: "#006f94",
                  color: "#ffffff",
                  borderColor: "#006f94",
                  fontSize: "13px",
                  fontWeight: "600",
                  padding: "8px 20px",
                  borderRadius: "6px",
                  width: "auto",
                  minWidth: "fit-content",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  whiteSpace: "nowrap",
                }}
              >
                + Add Supplementary Material
              </button>
            </div>

            {/* Step 3: Upload Images / Figures (Vertical below Supplementary Material) */}
            <div
              className="p-3 border rounded-3"
              style={{
                backgroundColor: uploadFile ? "#ffffff" : "#f8f9fa",
                opacity: uploadFile ? 1 : 0.6,
                transition: "all 0.2s ease-in-out",
              }}
            >
              <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="d-flex align-items-center gap-2">
                  <span
                    className="badge rounded-pill"
                    style={{
                      backgroundColor: uploadFile ? "#006f94" : "#6c757d",
                      color: "#fff",
                      fontSize: "11px",
                    }}
                  >
                    STEP 3
                  </span>
                  <h6
                    className="mb-0"
                    style={{
                      fontWeight: "700",
                      color: "#333",
                      fontSize: "15px",
                    }}
                  >
                    Upload Figures / Images{" "}
                    <span
                      className="text-muted fw-normal"
                      style={{ fontSize: "13px" }}
                    >
                      (Optional)
                    </span>
                  </h6>
                </div>
                {imageList.length > 0 && (
                  <span
                    className="badge bg-info text-dark"
                    style={{ fontSize: "11px" }}
                  >
                    {imageList.length}{" "}
                    {imageList.length === 1 ? "Image" : "Images"} Added
                  </span>
                )}
              </div>
              <p className="text-muted mb-3" style={{ fontSize: "12px" }}>
                Upload figure images referenced in your manuscript and assign
                their figure labels (e.g. <code>Figure 1</code>,{" "}
                <code>Figure 2</code>).
              </p>

              {/* List of Uploaded Images */}
              {imageList.length > 0 && (
                <div className="d-flex flex-column gap-2 mb-3">
                  {imageList.map((item) => (
                    <div
                      key={item.id}
                      className="p-2 border rounded-3 d-flex align-items-center justify-content-between gap-3"
                      style={{ backgroundColor: "#f9fbfd" }}
                    >
                      <div className="d-flex align-items-center gap-2 overflow-hidden flex-grow-1">
                        <img
                          src={URL.createObjectURL(item.file)}
                          alt="preview"
                          style={{
                            width: "42px",
                            height: "42px",
                            objectFit: "cover",
                            borderRadius: "6px",
                            border: "1px solid #dee2e6",
                          }}
                        />
                        <div className="flex-grow-1 overflow-hidden">
                          <label
                            className="form-label mb-1 text-muted fw-bold"
                            style={{ fontSize: "11px" }}
                          >
                            Figure Title / Label (e.g. Figure 1, Figure 2)
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={item.title}
                            onChange={(e) =>
                              handleUpdateImageTitle(item.id, e.target.value)
                            }
                            placeholder="e.g. Figure 1 or Figure 2"
                            disabled={isUploadingArticle}
                            style={{ fontSize: "13px" }}
                          />
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn border-0 p-1 ms-2"
                        style={{
                          background: "transparent",
                          color: "#dc3545",
                          fontSize: "18px",
                          fontWeight: "bold",
                          lineHeight: 1,
                          cursor: "pointer",
                          boxShadow: "none",
                        }}
                        onClick={() => handleRemoveImage(item.id)}
                        disabled={isUploadingArticle}
                        title="Remove image"
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              )}

              {/* Add Image Button */}
              <button
                type="button"
                className="btn btn-sm"
                disabled={!uploadFile || isUploadingArticle}
                onClick={() => {
                  if (imageInputRef.current) imageInputRef.current.click();
                }}
                style={{
                  backgroundColor: "#006f94",
                  color: "#ffffff",
                  borderColor: "#006f94",
                  fontSize: "13px",
                  fontWeight: "600",
                  padding: "8px 20px",
                  borderRadius: "6px",
                  width: "auto",
                  minWidth: "fit-content",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  whiteSpace: "nowrap",
                }}
              >
                + Add Image / Figure
              </button>
            </div>
          </div>

          {/* Hidden File Inputs */}
          <input
            type="file"
            ref={supplementaryInputRef}
            style={{ display: "none" }}
            accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,image/jpeg,image/png"
            multiple
            onChange={handleAddSupplementaryFiles}
          />
          <input
            type="file"
            ref={imageInputRef}
            style={{ display: "none" }}
            accept="image/*"
            multiple
            onChange={handleAddImages}
          />
          <input
            type="file"
            ref={documentInputRef}
            style={{ display: "none" }}
            accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            onChange={(e) => {
              if (e.target.files && e.target.files[0]) {
                setUploadFile(e.target.files[0]);
                setUploadErrorMessage("");
              }
            }}
          />

          {/* Modal Footer Actions */}
          <div className="d-flex flex-column align-items-center justify-content-center gap-2 mt-4 pt-3 border-top">
            {uploadErrorMessage && (
              <div
                className="alert alert-danger d-flex align-items-center justify-content-between w-100 mb-3"
                role="alert"
                style={{
                  borderRadius: "8px",
                  fontSize: "13px",
                  backgroundColor: "#f8d7da",
                  borderColor: "#f5c6cb",
                  color: "#721c24",
                  padding: "10px 14px",
                  margin: "0",
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ flexShrink: 0 }}
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                  </svg>
                  <span>{uploadErrorMessage}</span>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px", boxShadow: "none" }}
                  onClick={() => setUploadErrorMessage("")}
                ></button>
              </div>
            )}
            {isUploadingArticle && (
              <div className="text-center w-100 mb-2">
                <span
                  style={{
                    color: "#dc3545",
                    fontWeight: "600",
                    fontSize: "14px",
                    display: "inline-block",
                  }}
                >
                  Evaluating article to determine if it meets our Article
                  Submission Guidelines. This could take up to 5 minutes. You
                  will be notified by email when this is completed
                </span>
              </div>
            )}
            <div className="d-flex align-items-center justify-content-center gap-3 w-100">
              <button
                type="button"
                className="btn btn-primary-custom"
                disabled={!uploadFile || isUploadingArticle}
                onClick={() => {
                  const isMega =
                    !isSocietyArticle() ||
                    preValues?.journalType === journalTypes.mega;
                  if (isMega && (!imageList || imageList.length === 0)) {
                    setShowNoFiguresModal(true);
                    return;
                  }
                  handleUploadArticleSubmit();
                }}
                style={{
                  padding: "12px 32px",
                  minWidth: "240px",
                  fontSize: "15px",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                  borderRadius: "8px",
                }}
              >
                {isUploadingArticle ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Processing...
                  </>
                ) : (
                  "Review Submission"
                )}
              </button>

              <button
                type="button"
                className="btn btn-outline-primary-custom"
                onClick={() => {
                  setShowUploadArticleModal(false);
                  setUploadErrorMessage("");
                  if (!isUploadingArticle) {
                    setUploadFile(null);
                    setImageList([]);
                    setSupplementaryList([]);
                  }
                }}
                style={{
                  padding: "12px 32px",
                  minWidth: "160px",
                  fontSize: "15px",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                  borderRadius: "8px",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Mega Journal Figures Verification Modal */}
      <Modal
        show={showNoFiguresModal}
        onHide={() => setShowNoFiguresModal(false)}
        centered
        backdrop="static"
        keyboard={false}
        className="figureNoticeModal"
        dialogClassName="figureNoticeModal"
        backdropClassName="figureNoticeModalBackdrop"
        style={{ zIndex: 1070 }}
      >
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            overflow: "hidden",
            position: "relative",
            padding: "32px 28px 26px",
          }}
        >
          <button
            type="button"
            className="btn-close"
            style={{
              position: "absolute",
              right: "20px",
              top: "20px",
              fontSize: "12px",
              cursor: "pointer",
              boxShadow: "none",
            }}
            onClick={() => setShowNoFiguresModal(false)}
          ></button>

          <div className="text-center">
            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "50%",
                backgroundColor: "#FFF4EB",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "16px",
              }}
            >
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ef5c23"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>

            <h4
              style={{
                color: "#004c6c",
                fontWeight: "700",
                fontSize: "20px",
                marginBottom: "12px",
                textTransform: "none",
                letterSpacing: "normal",
              }}
            >
              Notice: Figures / Images
            </h4>

            <p
              style={{
                fontSize: "15px",
                color: "#4b5563",
                lineHeight: "1.6",
                marginBottom: "28px",
                padding: "0 10px",
                textAlign: "center",
              }}
            >
              Does your document contain images? If yes, you need to upload them
              separately. Images embedded in the PDF file will not display in the
              published article.
            </p>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "14px",
                width: "100%",
              }}
            >
              <button
                type="button"
                className="btn-outline-modal-action"
                onClick={() => setShowNoFiguresModal(false)}
                style={{
                  flex: 1,
                  height: "44px",
                  borderRadius: "8px",
                  fontWeight: "600",
                  fontSize: "14px",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.2s ease",
                  padding: "0 16px",
                  minWidth: "0",
                }}
              >
                Upload Figures
              </button>
              <button
                type="button"
                className="btn-primary-modal-action"
                onClick={() => {
                  setShowNoFiguresModal(false);
                  handleUploadArticleSubmit();
                }}
                style={{
                  flex: 1,
                  height: "44px",
                  borderRadius: "8px",
                  fontWeight: "600",
                  fontSize: "14px",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.2s ease",
                  padding: "0 16px",
                  minWidth: "0",
                }}
              >
                No figures to Upload
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        show={showPreviouslySubmittedModal}
        onHide={() => setShowPreviouslySubmittedModal(false)}
        centered
        size="lg"
        className="previouslySubmittedModal"
      >
        <div
          className="modal-header border-0 pb-0 position-relative"
          style={{
            backgroundColor: "#ffffff",
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
            padding: "20px 20px 10px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className="d-flex align-items-center justify-content-center gap-2 w-100"
            style={{ textAlign: "center" }}
          >
            <div
              className="d-flex align-items-center justify-content-center rounded-circle"
              style={{
                width: "36px",
                height: "36px",
                backgroundColor: "#fee2e2",
                color: "#dc2626",
                flexShrink: 0,
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
                <line x1="12" y1="9" x2="12" y2="13" />
                <line x1="12" y1="17" x2="12.01" y2="17" />
              </svg>
            </div>
            <h4
              className="modal-title font-bold text-xl mb-0"
              style={{
                color: "#dc2626",
                fontWeight: "700",
                textAlign: "center",
                textTransform: "uppercase",
              }}
            >
              CAUTION!
            </h4>
          </div>
          <button
            type="button"
            className="btn-close position-absolute"
            style={{ right: "16px", top: "16px" }}
            onClick={() => setShowPreviouslySubmittedModal(false)}
          ></button>
        </div>
        <Modal.Body
          className="px-4 py-4 text-center"
          style={{
            backgroundColor: "#ffffff",
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
            textAlign: "center",
          }}
        >
          <p
            style={{
              color: "#7f1d1d",
              fontSize: "15px",
              lineHeight: "1.6",
              fontWeight: "500",
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            You have selected Yes as the answer to the question. If this is done
            in error please CANCEL to close this window, go back and correct
            your answer. If you have submitted to another journal then our
            policy forbids us from accepting your article directly. Please write
            to{" "}
            <a
              href="mailto:submissions@aakashgangaopen.in?subject=Manuscript%20Previously%20Submitted%20Inquiry"
              style={{
                color: "#dc2626",
                textDecoration: "underline",
                fontWeight: "600",
              }}
            >
              submissions@aakashgangaopen.in
            </a>{" "}
            and explain why you wish to submit the article to us when you have
            already submitted this elsewhere.
          </p>
          <div
            className="d-flex align-items-center justify-content-center gap-3 mt-4"
            style={{ width: "100%" }}
          >
            <button
              type="button"
              style={{
                backgroundColor: "#ffffff",
                color: "#374151",
                border: "1px solid #d1d5db",
                fontWeight: "600",
                padding: "10px 24px",
                borderRadius: "6px",
                whiteSpace: "nowrap",
                width: "auto",
                minWidth: "120px",
                maxWidth: "none",
                fontSize: "14px",
                boxSizing: "border-box",
                cursor: "pointer",
              }}
              onClick={() => setShowPreviouslySubmittedModal(false)}
            >
              CANCEL
            </button>
            <a
              href="mailto:submissions@aakashgangaopen.in?subject=Manuscript%20Previously%20Submitted%20Inquiry"
              style={{
                backgroundColor: "#dc2626",
                color: "#ffffff",
                border: "none",
                fontWeight: "600",
                padding: "10px 28px",
                borderRadius: "6px",
                textDecoration: "none",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                whiteSpace: "nowrap",
                width: "auto",
                minWidth: "180px",
                maxWidth: "none",
                fontSize: "14px",
                boxSizing: "border-box",
                cursor: "pointer",
              }}
              onClick={() => {
                setShowPreviouslySubmittedModal(false);
              }}
            >
              WRITE TO ADMIN
            </a>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showMegaGuidelineModal}
        onHide={() => setShowMegaGuidelineModal(false)}
        centered
        backdrop="static"
      >
        <div
          className="modal-header border-0 position-relative"
          style={{
            backgroundColor: "#ffffff",
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
            padding: "20px 24px 10px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <h5
            className="modal-title mb-0"
            style={{
              color: "#366c91",
              fontWeight: "700",
              fontSize: "18px",
            }}
          >
            Mega Journal Formatting Guidelines
          </h5>
          <button
            type="button"
            className="btn-close"
            style={{ cursor: "pointer" }}
            onClick={() => setShowMegaGuidelineModal(false)}
          ></button>
        </div>
        <Modal.Body
          className="px-4 py-3"
          style={{
            backgroundColor: "#ffffff",
            color: "#4b5563",
            fontSize: "15px",
            lineHeight: "1.6",
          }}
        >
          <p style={{ marginBottom: "20px", color: "#374151" }}>
            You have chosen to publish in one of our Mega Journal. You will now be directed to view the Formatting Guidelines that your article must follow. At the end of the page, you will have the option to Download a PDF of the Guidelines for your record. You need to confirm you have read and understood the formatting guidelines. Press the Continue button to complete the submission of your article.
          </p>
          <div
            className="d-flex align-items-center justify-content-center gap-3 mt-3 pt-3"
            style={{ width: "100%", borderTop: "1px solid #f0f0f0" }}
          >
            <button
              type="button"
              style={{
                backgroundColor: "#ffffff",
                color: "#4b5563",
                border: "1px solid #d1d5db",
                fontWeight: "600",
                padding: "8px 20px",
                borderRadius: "6px",
                fontSize: "14px",
                cursor: "pointer",
              }}
              onClick={() => setShowMegaGuidelineModal(false)}
            >
              Cancel
            </button>
            <button
              type="button"
              style={{
                backgroundColor: "#366c91",
                color: "#ffffff",
                border: "none",
                fontWeight: "600",
                padding: "8px 24px",
                borderRadius: "6px",
                fontSize: "14px",
                cursor: "pointer",
                boxShadow: "0 2px 6px rgba(54, 108, 145, 0.3)",
              }}
              onClick={() => {
                setShowMegaGuidelineModal(false);
                localStorage.removeItem("megaGuidelineAgreed");
                window.open("/mega-journal-formatting-guideline", "_blank");
              }}
            >
              Continue
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <OtherSubject
        showSubject={showSubject}
        setShowSubject={setShowSubject}
        props={handleOtherSubject}
        other={other}
        subjectId={preValues.subjectId}
        subjectType={"article"}
        setOther={setOther}
      />
    </div>
  );
};

export default mySubmission2;
